import Qt, { useState as vt, useRef as he, useCallback as ft, memo as fe, useEffect as Lt, useMemo as Pt, useContext as Ft, createContext as hr } from "react";
import { ItemsCart as Oe, Dropzone as me, FileItem as Ne, RemoveButton as Be, FormActionsContainer as fr, MediaViewer as Re, ShortListWrapper as mr, AuthorCellWithIcon as pr, DateCell as gr, ActionCell as _r, IconActionButton as vr, ListHeaderSecondary as br, SpinnerWidgetContainer as Ue, HomePageWidgetList as yr, HomePageWidgetListItem as Ee, ModuleDescriptionCard as wr, PageList as xr } from "@prometheus/features";
import { useNotifications as Wt, Button as bt, Icon as gt, Spinner as Zt, useTheme as pe, Grid as rt, Block as ge, Typography as xt, Input as ce, Tooltip as Jt, IconActionButton as Pe, Alert as Er, BasicPagination as kr, Skeleton as Ot, IconButton as Fe, Box as ke, NewTable as Sr, StatusTag as Se, EmptyTableStub as Cr } from "@prometheus/components";
import { useList as Kt, ModalContext as te, useRequest as Ar } from "@prometheus/hooks";
import { getUUID as Le, api as mt, getSortDirection as ee, createMethodApiCreateListConfig as We, getFileExtension as Ze, getFileIconName as re, formatBytes as _e, convertToDocumentAsset as ve, parseActions as be, getFileStatusColor as Ke, formatDate as Ir, DateFormat as jr, createSortingMethodListConfig as Tr, createFiltersPanelListConfig as Dr, createCrudMethodsListConfig as zr } from "@prometheus/utils";
import _t from "@emotion/styled";
import { TypesOfContainer as It } from "@prometheus/enums";
import { useDispatch as Mr, useSelector as Or } from "react-redux";
import { ListActions as Ge, EntityActions as Nr, Status as jt } from "@prometheus/types";
import { useNavigate as Ye, Routes as Br, Route as Ce } from "react-router-dom";
import { getSummary as Ae } from "@prometheus/redux";
import { useTheme as Rr } from "@emotion/react";
var pt = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Ur(T) {
  return T && T.__esModule && Object.prototype.hasOwnProperty.call(T, "default") ? T.default : T;
}
var de = { exports: {} }, Nt = {};
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ie;
function Pr() {
  if (Ie) return Nt;
  Ie = 1;
  var T = Symbol.for("react.transitional.element"), o = Symbol.for("react.fragment");
  function r(h, n, s) {
    var i = null;
    if (s !== void 0 && (i = "" + s), n.key !== void 0 && (i = "" + n.key), "key" in n) {
      s = {};
      for (var e in n)
        e !== "key" && (s[e] = n[e]);
    } else s = n;
    return n = s.ref, {
      $$typeof: T,
      type: h,
      key: i,
      ref: n !== void 0 ? n : null,
      props: s
    };
  }
  return Nt.Fragment = o, Nt.jsx = r, Nt.jsxs = r, Nt;
}
var Bt = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var je;
function Fr() {
  return je || (je = 1, process.env.NODE_ENV !== "production" && function() {
    function T(M) {
      if (M == null) return null;
      if (typeof M == "function")
        return M.$$typeof === W ? null : M.displayName || M.name || null;
      if (typeof M == "string") return M;
      switch (M) {
        case c:
          return "Fragment";
        case d:
          return "Profiler";
        case f:
          return "StrictMode";
        case S:
          return "Suspense";
        case P:
          return "SuspenseList";
        case D:
          return "Activity";
      }
      if (typeof M == "object")
        switch (typeof M.tag == "number" && console.error(
          "Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."
        ), M.$$typeof) {
          case m:
            return "Portal";
          case E:
            return (M.displayName || "Context") + ".Provider";
          case v:
            return (M._context.displayName || "Context") + ".Consumer";
          case C:
            var A = M.render;
            return M = M.displayName, M || (M = A.displayName || A.name || "", M = M !== "" ? "ForwardRef(" + M + ")" : "ForwardRef"), M;
          case R:
            return A = M.displayName || null, A !== null ? A : T(M.type) || "Memo";
          case N:
            A = M._payload, M = M._init;
            try {
              return T(M(A));
            } catch {
            }
        }
      return null;
    }
    function o(M) {
      return "" + M;
    }
    function r(M) {
      try {
        o(M);
        var A = !1;
      } catch {
        A = !0;
      }
      if (A) {
        A = console;
        var j = A.error, V = typeof Symbol == "function" && Symbol.toStringTag && M[Symbol.toStringTag] || M.constructor.name || "Object";
        return j.call(
          A,
          "The provided key is an unsupported type %s. This value must be coerced to a string before using it here.",
          V
        ), o(M);
      }
    }
    function h(M) {
      if (M === c) return "<>";
      if (typeof M == "object" && M !== null && M.$$typeof === N)
        return "<...>";
      try {
        var A = T(M);
        return A ? "<" + A + ">" : "<...>";
      } catch {
        return "<...>";
      }
    }
    function n() {
      var M = X.A;
      return M === null ? null : M.getOwner();
    }
    function s() {
      return Error("react-stack-top-frame");
    }
    function i(M) {
      if (w.call(M, "key")) {
        var A = Object.getOwnPropertyDescriptor(M, "key").get;
        if (A && A.isReactWarning) return !1;
      }
      return M.key !== void 0;
    }
    function e(M, A) {
      function j() {
        U || (U = !0, console.error(
          "%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://react.dev/link/special-props)",
          A
        ));
      }
      j.isReactWarning = !0, Object.defineProperty(M, "key", {
        get: j,
        configurable: !0
      });
    }
    function l() {
      var M = T(this.type);
      return Q[M] || (Q[M] = !0, console.error(
        "Accessing element.ref was removed in React 19. ref is now a regular prop. It will be removed from the JSX Element type in a future release."
      )), M = this.props.ref, M !== void 0 ? M : null;
    }
    function _(M, A, j, V, Y, $, lt, ht) {
      return j = $.ref, M = {
        $$typeof: u,
        type: M,
        key: A,
        props: $,
        _owner: Y
      }, (j !== void 0 ? j : null) !== null ? Object.defineProperty(M, "ref", {
        enumerable: !1,
        get: l
      }) : Object.defineProperty(M, "ref", { enumerable: !1, value: null }), M._store = {}, Object.defineProperty(M._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: 0
      }), Object.defineProperty(M, "_debugInfo", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: null
      }), Object.defineProperty(M, "_debugStack", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: lt
      }), Object.defineProperty(M, "_debugTask", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: ht
      }), Object.freeze && (Object.freeze(M.props), Object.freeze(M)), M;
    }
    function x(M, A, j, V, Y, $, lt, ht) {
      var et = A.children;
      if (et !== void 0)
        if (V)
          if (O(et)) {
            for (V = 0; V < et.length; V++)
              g(et[V]);
            Object.freeze && Object.freeze(et);
          } else
            console.error(
              "React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead."
            );
        else g(et);
      if (w.call(A, "key")) {
        et = T(M);
        var st = Object.keys(A).filter(function(ct) {
          return ct !== "key";
        });
        V = 0 < st.length ? "{key: someKey, " + st.join(": ..., ") + ": ...}" : "{key: someKey}", G[et + V] || (st = 0 < st.length ? "{" + st.join(": ..., ") + ": ...}" : "{}", console.error(
          `A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`,
          V,
          et,
          st,
          et
        ), G[et + V] = !0);
      }
      if (et = null, j !== void 0 && (r(j), et = "" + j), i(A) && (r(A.key), et = "" + A.key), "key" in A) {
        j = {};
        for (var ut in A)
          ut !== "key" && (j[ut] = A[ut]);
      } else j = A;
      return et && e(
        j,
        typeof M == "function" ? M.displayName || M.name || "Unknown" : M
      ), _(
        M,
        et,
        $,
        Y,
        n(),
        j,
        lt,
        ht
      );
    }
    function g(M) {
      typeof M == "object" && M !== null && M.$$typeof === u && M._store && (M._store.validated = 1);
    }
    var b = Qt, u = Symbol.for("react.transitional.element"), m = Symbol.for("react.portal"), c = Symbol.for("react.fragment"), f = Symbol.for("react.strict_mode"), d = Symbol.for("react.profiler"), v = Symbol.for("react.consumer"), E = Symbol.for("react.context"), C = Symbol.for("react.forward_ref"), S = Symbol.for("react.suspense"), P = Symbol.for("react.suspense_list"), R = Symbol.for("react.memo"), N = Symbol.for("react.lazy"), D = Symbol.for("react.activity"), W = Symbol.for("react.client.reference"), X = b.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, w = Object.prototype.hasOwnProperty, O = Array.isArray, a = console.createTask ? console.createTask : function() {
      return null;
    };
    b = {
      react_stack_bottom_frame: function(M) {
        return M();
      }
    };
    var U, Q = {}, L = b.react_stack_bottom_frame.bind(
      b,
      s
    )(), nt = a(h(s)), G = {};
    Bt.Fragment = c, Bt.jsx = function(M, A, j, V, Y) {
      var $ = 1e4 > X.recentlyCreatedOwnerStacks++;
      return x(
        M,
        A,
        j,
        !1,
        V,
        Y,
        $ ? Error("react-stack-top-frame") : L,
        $ ? a(h(M)) : nt
      );
    }, Bt.jsxs = function(M, A, j, V, Y) {
      var $ = 1e4 > X.recentlyCreatedOwnerStacks++;
      return x(
        M,
        A,
        j,
        !0,
        V,
        Y,
        $ ? Error("react-stack-top-frame") : L,
        $ ? a(h(M)) : nt
      );
    };
  }()), Bt;
}
process.env.NODE_ENV === "production" ? de.exports = Pr() : de.exports = Fr();
var k = de.exports;
function qt(T) {
  throw new Error('Could not dynamically require "' + T + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var $e = { exports: {} };
/*!

JSZip v3.10.1 - A JavaScript class for generating and reading zip files
<http://stuartk.com/jszip>

(c) 2009-2016 Stuart Knightley <stuart [at] stuartk.com>
Dual licenced under the MIT license or GPLv3. See https://raw.github.com/Stuk/jszip/main/LICENSE.markdown.

JSZip uses the library pako released under the MIT license :
https://github.com/nodeca/pako/blob/main/LICENSE
*/
(function(T, o) {
  (function(r) {
    T.exports = r();
  })(function() {
    return function r(h, n, s) {
      function i(_, x) {
        if (!n[_]) {
          if (!h[_]) {
            var g = typeof qt == "function" && qt;
            if (!x && g) return g(_, !0);
            if (e) return e(_, !0);
            var b = new Error("Cannot find module '" + _ + "'");
            throw b.code = "MODULE_NOT_FOUND", b;
          }
          var u = n[_] = { exports: {} };
          h[_][0].call(u.exports, function(m) {
            var c = h[_][1][m];
            return i(c || m);
          }, u, u.exports, r, h, n, s);
        }
        return n[_].exports;
      }
      for (var e = typeof qt == "function" && qt, l = 0; l < s.length; l++) i(s[l]);
      return i;
    }({ 1: [function(r, h, n) {
      var s = r("./utils"), i = r("./support"), e = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
      n.encode = function(l) {
        for (var _, x, g, b, u, m, c, f = [], d = 0, v = l.length, E = v, C = s.getTypeOf(l) !== "string"; d < l.length; ) E = v - d, g = C ? (_ = l[d++], x = d < v ? l[d++] : 0, d < v ? l[d++] : 0) : (_ = l.charCodeAt(d++), x = d < v ? l.charCodeAt(d++) : 0, d < v ? l.charCodeAt(d++) : 0), b = _ >> 2, u = (3 & _) << 4 | x >> 4, m = 1 < E ? (15 & x) << 2 | g >> 6 : 64, c = 2 < E ? 63 & g : 64, f.push(e.charAt(b) + e.charAt(u) + e.charAt(m) + e.charAt(c));
        return f.join("");
      }, n.decode = function(l) {
        var _, x, g, b, u, m, c = 0, f = 0, d = "data:";
        if (l.substr(0, d.length) === d) throw new Error("Invalid base64 input, it looks like a data url.");
        var v, E = 3 * (l = l.replace(/[^A-Za-z0-9+/=]/g, "")).length / 4;
        if (l.charAt(l.length - 1) === e.charAt(64) && E--, l.charAt(l.length - 2) === e.charAt(64) && E--, E % 1 != 0) throw new Error("Invalid base64 input, bad content length.");
        for (v = i.uint8array ? new Uint8Array(0 | E) : new Array(0 | E); c < l.length; ) _ = e.indexOf(l.charAt(c++)) << 2 | (b = e.indexOf(l.charAt(c++))) >> 4, x = (15 & b) << 4 | (u = e.indexOf(l.charAt(c++))) >> 2, g = (3 & u) << 6 | (m = e.indexOf(l.charAt(c++))), v[f++] = _, u !== 64 && (v[f++] = x), m !== 64 && (v[f++] = g);
        return v;
      };
    }, { "./support": 30, "./utils": 32 }], 2: [function(r, h, n) {
      var s = r("./external"), i = r("./stream/DataWorker"), e = r("./stream/Crc32Probe"), l = r("./stream/DataLengthProbe");
      function _(x, g, b, u, m) {
        this.compressedSize = x, this.uncompressedSize = g, this.crc32 = b, this.compression = u, this.compressedContent = m;
      }
      _.prototype = { getContentWorker: function() {
        var x = new i(s.Promise.resolve(this.compressedContent)).pipe(this.compression.uncompressWorker()).pipe(new l("data_length")), g = this;
        return x.on("end", function() {
          if (this.streamInfo.data_length !== g.uncompressedSize) throw new Error("Bug : uncompressed data size mismatch");
        }), x;
      }, getCompressedWorker: function() {
        return new i(s.Promise.resolve(this.compressedContent)).withStreamInfo("compressedSize", this.compressedSize).withStreamInfo("uncompressedSize", this.uncompressedSize).withStreamInfo("crc32", this.crc32).withStreamInfo("compression", this.compression);
      } }, _.createWorkerFrom = function(x, g, b) {
        return x.pipe(new e()).pipe(new l("uncompressedSize")).pipe(g.compressWorker(b)).pipe(new l("compressedSize")).withStreamInfo("compression", g);
      }, h.exports = _;
    }, { "./external": 6, "./stream/Crc32Probe": 25, "./stream/DataLengthProbe": 26, "./stream/DataWorker": 27 }], 3: [function(r, h, n) {
      var s = r("./stream/GenericWorker");
      n.STORE = { magic: "\0\0", compressWorker: function() {
        return new s("STORE compression");
      }, uncompressWorker: function() {
        return new s("STORE decompression");
      } }, n.DEFLATE = r("./flate");
    }, { "./flate": 7, "./stream/GenericWorker": 28 }], 4: [function(r, h, n) {
      var s = r("./utils"), i = function() {
        for (var e, l = [], _ = 0; _ < 256; _++) {
          e = _;
          for (var x = 0; x < 8; x++) e = 1 & e ? 3988292384 ^ e >>> 1 : e >>> 1;
          l[_] = e;
        }
        return l;
      }();
      h.exports = function(e, l) {
        return e !== void 0 && e.length ? s.getTypeOf(e) !== "string" ? function(_, x, g, b) {
          var u = i, m = b + g;
          _ ^= -1;
          for (var c = b; c < m; c++) _ = _ >>> 8 ^ u[255 & (_ ^ x[c])];
          return -1 ^ _;
        }(0 | l, e, e.length, 0) : function(_, x, g, b) {
          var u = i, m = b + g;
          _ ^= -1;
          for (var c = b; c < m; c++) _ = _ >>> 8 ^ u[255 & (_ ^ x.charCodeAt(c))];
          return -1 ^ _;
        }(0 | l, e, e.length, 0) : 0;
      };
    }, { "./utils": 32 }], 5: [function(r, h, n) {
      n.base64 = !1, n.binary = !1, n.dir = !1, n.createFolders = !0, n.date = null, n.compression = null, n.compressionOptions = null, n.comment = null, n.unixPermissions = null, n.dosPermissions = null;
    }, {}], 6: [function(r, h, n) {
      var s = null;
      s = typeof Promise < "u" ? Promise : r("lie"), h.exports = { Promise: s };
    }, { lie: 37 }], 7: [function(r, h, n) {
      var s = typeof Uint8Array < "u" && typeof Uint16Array < "u" && typeof Uint32Array < "u", i = r("pako"), e = r("./utils"), l = r("./stream/GenericWorker"), _ = s ? "uint8array" : "array";
      function x(g, b) {
        l.call(this, "FlateWorker/" + g), this._pako = null, this._pakoAction = g, this._pakoOptions = b, this.meta = {};
      }
      n.magic = "\b\0", e.inherits(x, l), x.prototype.processChunk = function(g) {
        this.meta = g.meta, this._pako === null && this._createPako(), this._pako.push(e.transformTo(_, g.data), !1);
      }, x.prototype.flush = function() {
        l.prototype.flush.call(this), this._pako === null && this._createPako(), this._pako.push([], !0);
      }, x.prototype.cleanUp = function() {
        l.prototype.cleanUp.call(this), this._pako = null;
      }, x.prototype._createPako = function() {
        this._pako = new i[this._pakoAction]({ raw: !0, level: this._pakoOptions.level || -1 });
        var g = this;
        this._pako.onData = function(b) {
          g.push({ data: b, meta: g.meta });
        };
      }, n.compressWorker = function(g) {
        return new x("Deflate", g);
      }, n.uncompressWorker = function() {
        return new x("Inflate", {});
      };
    }, { "./stream/GenericWorker": 28, "./utils": 32, pako: 38 }], 8: [function(r, h, n) {
      function s(u, m) {
        var c, f = "";
        for (c = 0; c < m; c++) f += String.fromCharCode(255 & u), u >>>= 8;
        return f;
      }
      function i(u, m, c, f, d, v) {
        var E, C, S = u.file, P = u.compression, R = v !== _.utf8encode, N = e.transformTo("string", v(S.name)), D = e.transformTo("string", _.utf8encode(S.name)), W = S.comment, X = e.transformTo("string", v(W)), w = e.transformTo("string", _.utf8encode(W)), O = D.length !== S.name.length, a = w.length !== W.length, U = "", Q = "", L = "", nt = S.dir, G = S.date, M = { crc32: 0, compressedSize: 0, uncompressedSize: 0 };
        m && !c || (M.crc32 = u.crc32, M.compressedSize = u.compressedSize, M.uncompressedSize = u.uncompressedSize);
        var A = 0;
        m && (A |= 8), R || !O && !a || (A |= 2048);
        var j = 0, V = 0;
        nt && (j |= 16), d === "UNIX" ? (V = 798, j |= function($, lt) {
          var ht = $;
          return $ || (ht = lt ? 16893 : 33204), (65535 & ht) << 16;
        }(S.unixPermissions, nt)) : (V = 20, j |= function($) {
          return 63 & ($ || 0);
        }(S.dosPermissions)), E = G.getUTCHours(), E <<= 6, E |= G.getUTCMinutes(), E <<= 5, E |= G.getUTCSeconds() / 2, C = G.getUTCFullYear() - 1980, C <<= 4, C |= G.getUTCMonth() + 1, C <<= 5, C |= G.getUTCDate(), O && (Q = s(1, 1) + s(x(N), 4) + D, U += "up" + s(Q.length, 2) + Q), a && (L = s(1, 1) + s(x(X), 4) + w, U += "uc" + s(L.length, 2) + L);
        var Y = "";
        return Y += `
\0`, Y += s(A, 2), Y += P.magic, Y += s(E, 2), Y += s(C, 2), Y += s(M.crc32, 4), Y += s(M.compressedSize, 4), Y += s(M.uncompressedSize, 4), Y += s(N.length, 2), Y += s(U.length, 2), { fileRecord: g.LOCAL_FILE_HEADER + Y + N + U, dirRecord: g.CENTRAL_FILE_HEADER + s(V, 2) + Y + s(X.length, 2) + "\0\0\0\0" + s(j, 4) + s(f, 4) + N + U + X };
      }
      var e = r("../utils"), l = r("../stream/GenericWorker"), _ = r("../utf8"), x = r("../crc32"), g = r("../signature");
      function b(u, m, c, f) {
        l.call(this, "ZipFileWorker"), this.bytesWritten = 0, this.zipComment = m, this.zipPlatform = c, this.encodeFileName = f, this.streamFiles = u, this.accumulate = !1, this.contentBuffer = [], this.dirRecords = [], this.currentSourceOffset = 0, this.entriesCount = 0, this.currentFile = null, this._sources = [];
      }
      e.inherits(b, l), b.prototype.push = function(u) {
        var m = u.meta.percent || 0, c = this.entriesCount, f = this._sources.length;
        this.accumulate ? this.contentBuffer.push(u) : (this.bytesWritten += u.data.length, l.prototype.push.call(this, { data: u.data, meta: { currentFile: this.currentFile, percent: c ? (m + 100 * (c - f - 1)) / c : 100 } }));
      }, b.prototype.openedSource = function(u) {
        this.currentSourceOffset = this.bytesWritten, this.currentFile = u.file.name;
        var m = this.streamFiles && !u.file.dir;
        if (m) {
          var c = i(u, m, !1, this.currentSourceOffset, this.zipPlatform, this.encodeFileName);
          this.push({ data: c.fileRecord, meta: { percent: 0 } });
        } else this.accumulate = !0;
      }, b.prototype.closedSource = function(u) {
        this.accumulate = !1;
        var m = this.streamFiles && !u.file.dir, c = i(u, m, !0, this.currentSourceOffset, this.zipPlatform, this.encodeFileName);
        if (this.dirRecords.push(c.dirRecord), m) this.push({ data: function(f) {
          return g.DATA_DESCRIPTOR + s(f.crc32, 4) + s(f.compressedSize, 4) + s(f.uncompressedSize, 4);
        }(u), meta: { percent: 100 } });
        else for (this.push({ data: c.fileRecord, meta: { percent: 0 } }); this.contentBuffer.length; ) this.push(this.contentBuffer.shift());
        this.currentFile = null;
      }, b.prototype.flush = function() {
        for (var u = this.bytesWritten, m = 0; m < this.dirRecords.length; m++) this.push({ data: this.dirRecords[m], meta: { percent: 100 } });
        var c = this.bytesWritten - u, f = function(d, v, E, C, S) {
          var P = e.transformTo("string", S(C));
          return g.CENTRAL_DIRECTORY_END + "\0\0\0\0" + s(d, 2) + s(d, 2) + s(v, 4) + s(E, 4) + s(P.length, 2) + P;
        }(this.dirRecords.length, c, u, this.zipComment, this.encodeFileName);
        this.push({ data: f, meta: { percent: 100 } });
      }, b.prototype.prepareNextSource = function() {
        this.previous = this._sources.shift(), this.openedSource(this.previous.streamInfo), this.isPaused ? this.previous.pause() : this.previous.resume();
      }, b.prototype.registerPrevious = function(u) {
        this._sources.push(u);
        var m = this;
        return u.on("data", function(c) {
          m.processChunk(c);
        }), u.on("end", function() {
          m.closedSource(m.previous.streamInfo), m._sources.length ? m.prepareNextSource() : m.end();
        }), u.on("error", function(c) {
          m.error(c);
        }), this;
      }, b.prototype.resume = function() {
        return !!l.prototype.resume.call(this) && (!this.previous && this._sources.length ? (this.prepareNextSource(), !0) : this.previous || this._sources.length || this.generatedError ? void 0 : (this.end(), !0));
      }, b.prototype.error = function(u) {
        var m = this._sources;
        if (!l.prototype.error.call(this, u)) return !1;
        for (var c = 0; c < m.length; c++) try {
          m[c].error(u);
        } catch {
        }
        return !0;
      }, b.prototype.lock = function() {
        l.prototype.lock.call(this);
        for (var u = this._sources, m = 0; m < u.length; m++) u[m].lock();
      }, h.exports = b;
    }, { "../crc32": 4, "../signature": 23, "../stream/GenericWorker": 28, "../utf8": 31, "../utils": 32 }], 9: [function(r, h, n) {
      var s = r("../compressions"), i = r("./ZipFileWorker");
      n.generateWorker = function(e, l, _) {
        var x = new i(l.streamFiles, _, l.platform, l.encodeFileName), g = 0;
        try {
          e.forEach(function(b, u) {
            g++;
            var m = function(v, E) {
              var C = v || E, S = s[C];
              if (!S) throw new Error(C + " is not a valid compression method !");
              return S;
            }(u.options.compression, l.compression), c = u.options.compressionOptions || l.compressionOptions || {}, f = u.dir, d = u.date;
            u._compressWorker(m, c).withStreamInfo("file", { name: b, dir: f, date: d, comment: u.comment || "", unixPermissions: u.unixPermissions, dosPermissions: u.dosPermissions }).pipe(x);
          }), x.entriesCount = g;
        } catch (b) {
          x.error(b);
        }
        return x;
      };
    }, { "../compressions": 3, "./ZipFileWorker": 8 }], 10: [function(r, h, n) {
      function s() {
        if (!(this instanceof s)) return new s();
        if (arguments.length) throw new Error("The constructor with parameters has been removed in JSZip 3.0, please check the upgrade guide.");
        this.files = /* @__PURE__ */ Object.create(null), this.comment = null, this.root = "", this.clone = function() {
          var i = new s();
          for (var e in this) typeof this[e] != "function" && (i[e] = this[e]);
          return i;
        };
      }
      (s.prototype = r("./object")).loadAsync = r("./load"), s.support = r("./support"), s.defaults = r("./defaults"), s.version = "3.10.1", s.loadAsync = function(i, e) {
        return new s().loadAsync(i, e);
      }, s.external = r("./external"), h.exports = s;
    }, { "./defaults": 5, "./external": 6, "./load": 11, "./object": 15, "./support": 30 }], 11: [function(r, h, n) {
      var s = r("./utils"), i = r("./external"), e = r("./utf8"), l = r("./zipEntries"), _ = r("./stream/Crc32Probe"), x = r("./nodejsUtils");
      function g(b) {
        return new i.Promise(function(u, m) {
          var c = b.decompressed.getContentWorker().pipe(new _());
          c.on("error", function(f) {
            m(f);
          }).on("end", function() {
            c.streamInfo.crc32 !== b.decompressed.crc32 ? m(new Error("Corrupted zip : CRC32 mismatch")) : u();
          }).resume();
        });
      }
      h.exports = function(b, u) {
        var m = this;
        return u = s.extend(u || {}, { base64: !1, checkCRC32: !1, optimizedBinaryString: !1, createFolders: !1, decodeFileName: e.utf8decode }), x.isNode && x.isStream(b) ? i.Promise.reject(new Error("JSZip can't accept a stream when loading a zip file.")) : s.prepareContent("the loaded zip file", b, !0, u.optimizedBinaryString, u.base64).then(function(c) {
          var f = new l(u);
          return f.load(c), f;
        }).then(function(c) {
          var f = [i.Promise.resolve(c)], d = c.files;
          if (u.checkCRC32) for (var v = 0; v < d.length; v++) f.push(g(d[v]));
          return i.Promise.all(f);
        }).then(function(c) {
          for (var f = c.shift(), d = f.files, v = 0; v < d.length; v++) {
            var E = d[v], C = E.fileNameStr, S = s.resolve(E.fileNameStr);
            m.file(S, E.decompressed, { binary: !0, optimizedBinaryString: !0, date: E.date, dir: E.dir, comment: E.fileCommentStr.length ? E.fileCommentStr : null, unixPermissions: E.unixPermissions, dosPermissions: E.dosPermissions, createFolders: u.createFolders }), E.dir || (m.file(S).unsafeOriginalName = C);
          }
          return f.zipComment.length && (m.comment = f.zipComment), m;
        });
      };
    }, { "./external": 6, "./nodejsUtils": 14, "./stream/Crc32Probe": 25, "./utf8": 31, "./utils": 32, "./zipEntries": 33 }], 12: [function(r, h, n) {
      var s = r("../utils"), i = r("../stream/GenericWorker");
      function e(l, _) {
        i.call(this, "Nodejs stream input adapter for " + l), this._upstreamEnded = !1, this._bindStream(_);
      }
      s.inherits(e, i), e.prototype._bindStream = function(l) {
        var _ = this;
        (this._stream = l).pause(), l.on("data", function(x) {
          _.push({ data: x, meta: { percent: 0 } });
        }).on("error", function(x) {
          _.isPaused ? this.generatedError = x : _.error(x);
        }).on("end", function() {
          _.isPaused ? _._upstreamEnded = !0 : _.end();
        });
      }, e.prototype.pause = function() {
        return !!i.prototype.pause.call(this) && (this._stream.pause(), !0);
      }, e.prototype.resume = function() {
        return !!i.prototype.resume.call(this) && (this._upstreamEnded ? this.end() : this._stream.resume(), !0);
      }, h.exports = e;
    }, { "../stream/GenericWorker": 28, "../utils": 32 }], 13: [function(r, h, n) {
      var s = r("readable-stream").Readable;
      function i(e, l, _) {
        s.call(this, l), this._helper = e;
        var x = this;
        e.on("data", function(g, b) {
          x.push(g) || x._helper.pause(), _ && _(b);
        }).on("error", function(g) {
          x.emit("error", g);
        }).on("end", function() {
          x.push(null);
        });
      }
      r("../utils").inherits(i, s), i.prototype._read = function() {
        this._helper.resume();
      }, h.exports = i;
    }, { "../utils": 32, "readable-stream": 16 }], 14: [function(r, h, n) {
      h.exports = { isNode: typeof Buffer < "u", newBufferFrom: function(s, i) {
        if (Buffer.from && Buffer.from !== Uint8Array.from) return Buffer.from(s, i);
        if (typeof s == "number") throw new Error('The "data" argument must not be a number');
        return new Buffer(s, i);
      }, allocBuffer: function(s) {
        if (Buffer.alloc) return Buffer.alloc(s);
        var i = new Buffer(s);
        return i.fill(0), i;
      }, isBuffer: function(s) {
        return Buffer.isBuffer(s);
      }, isStream: function(s) {
        return s && typeof s.on == "function" && typeof s.pause == "function" && typeof s.resume == "function";
      } };
    }, {}], 15: [function(r, h, n) {
      function s(S, P, R) {
        var N, D = e.getTypeOf(P), W = e.extend(R || {}, x);
        W.date = W.date || /* @__PURE__ */ new Date(), W.compression !== null && (W.compression = W.compression.toUpperCase()), typeof W.unixPermissions == "string" && (W.unixPermissions = parseInt(W.unixPermissions, 8)), W.unixPermissions && 16384 & W.unixPermissions && (W.dir = !0), W.dosPermissions && 16 & W.dosPermissions && (W.dir = !0), W.dir && (S = d(S)), W.createFolders && (N = f(S)) && v.call(this, N, !0);
        var X = D === "string" && W.binary === !1 && W.base64 === !1;
        R && R.binary !== void 0 || (W.binary = !X), (P instanceof g && P.uncompressedSize === 0 || W.dir || !P || P.length === 0) && (W.base64 = !1, W.binary = !0, P = "", W.compression = "STORE", D = "string");
        var w = null;
        w = P instanceof g || P instanceof l ? P : m.isNode && m.isStream(P) ? new c(S, P) : e.prepareContent(S, P, W.binary, W.optimizedBinaryString, W.base64);
        var O = new b(S, w, W);
        this.files[S] = O;
      }
      var i = r("./utf8"), e = r("./utils"), l = r("./stream/GenericWorker"), _ = r("./stream/StreamHelper"), x = r("./defaults"), g = r("./compressedObject"), b = r("./zipObject"), u = r("./generate"), m = r("./nodejsUtils"), c = r("./nodejs/NodejsStreamInputAdapter"), f = function(S) {
        S.slice(-1) === "/" && (S = S.substring(0, S.length - 1));
        var P = S.lastIndexOf("/");
        return 0 < P ? S.substring(0, P) : "";
      }, d = function(S) {
        return S.slice(-1) !== "/" && (S += "/"), S;
      }, v = function(S, P) {
        return P = P !== void 0 ? P : x.createFolders, S = d(S), this.files[S] || s.call(this, S, null, { dir: !0, createFolders: P }), this.files[S];
      };
      function E(S) {
        return Object.prototype.toString.call(S) === "[object RegExp]";
      }
      var C = { load: function() {
        throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
      }, forEach: function(S) {
        var P, R, N;
        for (P in this.files) N = this.files[P], (R = P.slice(this.root.length, P.length)) && P.slice(0, this.root.length) === this.root && S(R, N);
      }, filter: function(S) {
        var P = [];
        return this.forEach(function(R, N) {
          S(R, N) && P.push(N);
        }), P;
      }, file: function(S, P, R) {
        if (arguments.length !== 1) return S = this.root + S, s.call(this, S, P, R), this;
        if (E(S)) {
          var N = S;
          return this.filter(function(W, X) {
            return !X.dir && N.test(W);
          });
        }
        var D = this.files[this.root + S];
        return D && !D.dir ? D : null;
      }, folder: function(S) {
        if (!S) return this;
        if (E(S)) return this.filter(function(D, W) {
          return W.dir && S.test(D);
        });
        var P = this.root + S, R = v.call(this, P), N = this.clone();
        return N.root = R.name, N;
      }, remove: function(S) {
        S = this.root + S;
        var P = this.files[S];
        if (P || (S.slice(-1) !== "/" && (S += "/"), P = this.files[S]), P && !P.dir) delete this.files[S];
        else for (var R = this.filter(function(D, W) {
          return W.name.slice(0, S.length) === S;
        }), N = 0; N < R.length; N++) delete this.files[R[N].name];
        return this;
      }, generate: function() {
        throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
      }, generateInternalStream: function(S) {
        var P, R = {};
        try {
          if ((R = e.extend(S || {}, { streamFiles: !1, compression: "STORE", compressionOptions: null, type: "", platform: "DOS", comment: null, mimeType: "application/zip", encodeFileName: i.utf8encode })).type = R.type.toLowerCase(), R.compression = R.compression.toUpperCase(), R.type === "binarystring" && (R.type = "string"), !R.type) throw new Error("No output type specified.");
          e.checkSupport(R.type), R.platform !== "darwin" && R.platform !== "freebsd" && R.platform !== "linux" && R.platform !== "sunos" || (R.platform = "UNIX"), R.platform === "win32" && (R.platform = "DOS");
          var N = R.comment || this.comment || "";
          P = u.generateWorker(this, R, N);
        } catch (D) {
          (P = new l("error")).error(D);
        }
        return new _(P, R.type || "string", R.mimeType);
      }, generateAsync: function(S, P) {
        return this.generateInternalStream(S).accumulate(P);
      }, generateNodeStream: function(S, P) {
        return (S = S || {}).type || (S.type = "nodebuffer"), this.generateInternalStream(S).toNodejsStream(P);
      } };
      h.exports = C;
    }, { "./compressedObject": 2, "./defaults": 5, "./generate": 9, "./nodejs/NodejsStreamInputAdapter": 12, "./nodejsUtils": 14, "./stream/GenericWorker": 28, "./stream/StreamHelper": 29, "./utf8": 31, "./utils": 32, "./zipObject": 35 }], 16: [function(r, h, n) {
      h.exports = r("stream");
    }, { stream: void 0 }], 17: [function(r, h, n) {
      var s = r("./DataReader");
      function i(e) {
        s.call(this, e);
        for (var l = 0; l < this.data.length; l++) e[l] = 255 & e[l];
      }
      r("../utils").inherits(i, s), i.prototype.byteAt = function(e) {
        return this.data[this.zero + e];
      }, i.prototype.lastIndexOfSignature = function(e) {
        for (var l = e.charCodeAt(0), _ = e.charCodeAt(1), x = e.charCodeAt(2), g = e.charCodeAt(3), b = this.length - 4; 0 <= b; --b) if (this.data[b] === l && this.data[b + 1] === _ && this.data[b + 2] === x && this.data[b + 3] === g) return b - this.zero;
        return -1;
      }, i.prototype.readAndCheckSignature = function(e) {
        var l = e.charCodeAt(0), _ = e.charCodeAt(1), x = e.charCodeAt(2), g = e.charCodeAt(3), b = this.readData(4);
        return l === b[0] && _ === b[1] && x === b[2] && g === b[3];
      }, i.prototype.readData = function(e) {
        if (this.checkOffset(e), e === 0) return [];
        var l = this.data.slice(this.zero + this.index, this.zero + this.index + e);
        return this.index += e, l;
      }, h.exports = i;
    }, { "../utils": 32, "./DataReader": 18 }], 18: [function(r, h, n) {
      var s = r("../utils");
      function i(e) {
        this.data = e, this.length = e.length, this.index = 0, this.zero = 0;
      }
      i.prototype = { checkOffset: function(e) {
        this.checkIndex(this.index + e);
      }, checkIndex: function(e) {
        if (this.length < this.zero + e || e < 0) throw new Error("End of data reached (data length = " + this.length + ", asked index = " + e + "). Corrupted zip ?");
      }, setIndex: function(e) {
        this.checkIndex(e), this.index = e;
      }, skip: function(e) {
        this.setIndex(this.index + e);
      }, byteAt: function() {
      }, readInt: function(e) {
        var l, _ = 0;
        for (this.checkOffset(e), l = this.index + e - 1; l >= this.index; l--) _ = (_ << 8) + this.byteAt(l);
        return this.index += e, _;
      }, readString: function(e) {
        return s.transformTo("string", this.readData(e));
      }, readData: function() {
      }, lastIndexOfSignature: function() {
      }, readAndCheckSignature: function() {
      }, readDate: function() {
        var e = this.readInt(4);
        return new Date(Date.UTC(1980 + (e >> 25 & 127), (e >> 21 & 15) - 1, e >> 16 & 31, e >> 11 & 31, e >> 5 & 63, (31 & e) << 1));
      } }, h.exports = i;
    }, { "../utils": 32 }], 19: [function(r, h, n) {
      var s = r("./Uint8ArrayReader");
      function i(e) {
        s.call(this, e);
      }
      r("../utils").inherits(i, s), i.prototype.readData = function(e) {
        this.checkOffset(e);
        var l = this.data.slice(this.zero + this.index, this.zero + this.index + e);
        return this.index += e, l;
      }, h.exports = i;
    }, { "../utils": 32, "./Uint8ArrayReader": 21 }], 20: [function(r, h, n) {
      var s = r("./DataReader");
      function i(e) {
        s.call(this, e);
      }
      r("../utils").inherits(i, s), i.prototype.byteAt = function(e) {
        return this.data.charCodeAt(this.zero + e);
      }, i.prototype.lastIndexOfSignature = function(e) {
        return this.data.lastIndexOf(e) - this.zero;
      }, i.prototype.readAndCheckSignature = function(e) {
        return e === this.readData(4);
      }, i.prototype.readData = function(e) {
        this.checkOffset(e);
        var l = this.data.slice(this.zero + this.index, this.zero + this.index + e);
        return this.index += e, l;
      }, h.exports = i;
    }, { "../utils": 32, "./DataReader": 18 }], 21: [function(r, h, n) {
      var s = r("./ArrayReader");
      function i(e) {
        s.call(this, e);
      }
      r("../utils").inherits(i, s), i.prototype.readData = function(e) {
        if (this.checkOffset(e), e === 0) return new Uint8Array(0);
        var l = this.data.subarray(this.zero + this.index, this.zero + this.index + e);
        return this.index += e, l;
      }, h.exports = i;
    }, { "../utils": 32, "./ArrayReader": 17 }], 22: [function(r, h, n) {
      var s = r("../utils"), i = r("../support"), e = r("./ArrayReader"), l = r("./StringReader"), _ = r("./NodeBufferReader"), x = r("./Uint8ArrayReader");
      h.exports = function(g) {
        var b = s.getTypeOf(g);
        return s.checkSupport(b), b !== "string" || i.uint8array ? b === "nodebuffer" ? new _(g) : i.uint8array ? new x(s.transformTo("uint8array", g)) : new e(s.transformTo("array", g)) : new l(g);
      };
    }, { "../support": 30, "../utils": 32, "./ArrayReader": 17, "./NodeBufferReader": 19, "./StringReader": 20, "./Uint8ArrayReader": 21 }], 23: [function(r, h, n) {
      n.LOCAL_FILE_HEADER = "PK", n.CENTRAL_FILE_HEADER = "PK", n.CENTRAL_DIRECTORY_END = "PK", n.ZIP64_CENTRAL_DIRECTORY_LOCATOR = "PK\x07", n.ZIP64_CENTRAL_DIRECTORY_END = "PK", n.DATA_DESCRIPTOR = "PK\x07\b";
    }, {}], 24: [function(r, h, n) {
      var s = r("./GenericWorker"), i = r("../utils");
      function e(l) {
        s.call(this, "ConvertWorker to " + l), this.destType = l;
      }
      i.inherits(e, s), e.prototype.processChunk = function(l) {
        this.push({ data: i.transformTo(this.destType, l.data), meta: l.meta });
      }, h.exports = e;
    }, { "../utils": 32, "./GenericWorker": 28 }], 25: [function(r, h, n) {
      var s = r("./GenericWorker"), i = r("../crc32");
      function e() {
        s.call(this, "Crc32Probe"), this.withStreamInfo("crc32", 0);
      }
      r("../utils").inherits(e, s), e.prototype.processChunk = function(l) {
        this.streamInfo.crc32 = i(l.data, this.streamInfo.crc32 || 0), this.push(l);
      }, h.exports = e;
    }, { "../crc32": 4, "../utils": 32, "./GenericWorker": 28 }], 26: [function(r, h, n) {
      var s = r("../utils"), i = r("./GenericWorker");
      function e(l) {
        i.call(this, "DataLengthProbe for " + l), this.propName = l, this.withStreamInfo(l, 0);
      }
      s.inherits(e, i), e.prototype.processChunk = function(l) {
        if (l) {
          var _ = this.streamInfo[this.propName] || 0;
          this.streamInfo[this.propName] = _ + l.data.length;
        }
        i.prototype.processChunk.call(this, l);
      }, h.exports = e;
    }, { "../utils": 32, "./GenericWorker": 28 }], 27: [function(r, h, n) {
      var s = r("../utils"), i = r("./GenericWorker");
      function e(l) {
        i.call(this, "DataWorker");
        var _ = this;
        this.dataIsReady = !1, this.index = 0, this.max = 0, this.data = null, this.type = "", this._tickScheduled = !1, l.then(function(x) {
          _.dataIsReady = !0, _.data = x, _.max = x && x.length || 0, _.type = s.getTypeOf(x), _.isPaused || _._tickAndRepeat();
        }, function(x) {
          _.error(x);
        });
      }
      s.inherits(e, i), e.prototype.cleanUp = function() {
        i.prototype.cleanUp.call(this), this.data = null;
      }, e.prototype.resume = function() {
        return !!i.prototype.resume.call(this) && (!this._tickScheduled && this.dataIsReady && (this._tickScheduled = !0, s.delay(this._tickAndRepeat, [], this)), !0);
      }, e.prototype._tickAndRepeat = function() {
        this._tickScheduled = !1, this.isPaused || this.isFinished || (this._tick(), this.isFinished || (s.delay(this._tickAndRepeat, [], this), this._tickScheduled = !0));
      }, e.prototype._tick = function() {
        if (this.isPaused || this.isFinished) return !1;
        var l = null, _ = Math.min(this.max, this.index + 16384);
        if (this.index >= this.max) return this.end();
        switch (this.type) {
          case "string":
            l = this.data.substring(this.index, _);
            break;
          case "uint8array":
            l = this.data.subarray(this.index, _);
            break;
          case "array":
          case "nodebuffer":
            l = this.data.slice(this.index, _);
        }
        return this.index = _, this.push({ data: l, meta: { percent: this.max ? this.index / this.max * 100 : 0 } });
      }, h.exports = e;
    }, { "../utils": 32, "./GenericWorker": 28 }], 28: [function(r, h, n) {
      function s(i) {
        this.name = i || "default", this.streamInfo = {}, this.generatedError = null, this.extraStreamInfo = {}, this.isPaused = !0, this.isFinished = !1, this.isLocked = !1, this._listeners = { data: [], end: [], error: [] }, this.previous = null;
      }
      s.prototype = { push: function(i) {
        this.emit("data", i);
      }, end: function() {
        if (this.isFinished) return !1;
        this.flush();
        try {
          this.emit("end"), this.cleanUp(), this.isFinished = !0;
        } catch (i) {
          this.emit("error", i);
        }
        return !0;
      }, error: function(i) {
        return !this.isFinished && (this.isPaused ? this.generatedError = i : (this.isFinished = !0, this.emit("error", i), this.previous && this.previous.error(i), this.cleanUp()), !0);
      }, on: function(i, e) {
        return this._listeners[i].push(e), this;
      }, cleanUp: function() {
        this.streamInfo = this.generatedError = this.extraStreamInfo = null, this._listeners = [];
      }, emit: function(i, e) {
        if (this._listeners[i]) for (var l = 0; l < this._listeners[i].length; l++) this._listeners[i][l].call(this, e);
      }, pipe: function(i) {
        return i.registerPrevious(this);
      }, registerPrevious: function(i) {
        if (this.isLocked) throw new Error("The stream '" + this + "' has already been used.");
        this.streamInfo = i.streamInfo, this.mergeStreamInfo(), this.previous = i;
        var e = this;
        return i.on("data", function(l) {
          e.processChunk(l);
        }), i.on("end", function() {
          e.end();
        }), i.on("error", function(l) {
          e.error(l);
        }), this;
      }, pause: function() {
        return !this.isPaused && !this.isFinished && (this.isPaused = !0, this.previous && this.previous.pause(), !0);
      }, resume: function() {
        if (!this.isPaused || this.isFinished) return !1;
        var i = this.isPaused = !1;
        return this.generatedError && (this.error(this.generatedError), i = !0), this.previous && this.previous.resume(), !i;
      }, flush: function() {
      }, processChunk: function(i) {
        this.push(i);
      }, withStreamInfo: function(i, e) {
        return this.extraStreamInfo[i] = e, this.mergeStreamInfo(), this;
      }, mergeStreamInfo: function() {
        for (var i in this.extraStreamInfo) Object.prototype.hasOwnProperty.call(this.extraStreamInfo, i) && (this.streamInfo[i] = this.extraStreamInfo[i]);
      }, lock: function() {
        if (this.isLocked) throw new Error("The stream '" + this + "' has already been used.");
        this.isLocked = !0, this.previous && this.previous.lock();
      }, toString: function() {
        var i = "Worker " + this.name;
        return this.previous ? this.previous + " -> " + i : i;
      } }, h.exports = s;
    }, {}], 29: [function(r, h, n) {
      var s = r("../utils"), i = r("./ConvertWorker"), e = r("./GenericWorker"), l = r("../base64"), _ = r("../support"), x = r("../external"), g = null;
      if (_.nodestream) try {
        g = r("../nodejs/NodejsStreamOutputAdapter");
      } catch {
      }
      function b(m, c) {
        return new x.Promise(function(f, d) {
          var v = [], E = m._internalType, C = m._outputType, S = m._mimeType;
          m.on("data", function(P, R) {
            v.push(P), c && c(R);
          }).on("error", function(P) {
            v = [], d(P);
          }).on("end", function() {
            try {
              var P = function(R, N, D) {
                switch (R) {
                  case "blob":
                    return s.newBlob(s.transformTo("arraybuffer", N), D);
                  case "base64":
                    return l.encode(N);
                  default:
                    return s.transformTo(R, N);
                }
              }(C, function(R, N) {
                var D, W = 0, X = null, w = 0;
                for (D = 0; D < N.length; D++) w += N[D].length;
                switch (R) {
                  case "string":
                    return N.join("");
                  case "array":
                    return Array.prototype.concat.apply([], N);
                  case "uint8array":
                    for (X = new Uint8Array(w), D = 0; D < N.length; D++) X.set(N[D], W), W += N[D].length;
                    return X;
                  case "nodebuffer":
                    return Buffer.concat(N);
                  default:
                    throw new Error("concat : unsupported type '" + R + "'");
                }
              }(E, v), S);
              f(P);
            } catch (R) {
              d(R);
            }
            v = [];
          }).resume();
        });
      }
      function u(m, c, f) {
        var d = c;
        switch (c) {
          case "blob":
          case "arraybuffer":
            d = "uint8array";
            break;
          case "base64":
            d = "string";
        }
        try {
          this._internalType = d, this._outputType = c, this._mimeType = f, s.checkSupport(d), this._worker = m.pipe(new i(d)), m.lock();
        } catch (v) {
          this._worker = new e("error"), this._worker.error(v);
        }
      }
      u.prototype = { accumulate: function(m) {
        return b(this, m);
      }, on: function(m, c) {
        var f = this;
        return m === "data" ? this._worker.on(m, function(d) {
          c.call(f, d.data, d.meta);
        }) : this._worker.on(m, function() {
          s.delay(c, arguments, f);
        }), this;
      }, resume: function() {
        return s.delay(this._worker.resume, [], this._worker), this;
      }, pause: function() {
        return this._worker.pause(), this;
      }, toNodejsStream: function(m) {
        if (s.checkSupport("nodestream"), this._outputType !== "nodebuffer") throw new Error(this._outputType + " is not supported by this method");
        return new g(this, { objectMode: this._outputType !== "nodebuffer" }, m);
      } }, h.exports = u;
    }, { "../base64": 1, "../external": 6, "../nodejs/NodejsStreamOutputAdapter": 13, "../support": 30, "../utils": 32, "./ConvertWorker": 24, "./GenericWorker": 28 }], 30: [function(r, h, n) {
      if (n.base64 = !0, n.array = !0, n.string = !0, n.arraybuffer = typeof ArrayBuffer < "u" && typeof Uint8Array < "u", n.nodebuffer = typeof Buffer < "u", n.uint8array = typeof Uint8Array < "u", typeof ArrayBuffer > "u") n.blob = !1;
      else {
        var s = new ArrayBuffer(0);
        try {
          n.blob = new Blob([s], { type: "application/zip" }).size === 0;
        } catch {
          try {
            var i = new (self.BlobBuilder || self.WebKitBlobBuilder || self.MozBlobBuilder || self.MSBlobBuilder)();
            i.append(s), n.blob = i.getBlob("application/zip").size === 0;
          } catch {
            n.blob = !1;
          }
        }
      }
      try {
        n.nodestream = !!r("readable-stream").Readable;
      } catch {
        n.nodestream = !1;
      }
    }, { "readable-stream": 16 }], 31: [function(r, h, n) {
      for (var s = r("./utils"), i = r("./support"), e = r("./nodejsUtils"), l = r("./stream/GenericWorker"), _ = new Array(256), x = 0; x < 256; x++) _[x] = 252 <= x ? 6 : 248 <= x ? 5 : 240 <= x ? 4 : 224 <= x ? 3 : 192 <= x ? 2 : 1;
      _[254] = _[254] = 1;
      function g() {
        l.call(this, "utf-8 decode"), this.leftOver = null;
      }
      function b() {
        l.call(this, "utf-8 encode");
      }
      n.utf8encode = function(u) {
        return i.nodebuffer ? e.newBufferFrom(u, "utf-8") : function(m) {
          var c, f, d, v, E, C = m.length, S = 0;
          for (v = 0; v < C; v++) (64512 & (f = m.charCodeAt(v))) == 55296 && v + 1 < C && (64512 & (d = m.charCodeAt(v + 1))) == 56320 && (f = 65536 + (f - 55296 << 10) + (d - 56320), v++), S += f < 128 ? 1 : f < 2048 ? 2 : f < 65536 ? 3 : 4;
          for (c = i.uint8array ? new Uint8Array(S) : new Array(S), v = E = 0; E < S; v++) (64512 & (f = m.charCodeAt(v))) == 55296 && v + 1 < C && (64512 & (d = m.charCodeAt(v + 1))) == 56320 && (f = 65536 + (f - 55296 << 10) + (d - 56320), v++), f < 128 ? c[E++] = f : (f < 2048 ? c[E++] = 192 | f >>> 6 : (f < 65536 ? c[E++] = 224 | f >>> 12 : (c[E++] = 240 | f >>> 18, c[E++] = 128 | f >>> 12 & 63), c[E++] = 128 | f >>> 6 & 63), c[E++] = 128 | 63 & f);
          return c;
        }(u);
      }, n.utf8decode = function(u) {
        return i.nodebuffer ? s.transformTo("nodebuffer", u).toString("utf-8") : function(m) {
          var c, f, d, v, E = m.length, C = new Array(2 * E);
          for (c = f = 0; c < E; ) if ((d = m[c++]) < 128) C[f++] = d;
          else if (4 < (v = _[d])) C[f++] = 65533, c += v - 1;
          else {
            for (d &= v === 2 ? 31 : v === 3 ? 15 : 7; 1 < v && c < E; ) d = d << 6 | 63 & m[c++], v--;
            1 < v ? C[f++] = 65533 : d < 65536 ? C[f++] = d : (d -= 65536, C[f++] = 55296 | d >> 10 & 1023, C[f++] = 56320 | 1023 & d);
          }
          return C.length !== f && (C.subarray ? C = C.subarray(0, f) : C.length = f), s.applyFromCharCode(C);
        }(u = s.transformTo(i.uint8array ? "uint8array" : "array", u));
      }, s.inherits(g, l), g.prototype.processChunk = function(u) {
        var m = s.transformTo(i.uint8array ? "uint8array" : "array", u.data);
        if (this.leftOver && this.leftOver.length) {
          if (i.uint8array) {
            var c = m;
            (m = new Uint8Array(c.length + this.leftOver.length)).set(this.leftOver, 0), m.set(c, this.leftOver.length);
          } else m = this.leftOver.concat(m);
          this.leftOver = null;
        }
        var f = function(v, E) {
          var C;
          for ((E = E || v.length) > v.length && (E = v.length), C = E - 1; 0 <= C && (192 & v[C]) == 128; ) C--;
          return C < 0 || C === 0 ? E : C + _[v[C]] > E ? C : E;
        }(m), d = m;
        f !== m.length && (i.uint8array ? (d = m.subarray(0, f), this.leftOver = m.subarray(f, m.length)) : (d = m.slice(0, f), this.leftOver = m.slice(f, m.length))), this.push({ data: n.utf8decode(d), meta: u.meta });
      }, g.prototype.flush = function() {
        this.leftOver && this.leftOver.length && (this.push({ data: n.utf8decode(this.leftOver), meta: {} }), this.leftOver = null);
      }, n.Utf8DecodeWorker = g, s.inherits(b, l), b.prototype.processChunk = function(u) {
        this.push({ data: n.utf8encode(u.data), meta: u.meta });
      }, n.Utf8EncodeWorker = b;
    }, { "./nodejsUtils": 14, "./stream/GenericWorker": 28, "./support": 30, "./utils": 32 }], 32: [function(r, h, n) {
      var s = r("./support"), i = r("./base64"), e = r("./nodejsUtils"), l = r("./external");
      function _(c) {
        return c;
      }
      function x(c, f) {
        for (var d = 0; d < c.length; ++d) f[d] = 255 & c.charCodeAt(d);
        return f;
      }
      r("setimmediate"), n.newBlob = function(c, f) {
        n.checkSupport("blob");
        try {
          return new Blob([c], { type: f });
        } catch {
          try {
            var d = new (self.BlobBuilder || self.WebKitBlobBuilder || self.MozBlobBuilder || self.MSBlobBuilder)();
            return d.append(c), d.getBlob(f);
          } catch {
            throw new Error("Bug : can't construct the Blob.");
          }
        }
      };
      var g = { stringifyByChunk: function(c, f, d) {
        var v = [], E = 0, C = c.length;
        if (C <= d) return String.fromCharCode.apply(null, c);
        for (; E < C; ) f === "array" || f === "nodebuffer" ? v.push(String.fromCharCode.apply(null, c.slice(E, Math.min(E + d, C)))) : v.push(String.fromCharCode.apply(null, c.subarray(E, Math.min(E + d, C)))), E += d;
        return v.join("");
      }, stringifyByChar: function(c) {
        for (var f = "", d = 0; d < c.length; d++) f += String.fromCharCode(c[d]);
        return f;
      }, applyCanBeUsed: { uint8array: function() {
        try {
          return s.uint8array && String.fromCharCode.apply(null, new Uint8Array(1)).length === 1;
        } catch {
          return !1;
        }
      }(), nodebuffer: function() {
        try {
          return s.nodebuffer && String.fromCharCode.apply(null, e.allocBuffer(1)).length === 1;
        } catch {
          return !1;
        }
      }() } };
      function b(c) {
        var f = 65536, d = n.getTypeOf(c), v = !0;
        if (d === "uint8array" ? v = g.applyCanBeUsed.uint8array : d === "nodebuffer" && (v = g.applyCanBeUsed.nodebuffer), v) for (; 1 < f; ) try {
          return g.stringifyByChunk(c, d, f);
        } catch {
          f = Math.floor(f / 2);
        }
        return g.stringifyByChar(c);
      }
      function u(c, f) {
        for (var d = 0; d < c.length; d++) f[d] = c[d];
        return f;
      }
      n.applyFromCharCode = b;
      var m = {};
      m.string = { string: _, array: function(c) {
        return x(c, new Array(c.length));
      }, arraybuffer: function(c) {
        return m.string.uint8array(c).buffer;
      }, uint8array: function(c) {
        return x(c, new Uint8Array(c.length));
      }, nodebuffer: function(c) {
        return x(c, e.allocBuffer(c.length));
      } }, m.array = { string: b, array: _, arraybuffer: function(c) {
        return new Uint8Array(c).buffer;
      }, uint8array: function(c) {
        return new Uint8Array(c);
      }, nodebuffer: function(c) {
        return e.newBufferFrom(c);
      } }, m.arraybuffer = { string: function(c) {
        return b(new Uint8Array(c));
      }, array: function(c) {
        return u(new Uint8Array(c), new Array(c.byteLength));
      }, arraybuffer: _, uint8array: function(c) {
        return new Uint8Array(c);
      }, nodebuffer: function(c) {
        return e.newBufferFrom(new Uint8Array(c));
      } }, m.uint8array = { string: b, array: function(c) {
        return u(c, new Array(c.length));
      }, arraybuffer: function(c) {
        return c.buffer;
      }, uint8array: _, nodebuffer: function(c) {
        return e.newBufferFrom(c);
      } }, m.nodebuffer = { string: b, array: function(c) {
        return u(c, new Array(c.length));
      }, arraybuffer: function(c) {
        return m.nodebuffer.uint8array(c).buffer;
      }, uint8array: function(c) {
        return u(c, new Uint8Array(c.length));
      }, nodebuffer: _ }, n.transformTo = function(c, f) {
        if (f = f || "", !c) return f;
        n.checkSupport(c);
        var d = n.getTypeOf(f);
        return m[d][c](f);
      }, n.resolve = function(c) {
        for (var f = c.split("/"), d = [], v = 0; v < f.length; v++) {
          var E = f[v];
          E === "." || E === "" && v !== 0 && v !== f.length - 1 || (E === ".." ? d.pop() : d.push(E));
        }
        return d.join("/");
      }, n.getTypeOf = function(c) {
        return typeof c == "string" ? "string" : Object.prototype.toString.call(c) === "[object Array]" ? "array" : s.nodebuffer && e.isBuffer(c) ? "nodebuffer" : s.uint8array && c instanceof Uint8Array ? "uint8array" : s.arraybuffer && c instanceof ArrayBuffer ? "arraybuffer" : void 0;
      }, n.checkSupport = function(c) {
        if (!s[c.toLowerCase()]) throw new Error(c + " is not supported by this platform");
      }, n.MAX_VALUE_16BITS = 65535, n.MAX_VALUE_32BITS = -1, n.pretty = function(c) {
        var f, d, v = "";
        for (d = 0; d < (c || "").length; d++) v += "\\x" + ((f = c.charCodeAt(d)) < 16 ? "0" : "") + f.toString(16).toUpperCase();
        return v;
      }, n.delay = function(c, f, d) {
        setImmediate(function() {
          c.apply(d || null, f || []);
        });
      }, n.inherits = function(c, f) {
        function d() {
        }
        d.prototype = f.prototype, c.prototype = new d();
      }, n.extend = function() {
        var c, f, d = {};
        for (c = 0; c < arguments.length; c++) for (f in arguments[c]) Object.prototype.hasOwnProperty.call(arguments[c], f) && d[f] === void 0 && (d[f] = arguments[c][f]);
        return d;
      }, n.prepareContent = function(c, f, d, v, E) {
        return l.Promise.resolve(f).then(function(C) {
          return s.blob && (C instanceof Blob || ["[object File]", "[object Blob]"].indexOf(Object.prototype.toString.call(C)) !== -1) && typeof FileReader < "u" ? new l.Promise(function(S, P) {
            var R = new FileReader();
            R.onload = function(N) {
              S(N.target.result);
            }, R.onerror = function(N) {
              P(N.target.error);
            }, R.readAsArrayBuffer(C);
          }) : C;
        }).then(function(C) {
          var S = n.getTypeOf(C);
          return S ? (S === "arraybuffer" ? C = n.transformTo("uint8array", C) : S === "string" && (E ? C = i.decode(C) : d && v !== !0 && (C = function(P) {
            return x(P, s.uint8array ? new Uint8Array(P.length) : new Array(P.length));
          }(C))), C) : l.Promise.reject(new Error("Can't read the data of '" + c + "'. Is it in a supported JavaScript type (String, Blob, ArrayBuffer, etc) ?"));
        });
      };
    }, { "./base64": 1, "./external": 6, "./nodejsUtils": 14, "./support": 30, setimmediate: 54 }], 33: [function(r, h, n) {
      var s = r("./reader/readerFor"), i = r("./utils"), e = r("./signature"), l = r("./zipEntry"), _ = r("./support");
      function x(g) {
        this.files = [], this.loadOptions = g;
      }
      x.prototype = { checkSignature: function(g) {
        if (!this.reader.readAndCheckSignature(g)) {
          this.reader.index -= 4;
          var b = this.reader.readString(4);
          throw new Error("Corrupted zip or bug: unexpected signature (" + i.pretty(b) + ", expected " + i.pretty(g) + ")");
        }
      }, isSignature: function(g, b) {
        var u = this.reader.index;
        this.reader.setIndex(g);
        var m = this.reader.readString(4) === b;
        return this.reader.setIndex(u), m;
      }, readBlockEndOfCentral: function() {
        this.diskNumber = this.reader.readInt(2), this.diskWithCentralDirStart = this.reader.readInt(2), this.centralDirRecordsOnThisDisk = this.reader.readInt(2), this.centralDirRecords = this.reader.readInt(2), this.centralDirSize = this.reader.readInt(4), this.centralDirOffset = this.reader.readInt(4), this.zipCommentLength = this.reader.readInt(2);
        var g = this.reader.readData(this.zipCommentLength), b = _.uint8array ? "uint8array" : "array", u = i.transformTo(b, g);
        this.zipComment = this.loadOptions.decodeFileName(u);
      }, readBlockZip64EndOfCentral: function() {
        this.zip64EndOfCentralSize = this.reader.readInt(8), this.reader.skip(4), this.diskNumber = this.reader.readInt(4), this.diskWithCentralDirStart = this.reader.readInt(4), this.centralDirRecordsOnThisDisk = this.reader.readInt(8), this.centralDirRecords = this.reader.readInt(8), this.centralDirSize = this.reader.readInt(8), this.centralDirOffset = this.reader.readInt(8), this.zip64ExtensibleData = {};
        for (var g, b, u, m = this.zip64EndOfCentralSize - 44; 0 < m; ) g = this.reader.readInt(2), b = this.reader.readInt(4), u = this.reader.readData(b), this.zip64ExtensibleData[g] = { id: g, length: b, value: u };
      }, readBlockZip64EndOfCentralLocator: function() {
        if (this.diskWithZip64CentralDirStart = this.reader.readInt(4), this.relativeOffsetEndOfZip64CentralDir = this.reader.readInt(8), this.disksCount = this.reader.readInt(4), 1 < this.disksCount) throw new Error("Multi-volumes zip are not supported");
      }, readLocalFiles: function() {
        var g, b;
        for (g = 0; g < this.files.length; g++) b = this.files[g], this.reader.setIndex(b.localHeaderOffset), this.checkSignature(e.LOCAL_FILE_HEADER), b.readLocalPart(this.reader), b.handleUTF8(), b.processAttributes();
      }, readCentralDir: function() {
        var g;
        for (this.reader.setIndex(this.centralDirOffset); this.reader.readAndCheckSignature(e.CENTRAL_FILE_HEADER); ) (g = new l({ zip64: this.zip64 }, this.loadOptions)).readCentralPart(this.reader), this.files.push(g);
        if (this.centralDirRecords !== this.files.length && this.centralDirRecords !== 0 && this.files.length === 0) throw new Error("Corrupted zip or bug: expected " + this.centralDirRecords + " records in central dir, got " + this.files.length);
      }, readEndOfCentral: function() {
        var g = this.reader.lastIndexOfSignature(e.CENTRAL_DIRECTORY_END);
        if (g < 0) throw this.isSignature(0, e.LOCAL_FILE_HEADER) ? new Error("Corrupted zip: can't find end of central directory") : new Error("Can't find end of central directory : is this a zip file ? If it is, see https://stuk.github.io/jszip/documentation/howto/read_zip.html");
        this.reader.setIndex(g);
        var b = g;
        if (this.checkSignature(e.CENTRAL_DIRECTORY_END), this.readBlockEndOfCentral(), this.diskNumber === i.MAX_VALUE_16BITS || this.diskWithCentralDirStart === i.MAX_VALUE_16BITS || this.centralDirRecordsOnThisDisk === i.MAX_VALUE_16BITS || this.centralDirRecords === i.MAX_VALUE_16BITS || this.centralDirSize === i.MAX_VALUE_32BITS || this.centralDirOffset === i.MAX_VALUE_32BITS) {
          if (this.zip64 = !0, (g = this.reader.lastIndexOfSignature(e.ZIP64_CENTRAL_DIRECTORY_LOCATOR)) < 0) throw new Error("Corrupted zip: can't find the ZIP64 end of central directory locator");
          if (this.reader.setIndex(g), this.checkSignature(e.ZIP64_CENTRAL_DIRECTORY_LOCATOR), this.readBlockZip64EndOfCentralLocator(), !this.isSignature(this.relativeOffsetEndOfZip64CentralDir, e.ZIP64_CENTRAL_DIRECTORY_END) && (this.relativeOffsetEndOfZip64CentralDir = this.reader.lastIndexOfSignature(e.ZIP64_CENTRAL_DIRECTORY_END), this.relativeOffsetEndOfZip64CentralDir < 0)) throw new Error("Corrupted zip: can't find the ZIP64 end of central directory");
          this.reader.setIndex(this.relativeOffsetEndOfZip64CentralDir), this.checkSignature(e.ZIP64_CENTRAL_DIRECTORY_END), this.readBlockZip64EndOfCentral();
        }
        var u = this.centralDirOffset + this.centralDirSize;
        this.zip64 && (u += 20, u += 12 + this.zip64EndOfCentralSize);
        var m = b - u;
        if (0 < m) this.isSignature(b, e.CENTRAL_FILE_HEADER) || (this.reader.zero = m);
        else if (m < 0) throw new Error("Corrupted zip: missing " + Math.abs(m) + " bytes.");
      }, prepareReader: function(g) {
        this.reader = s(g);
      }, load: function(g) {
        this.prepareReader(g), this.readEndOfCentral(), this.readCentralDir(), this.readLocalFiles();
      } }, h.exports = x;
    }, { "./reader/readerFor": 22, "./signature": 23, "./support": 30, "./utils": 32, "./zipEntry": 34 }], 34: [function(r, h, n) {
      var s = r("./reader/readerFor"), i = r("./utils"), e = r("./compressedObject"), l = r("./crc32"), _ = r("./utf8"), x = r("./compressions"), g = r("./support");
      function b(u, m) {
        this.options = u, this.loadOptions = m;
      }
      b.prototype = { isEncrypted: function() {
        return (1 & this.bitFlag) == 1;
      }, useUTF8: function() {
        return (2048 & this.bitFlag) == 2048;
      }, readLocalPart: function(u) {
        var m, c;
        if (u.skip(22), this.fileNameLength = u.readInt(2), c = u.readInt(2), this.fileName = u.readData(this.fileNameLength), u.skip(c), this.compressedSize === -1 || this.uncompressedSize === -1) throw new Error("Bug or corrupted zip : didn't get enough information from the central directory (compressedSize === -1 || uncompressedSize === -1)");
        if ((m = function(f) {
          for (var d in x) if (Object.prototype.hasOwnProperty.call(x, d) && x[d].magic === f) return x[d];
          return null;
        }(this.compressionMethod)) === null) throw new Error("Corrupted zip : compression " + i.pretty(this.compressionMethod) + " unknown (inner file : " + i.transformTo("string", this.fileName) + ")");
        this.decompressed = new e(this.compressedSize, this.uncompressedSize, this.crc32, m, u.readData(this.compressedSize));
      }, readCentralPart: function(u) {
        this.versionMadeBy = u.readInt(2), u.skip(2), this.bitFlag = u.readInt(2), this.compressionMethod = u.readString(2), this.date = u.readDate(), this.crc32 = u.readInt(4), this.compressedSize = u.readInt(4), this.uncompressedSize = u.readInt(4);
        var m = u.readInt(2);
        if (this.extraFieldsLength = u.readInt(2), this.fileCommentLength = u.readInt(2), this.diskNumberStart = u.readInt(2), this.internalFileAttributes = u.readInt(2), this.externalFileAttributes = u.readInt(4), this.localHeaderOffset = u.readInt(4), this.isEncrypted()) throw new Error("Encrypted zip are not supported");
        u.skip(m), this.readExtraFields(u), this.parseZIP64ExtraField(u), this.fileComment = u.readData(this.fileCommentLength);
      }, processAttributes: function() {
        this.unixPermissions = null, this.dosPermissions = null;
        var u = this.versionMadeBy >> 8;
        this.dir = !!(16 & this.externalFileAttributes), u == 0 && (this.dosPermissions = 63 & this.externalFileAttributes), u == 3 && (this.unixPermissions = this.externalFileAttributes >> 16 & 65535), this.dir || this.fileNameStr.slice(-1) !== "/" || (this.dir = !0);
      }, parseZIP64ExtraField: function() {
        if (this.extraFields[1]) {
          var u = s(this.extraFields[1].value);
          this.uncompressedSize === i.MAX_VALUE_32BITS && (this.uncompressedSize = u.readInt(8)), this.compressedSize === i.MAX_VALUE_32BITS && (this.compressedSize = u.readInt(8)), this.localHeaderOffset === i.MAX_VALUE_32BITS && (this.localHeaderOffset = u.readInt(8)), this.diskNumberStart === i.MAX_VALUE_32BITS && (this.diskNumberStart = u.readInt(4));
        }
      }, readExtraFields: function(u) {
        var m, c, f, d = u.index + this.extraFieldsLength;
        for (this.extraFields || (this.extraFields = {}); u.index + 4 < d; ) m = u.readInt(2), c = u.readInt(2), f = u.readData(c), this.extraFields[m] = { id: m, length: c, value: f };
        u.setIndex(d);
      }, handleUTF8: function() {
        var u = g.uint8array ? "uint8array" : "array";
        if (this.useUTF8()) this.fileNameStr = _.utf8decode(this.fileName), this.fileCommentStr = _.utf8decode(this.fileComment);
        else {
          var m = this.findExtraFieldUnicodePath();
          if (m !== null) this.fileNameStr = m;
          else {
            var c = i.transformTo(u, this.fileName);
            this.fileNameStr = this.loadOptions.decodeFileName(c);
          }
          var f = this.findExtraFieldUnicodeComment();
          if (f !== null) this.fileCommentStr = f;
          else {
            var d = i.transformTo(u, this.fileComment);
            this.fileCommentStr = this.loadOptions.decodeFileName(d);
          }
        }
      }, findExtraFieldUnicodePath: function() {
        var u = this.extraFields[28789];
        if (u) {
          var m = s(u.value);
          return m.readInt(1) !== 1 || l(this.fileName) !== m.readInt(4) ? null : _.utf8decode(m.readData(u.length - 5));
        }
        return null;
      }, findExtraFieldUnicodeComment: function() {
        var u = this.extraFields[25461];
        if (u) {
          var m = s(u.value);
          return m.readInt(1) !== 1 || l(this.fileComment) !== m.readInt(4) ? null : _.utf8decode(m.readData(u.length - 5));
        }
        return null;
      } }, h.exports = b;
    }, { "./compressedObject": 2, "./compressions": 3, "./crc32": 4, "./reader/readerFor": 22, "./support": 30, "./utf8": 31, "./utils": 32 }], 35: [function(r, h, n) {
      function s(m, c, f) {
        this.name = m, this.dir = f.dir, this.date = f.date, this.comment = f.comment, this.unixPermissions = f.unixPermissions, this.dosPermissions = f.dosPermissions, this._data = c, this._dataBinary = f.binary, this.options = { compression: f.compression, compressionOptions: f.compressionOptions };
      }
      var i = r("./stream/StreamHelper"), e = r("./stream/DataWorker"), l = r("./utf8"), _ = r("./compressedObject"), x = r("./stream/GenericWorker");
      s.prototype = { internalStream: function(m) {
        var c = null, f = "string";
        try {
          if (!m) throw new Error("No output type specified.");
          var d = (f = m.toLowerCase()) === "string" || f === "text";
          f !== "binarystring" && f !== "text" || (f = "string"), c = this._decompressWorker();
          var v = !this._dataBinary;
          v && !d && (c = c.pipe(new l.Utf8EncodeWorker())), !v && d && (c = c.pipe(new l.Utf8DecodeWorker()));
        } catch (E) {
          (c = new x("error")).error(E);
        }
        return new i(c, f, "");
      }, async: function(m, c) {
        return this.internalStream(m).accumulate(c);
      }, nodeStream: function(m, c) {
        return this.internalStream(m || "nodebuffer").toNodejsStream(c);
      }, _compressWorker: function(m, c) {
        if (this._data instanceof _ && this._data.compression.magic === m.magic) return this._data.getCompressedWorker();
        var f = this._decompressWorker();
        return this._dataBinary || (f = f.pipe(new l.Utf8EncodeWorker())), _.createWorkerFrom(f, m, c);
      }, _decompressWorker: function() {
        return this._data instanceof _ ? this._data.getContentWorker() : this._data instanceof x ? this._data : new e(this._data);
      } };
      for (var g = ["asText", "asBinary", "asNodeBuffer", "asUint8Array", "asArrayBuffer"], b = function() {
        throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
      }, u = 0; u < g.length; u++) s.prototype[g[u]] = b;
      h.exports = s;
    }, { "./compressedObject": 2, "./stream/DataWorker": 27, "./stream/GenericWorker": 28, "./stream/StreamHelper": 29, "./utf8": 31 }], 36: [function(r, h, n) {
      (function(s) {
        var i, e, l = s.MutationObserver || s.WebKitMutationObserver;
        if (l) {
          var _ = 0, x = new l(m), g = s.document.createTextNode("");
          x.observe(g, { characterData: !0 }), i = function() {
            g.data = _ = ++_ % 2;
          };
        } else if (s.setImmediate || s.MessageChannel === void 0) i = "document" in s && "onreadystatechange" in s.document.createElement("script") ? function() {
          var c = s.document.createElement("script");
          c.onreadystatechange = function() {
            m(), c.onreadystatechange = null, c.parentNode.removeChild(c), c = null;
          }, s.document.documentElement.appendChild(c);
        } : function() {
          setTimeout(m, 0);
        };
        else {
          var b = new s.MessageChannel();
          b.port1.onmessage = m, i = function() {
            b.port2.postMessage(0);
          };
        }
        var u = [];
        function m() {
          var c, f;
          e = !0;
          for (var d = u.length; d; ) {
            for (f = u, u = [], c = -1; ++c < d; ) f[c]();
            d = u.length;
          }
          e = !1;
        }
        h.exports = function(c) {
          u.push(c) !== 1 || e || i();
        };
      }).call(this, typeof pt < "u" ? pt : typeof self < "u" ? self : typeof window < "u" ? window : {});
    }, {}], 37: [function(r, h, n) {
      var s = r("immediate");
      function i() {
      }
      var e = {}, l = ["REJECTED"], _ = ["FULFILLED"], x = ["PENDING"];
      function g(d) {
        if (typeof d != "function") throw new TypeError("resolver must be a function");
        this.state = x, this.queue = [], this.outcome = void 0, d !== i && c(this, d);
      }
      function b(d, v, E) {
        this.promise = d, typeof v == "function" && (this.onFulfilled = v, this.callFulfilled = this.otherCallFulfilled), typeof E == "function" && (this.onRejected = E, this.callRejected = this.otherCallRejected);
      }
      function u(d, v, E) {
        s(function() {
          var C;
          try {
            C = v(E);
          } catch (S) {
            return e.reject(d, S);
          }
          C === d ? e.reject(d, new TypeError("Cannot resolve promise with itself")) : e.resolve(d, C);
        });
      }
      function m(d) {
        var v = d && d.then;
        if (d && (typeof d == "object" || typeof d == "function") && typeof v == "function") return function() {
          v.apply(d, arguments);
        };
      }
      function c(d, v) {
        var E = !1;
        function C(R) {
          E || (E = !0, e.reject(d, R));
        }
        function S(R) {
          E || (E = !0, e.resolve(d, R));
        }
        var P = f(function() {
          v(S, C);
        });
        P.status === "error" && C(P.value);
      }
      function f(d, v) {
        var E = {};
        try {
          E.value = d(v), E.status = "success";
        } catch (C) {
          E.status = "error", E.value = C;
        }
        return E;
      }
      (h.exports = g).prototype.finally = function(d) {
        if (typeof d != "function") return this;
        var v = this.constructor;
        return this.then(function(E) {
          return v.resolve(d()).then(function() {
            return E;
          });
        }, function(E) {
          return v.resolve(d()).then(function() {
            throw E;
          });
        });
      }, g.prototype.catch = function(d) {
        return this.then(null, d);
      }, g.prototype.then = function(d, v) {
        if (typeof d != "function" && this.state === _ || typeof v != "function" && this.state === l) return this;
        var E = new this.constructor(i);
        return this.state !== x ? u(E, this.state === _ ? d : v, this.outcome) : this.queue.push(new b(E, d, v)), E;
      }, b.prototype.callFulfilled = function(d) {
        e.resolve(this.promise, d);
      }, b.prototype.otherCallFulfilled = function(d) {
        u(this.promise, this.onFulfilled, d);
      }, b.prototype.callRejected = function(d) {
        e.reject(this.promise, d);
      }, b.prototype.otherCallRejected = function(d) {
        u(this.promise, this.onRejected, d);
      }, e.resolve = function(d, v) {
        var E = f(m, v);
        if (E.status === "error") return e.reject(d, E.value);
        var C = E.value;
        if (C) c(d, C);
        else {
          d.state = _, d.outcome = v;
          for (var S = -1, P = d.queue.length; ++S < P; ) d.queue[S].callFulfilled(v);
        }
        return d;
      }, e.reject = function(d, v) {
        d.state = l, d.outcome = v;
        for (var E = -1, C = d.queue.length; ++E < C; ) d.queue[E].callRejected(v);
        return d;
      }, g.resolve = function(d) {
        return d instanceof this ? d : e.resolve(new this(i), d);
      }, g.reject = function(d) {
        var v = new this(i);
        return e.reject(v, d);
      }, g.all = function(d) {
        var v = this;
        if (Object.prototype.toString.call(d) !== "[object Array]") return this.reject(new TypeError("must be an array"));
        var E = d.length, C = !1;
        if (!E) return this.resolve([]);
        for (var S = new Array(E), P = 0, R = -1, N = new this(i); ++R < E; ) D(d[R], R);
        return N;
        function D(W, X) {
          v.resolve(W).then(function(w) {
            S[X] = w, ++P !== E || C || (C = !0, e.resolve(N, S));
          }, function(w) {
            C || (C = !0, e.reject(N, w));
          });
        }
      }, g.race = function(d) {
        var v = this;
        if (Object.prototype.toString.call(d) !== "[object Array]") return this.reject(new TypeError("must be an array"));
        var E = d.length, C = !1;
        if (!E) return this.resolve([]);
        for (var S = -1, P = new this(i); ++S < E; ) R = d[S], v.resolve(R).then(function(N) {
          C || (C = !0, e.resolve(P, N));
        }, function(N) {
          C || (C = !0, e.reject(P, N));
        });
        var R;
        return P;
      };
    }, { immediate: 36 }], 38: [function(r, h, n) {
      var s = {};
      (0, r("./lib/utils/common").assign)(s, r("./lib/deflate"), r("./lib/inflate"), r("./lib/zlib/constants")), h.exports = s;
    }, { "./lib/deflate": 39, "./lib/inflate": 40, "./lib/utils/common": 41, "./lib/zlib/constants": 44 }], 39: [function(r, h, n) {
      var s = r("./zlib/deflate"), i = r("./utils/common"), e = r("./utils/strings"), l = r("./zlib/messages"), _ = r("./zlib/zstream"), x = Object.prototype.toString, g = 0, b = -1, u = 0, m = 8;
      function c(d) {
        if (!(this instanceof c)) return new c(d);
        this.options = i.assign({ level: b, method: m, chunkSize: 16384, windowBits: 15, memLevel: 8, strategy: u, to: "" }, d || {});
        var v = this.options;
        v.raw && 0 < v.windowBits ? v.windowBits = -v.windowBits : v.gzip && 0 < v.windowBits && v.windowBits < 16 && (v.windowBits += 16), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new _(), this.strm.avail_out = 0;
        var E = s.deflateInit2(this.strm, v.level, v.method, v.windowBits, v.memLevel, v.strategy);
        if (E !== g) throw new Error(l[E]);
        if (v.header && s.deflateSetHeader(this.strm, v.header), v.dictionary) {
          var C;
          if (C = typeof v.dictionary == "string" ? e.string2buf(v.dictionary) : x.call(v.dictionary) === "[object ArrayBuffer]" ? new Uint8Array(v.dictionary) : v.dictionary, (E = s.deflateSetDictionary(this.strm, C)) !== g) throw new Error(l[E]);
          this._dict_set = !0;
        }
      }
      function f(d, v) {
        var E = new c(v);
        if (E.push(d, !0), E.err) throw E.msg || l[E.err];
        return E.result;
      }
      c.prototype.push = function(d, v) {
        var E, C, S = this.strm, P = this.options.chunkSize;
        if (this.ended) return !1;
        C = v === ~~v ? v : v === !0 ? 4 : 0, typeof d == "string" ? S.input = e.string2buf(d) : x.call(d) === "[object ArrayBuffer]" ? S.input = new Uint8Array(d) : S.input = d, S.next_in = 0, S.avail_in = S.input.length;
        do {
          if (S.avail_out === 0 && (S.output = new i.Buf8(P), S.next_out = 0, S.avail_out = P), (E = s.deflate(S, C)) !== 1 && E !== g) return this.onEnd(E), !(this.ended = !0);
          S.avail_out !== 0 && (S.avail_in !== 0 || C !== 4 && C !== 2) || (this.options.to === "string" ? this.onData(e.buf2binstring(i.shrinkBuf(S.output, S.next_out))) : this.onData(i.shrinkBuf(S.output, S.next_out)));
        } while ((0 < S.avail_in || S.avail_out === 0) && E !== 1);
        return C === 4 ? (E = s.deflateEnd(this.strm), this.onEnd(E), this.ended = !0, E === g) : C !== 2 || (this.onEnd(g), !(S.avail_out = 0));
      }, c.prototype.onData = function(d) {
        this.chunks.push(d);
      }, c.prototype.onEnd = function(d) {
        d === g && (this.options.to === "string" ? this.result = this.chunks.join("") : this.result = i.flattenChunks(this.chunks)), this.chunks = [], this.err = d, this.msg = this.strm.msg;
      }, n.Deflate = c, n.deflate = f, n.deflateRaw = function(d, v) {
        return (v = v || {}).raw = !0, f(d, v);
      }, n.gzip = function(d, v) {
        return (v = v || {}).gzip = !0, f(d, v);
      };
    }, { "./utils/common": 41, "./utils/strings": 42, "./zlib/deflate": 46, "./zlib/messages": 51, "./zlib/zstream": 53 }], 40: [function(r, h, n) {
      var s = r("./zlib/inflate"), i = r("./utils/common"), e = r("./utils/strings"), l = r("./zlib/constants"), _ = r("./zlib/messages"), x = r("./zlib/zstream"), g = r("./zlib/gzheader"), b = Object.prototype.toString;
      function u(c) {
        if (!(this instanceof u)) return new u(c);
        this.options = i.assign({ chunkSize: 16384, windowBits: 0, to: "" }, c || {});
        var f = this.options;
        f.raw && 0 <= f.windowBits && f.windowBits < 16 && (f.windowBits = -f.windowBits, f.windowBits === 0 && (f.windowBits = -15)), !(0 <= f.windowBits && f.windowBits < 16) || c && c.windowBits || (f.windowBits += 32), 15 < f.windowBits && f.windowBits < 48 && !(15 & f.windowBits) && (f.windowBits |= 15), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new x(), this.strm.avail_out = 0;
        var d = s.inflateInit2(this.strm, f.windowBits);
        if (d !== l.Z_OK) throw new Error(_[d]);
        this.header = new g(), s.inflateGetHeader(this.strm, this.header);
      }
      function m(c, f) {
        var d = new u(f);
        if (d.push(c, !0), d.err) throw d.msg || _[d.err];
        return d.result;
      }
      u.prototype.push = function(c, f) {
        var d, v, E, C, S, P, R = this.strm, N = this.options.chunkSize, D = this.options.dictionary, W = !1;
        if (this.ended) return !1;
        v = f === ~~f ? f : f === !0 ? l.Z_FINISH : l.Z_NO_FLUSH, typeof c == "string" ? R.input = e.binstring2buf(c) : b.call(c) === "[object ArrayBuffer]" ? R.input = new Uint8Array(c) : R.input = c, R.next_in = 0, R.avail_in = R.input.length;
        do {
          if (R.avail_out === 0 && (R.output = new i.Buf8(N), R.next_out = 0, R.avail_out = N), (d = s.inflate(R, l.Z_NO_FLUSH)) === l.Z_NEED_DICT && D && (P = typeof D == "string" ? e.string2buf(D) : b.call(D) === "[object ArrayBuffer]" ? new Uint8Array(D) : D, d = s.inflateSetDictionary(this.strm, P)), d === l.Z_BUF_ERROR && W === !0 && (d = l.Z_OK, W = !1), d !== l.Z_STREAM_END && d !== l.Z_OK) return this.onEnd(d), !(this.ended = !0);
          R.next_out && (R.avail_out !== 0 && d !== l.Z_STREAM_END && (R.avail_in !== 0 || v !== l.Z_FINISH && v !== l.Z_SYNC_FLUSH) || (this.options.to === "string" ? (E = e.utf8border(R.output, R.next_out), C = R.next_out - E, S = e.buf2string(R.output, E), R.next_out = C, R.avail_out = N - C, C && i.arraySet(R.output, R.output, E, C, 0), this.onData(S)) : this.onData(i.shrinkBuf(R.output, R.next_out)))), R.avail_in === 0 && R.avail_out === 0 && (W = !0);
        } while ((0 < R.avail_in || R.avail_out === 0) && d !== l.Z_STREAM_END);
        return d === l.Z_STREAM_END && (v = l.Z_FINISH), v === l.Z_FINISH ? (d = s.inflateEnd(this.strm), this.onEnd(d), this.ended = !0, d === l.Z_OK) : v !== l.Z_SYNC_FLUSH || (this.onEnd(l.Z_OK), !(R.avail_out = 0));
      }, u.prototype.onData = function(c) {
        this.chunks.push(c);
      }, u.prototype.onEnd = function(c) {
        c === l.Z_OK && (this.options.to === "string" ? this.result = this.chunks.join("") : this.result = i.flattenChunks(this.chunks)), this.chunks = [], this.err = c, this.msg = this.strm.msg;
      }, n.Inflate = u, n.inflate = m, n.inflateRaw = function(c, f) {
        return (f = f || {}).raw = !0, m(c, f);
      }, n.ungzip = m;
    }, { "./utils/common": 41, "./utils/strings": 42, "./zlib/constants": 44, "./zlib/gzheader": 47, "./zlib/inflate": 49, "./zlib/messages": 51, "./zlib/zstream": 53 }], 41: [function(r, h, n) {
      var s = typeof Uint8Array < "u" && typeof Uint16Array < "u" && typeof Int32Array < "u";
      n.assign = function(l) {
        for (var _ = Array.prototype.slice.call(arguments, 1); _.length; ) {
          var x = _.shift();
          if (x) {
            if (typeof x != "object") throw new TypeError(x + "must be non-object");
            for (var g in x) x.hasOwnProperty(g) && (l[g] = x[g]);
          }
        }
        return l;
      }, n.shrinkBuf = function(l, _) {
        return l.length === _ ? l : l.subarray ? l.subarray(0, _) : (l.length = _, l);
      };
      var i = { arraySet: function(l, _, x, g, b) {
        if (_.subarray && l.subarray) l.set(_.subarray(x, x + g), b);
        else for (var u = 0; u < g; u++) l[b + u] = _[x + u];
      }, flattenChunks: function(l) {
        var _, x, g, b, u, m;
        for (_ = g = 0, x = l.length; _ < x; _++) g += l[_].length;
        for (m = new Uint8Array(g), _ = b = 0, x = l.length; _ < x; _++) u = l[_], m.set(u, b), b += u.length;
        return m;
      } }, e = { arraySet: function(l, _, x, g, b) {
        for (var u = 0; u < g; u++) l[b + u] = _[x + u];
      }, flattenChunks: function(l) {
        return [].concat.apply([], l);
      } };
      n.setTyped = function(l) {
        l ? (n.Buf8 = Uint8Array, n.Buf16 = Uint16Array, n.Buf32 = Int32Array, n.assign(n, i)) : (n.Buf8 = Array, n.Buf16 = Array, n.Buf32 = Array, n.assign(n, e));
      }, n.setTyped(s);
    }, {}], 42: [function(r, h, n) {
      var s = r("./common"), i = !0, e = !0;
      try {
        String.fromCharCode.apply(null, [0]);
      } catch {
        i = !1;
      }
      try {
        String.fromCharCode.apply(null, new Uint8Array(1));
      } catch {
        e = !1;
      }
      for (var l = new s.Buf8(256), _ = 0; _ < 256; _++) l[_] = 252 <= _ ? 6 : 248 <= _ ? 5 : 240 <= _ ? 4 : 224 <= _ ? 3 : 192 <= _ ? 2 : 1;
      function x(g, b) {
        if (b < 65537 && (g.subarray && e || !g.subarray && i)) return String.fromCharCode.apply(null, s.shrinkBuf(g, b));
        for (var u = "", m = 0; m < b; m++) u += String.fromCharCode(g[m]);
        return u;
      }
      l[254] = l[254] = 1, n.string2buf = function(g) {
        var b, u, m, c, f, d = g.length, v = 0;
        for (c = 0; c < d; c++) (64512 & (u = g.charCodeAt(c))) == 55296 && c + 1 < d && (64512 & (m = g.charCodeAt(c + 1))) == 56320 && (u = 65536 + (u - 55296 << 10) + (m - 56320), c++), v += u < 128 ? 1 : u < 2048 ? 2 : u < 65536 ? 3 : 4;
        for (b = new s.Buf8(v), c = f = 0; f < v; c++) (64512 & (u = g.charCodeAt(c))) == 55296 && c + 1 < d && (64512 & (m = g.charCodeAt(c + 1))) == 56320 && (u = 65536 + (u - 55296 << 10) + (m - 56320), c++), u < 128 ? b[f++] = u : (u < 2048 ? b[f++] = 192 | u >>> 6 : (u < 65536 ? b[f++] = 224 | u >>> 12 : (b[f++] = 240 | u >>> 18, b[f++] = 128 | u >>> 12 & 63), b[f++] = 128 | u >>> 6 & 63), b[f++] = 128 | 63 & u);
        return b;
      }, n.buf2binstring = function(g) {
        return x(g, g.length);
      }, n.binstring2buf = function(g) {
        for (var b = new s.Buf8(g.length), u = 0, m = b.length; u < m; u++) b[u] = g.charCodeAt(u);
        return b;
      }, n.buf2string = function(g, b) {
        var u, m, c, f, d = b || g.length, v = new Array(2 * d);
        for (u = m = 0; u < d; ) if ((c = g[u++]) < 128) v[m++] = c;
        else if (4 < (f = l[c])) v[m++] = 65533, u += f - 1;
        else {
          for (c &= f === 2 ? 31 : f === 3 ? 15 : 7; 1 < f && u < d; ) c = c << 6 | 63 & g[u++], f--;
          1 < f ? v[m++] = 65533 : c < 65536 ? v[m++] = c : (c -= 65536, v[m++] = 55296 | c >> 10 & 1023, v[m++] = 56320 | 1023 & c);
        }
        return x(v, m);
      }, n.utf8border = function(g, b) {
        var u;
        for ((b = b || g.length) > g.length && (b = g.length), u = b - 1; 0 <= u && (192 & g[u]) == 128; ) u--;
        return u < 0 || u === 0 ? b : u + l[g[u]] > b ? u : b;
      };
    }, { "./common": 41 }], 43: [function(r, h, n) {
      h.exports = function(s, i, e, l) {
        for (var _ = 65535 & s | 0, x = s >>> 16 & 65535 | 0, g = 0; e !== 0; ) {
          for (e -= g = 2e3 < e ? 2e3 : e; x = x + (_ = _ + i[l++] | 0) | 0, --g; ) ;
          _ %= 65521, x %= 65521;
        }
        return _ | x << 16 | 0;
      };
    }, {}], 44: [function(r, h, n) {
      h.exports = { Z_NO_FLUSH: 0, Z_PARTIAL_FLUSH: 1, Z_SYNC_FLUSH: 2, Z_FULL_FLUSH: 3, Z_FINISH: 4, Z_BLOCK: 5, Z_TREES: 6, Z_OK: 0, Z_STREAM_END: 1, Z_NEED_DICT: 2, Z_ERRNO: -1, Z_STREAM_ERROR: -2, Z_DATA_ERROR: -3, Z_BUF_ERROR: -5, Z_NO_COMPRESSION: 0, Z_BEST_SPEED: 1, Z_BEST_COMPRESSION: 9, Z_DEFAULT_COMPRESSION: -1, Z_FILTERED: 1, Z_HUFFMAN_ONLY: 2, Z_RLE: 3, Z_FIXED: 4, Z_DEFAULT_STRATEGY: 0, Z_BINARY: 0, Z_TEXT: 1, Z_UNKNOWN: 2, Z_DEFLATED: 8 };
    }, {}], 45: [function(r, h, n) {
      var s = function() {
        for (var i, e = [], l = 0; l < 256; l++) {
          i = l;
          for (var _ = 0; _ < 8; _++) i = 1 & i ? 3988292384 ^ i >>> 1 : i >>> 1;
          e[l] = i;
        }
        return e;
      }();
      h.exports = function(i, e, l, _) {
        var x = s, g = _ + l;
        i ^= -1;
        for (var b = _; b < g; b++) i = i >>> 8 ^ x[255 & (i ^ e[b])];
        return -1 ^ i;
      };
    }, {}], 46: [function(r, h, n) {
      var s, i = r("../utils/common"), e = r("./trees"), l = r("./adler32"), _ = r("./crc32"), x = r("./messages"), g = 0, b = 4, u = 0, m = -2, c = -1, f = 4, d = 2, v = 8, E = 9, C = 286, S = 30, P = 19, R = 2 * C + 1, N = 15, D = 3, W = 258, X = W + D + 1, w = 42, O = 113, a = 1, U = 2, Q = 3, L = 4;
      function nt(t, F) {
        return t.msg = x[F], F;
      }
      function G(t) {
        return (t << 1) - (4 < t ? 9 : 0);
      }
      function M(t) {
        for (var F = t.length; 0 <= --F; ) t[F] = 0;
      }
      function A(t) {
        var F = t.state, B = F.pending;
        B > t.avail_out && (B = t.avail_out), B !== 0 && (i.arraySet(t.output, F.pending_buf, F.pending_out, B, t.next_out), t.next_out += B, F.pending_out += B, t.total_out += B, t.avail_out -= B, F.pending -= B, F.pending === 0 && (F.pending_out = 0));
      }
      function j(t, F) {
        e._tr_flush_block(t, 0 <= t.block_start ? t.block_start : -1, t.strstart - t.block_start, F), t.block_start = t.strstart, A(t.strm);
      }
      function V(t, F) {
        t.pending_buf[t.pending++] = F;
      }
      function Y(t, F) {
        t.pending_buf[t.pending++] = F >>> 8 & 255, t.pending_buf[t.pending++] = 255 & F;
      }
      function $(t, F) {
        var B, y, p = t.max_chain_length, I = t.strstart, Z = t.prev_length, K = t.nice_match, z = t.strstart > t.w_size - X ? t.strstart - (t.w_size - X) : 0, H = t.window, J = t.w_mask, q = t.prev, tt = t.strstart + W, ot = H[I + Z - 1], at = H[I + Z];
        t.prev_length >= t.good_match && (p >>= 2), K > t.lookahead && (K = t.lookahead);
        do
          if (H[(B = F) + Z] === at && H[B + Z - 1] === ot && H[B] === H[I] && H[++B] === H[I + 1]) {
            I += 2, B++;
            do
              ;
            while (H[++I] === H[++B] && H[++I] === H[++B] && H[++I] === H[++B] && H[++I] === H[++B] && H[++I] === H[++B] && H[++I] === H[++B] && H[++I] === H[++B] && H[++I] === H[++B] && I < tt);
            if (y = W - (tt - I), I = tt - W, Z < y) {
              if (t.match_start = F, K <= (Z = y)) break;
              ot = H[I + Z - 1], at = H[I + Z];
            }
          }
        while ((F = q[F & J]) > z && --p != 0);
        return Z <= t.lookahead ? Z : t.lookahead;
      }
      function lt(t) {
        var F, B, y, p, I, Z, K, z, H, J, q = t.w_size;
        do {
          if (p = t.window_size - t.lookahead - t.strstart, t.strstart >= q + (q - X)) {
            for (i.arraySet(t.window, t.window, q, q, 0), t.match_start -= q, t.strstart -= q, t.block_start -= q, F = B = t.hash_size; y = t.head[--F], t.head[F] = q <= y ? y - q : 0, --B; ) ;
            for (F = B = q; y = t.prev[--F], t.prev[F] = q <= y ? y - q : 0, --B; ) ;
            p += q;
          }
          if (t.strm.avail_in === 0) break;
          if (Z = t.strm, K = t.window, z = t.strstart + t.lookahead, H = p, J = void 0, J = Z.avail_in, H < J && (J = H), B = J === 0 ? 0 : (Z.avail_in -= J, i.arraySet(K, Z.input, Z.next_in, J, z), Z.state.wrap === 1 ? Z.adler = l(Z.adler, K, J, z) : Z.state.wrap === 2 && (Z.adler = _(Z.adler, K, J, z)), Z.next_in += J, Z.total_in += J, J), t.lookahead += B, t.lookahead + t.insert >= D) for (I = t.strstart - t.insert, t.ins_h = t.window[I], t.ins_h = (t.ins_h << t.hash_shift ^ t.window[I + 1]) & t.hash_mask; t.insert && (t.ins_h = (t.ins_h << t.hash_shift ^ t.window[I + D - 1]) & t.hash_mask, t.prev[I & t.w_mask] = t.head[t.ins_h], t.head[t.ins_h] = I, I++, t.insert--, !(t.lookahead + t.insert < D)); ) ;
        } while (t.lookahead < X && t.strm.avail_in !== 0);
      }
      function ht(t, F) {
        for (var B, y; ; ) {
          if (t.lookahead < X) {
            if (lt(t), t.lookahead < X && F === g) return a;
            if (t.lookahead === 0) break;
          }
          if (B = 0, t.lookahead >= D && (t.ins_h = (t.ins_h << t.hash_shift ^ t.window[t.strstart + D - 1]) & t.hash_mask, B = t.prev[t.strstart & t.w_mask] = t.head[t.ins_h], t.head[t.ins_h] = t.strstart), B !== 0 && t.strstart - B <= t.w_size - X && (t.match_length = $(t, B)), t.match_length >= D) if (y = e._tr_tally(t, t.strstart - t.match_start, t.match_length - D), t.lookahead -= t.match_length, t.match_length <= t.max_lazy_match && t.lookahead >= D) {
            for (t.match_length--; t.strstart++, t.ins_h = (t.ins_h << t.hash_shift ^ t.window[t.strstart + D - 1]) & t.hash_mask, B = t.prev[t.strstart & t.w_mask] = t.head[t.ins_h], t.head[t.ins_h] = t.strstart, --t.match_length != 0; ) ;
            t.strstart++;
          } else t.strstart += t.match_length, t.match_length = 0, t.ins_h = t.window[t.strstart], t.ins_h = (t.ins_h << t.hash_shift ^ t.window[t.strstart + 1]) & t.hash_mask;
          else y = e._tr_tally(t, 0, t.window[t.strstart]), t.lookahead--, t.strstart++;
          if (y && (j(t, !1), t.strm.avail_out === 0)) return a;
        }
        return t.insert = t.strstart < D - 1 ? t.strstart : D - 1, F === b ? (j(t, !0), t.strm.avail_out === 0 ? Q : L) : t.last_lit && (j(t, !1), t.strm.avail_out === 0) ? a : U;
      }
      function et(t, F) {
        for (var B, y, p; ; ) {
          if (t.lookahead < X) {
            if (lt(t), t.lookahead < X && F === g) return a;
            if (t.lookahead === 0) break;
          }
          if (B = 0, t.lookahead >= D && (t.ins_h = (t.ins_h << t.hash_shift ^ t.window[t.strstart + D - 1]) & t.hash_mask, B = t.prev[t.strstart & t.w_mask] = t.head[t.ins_h], t.head[t.ins_h] = t.strstart), t.prev_length = t.match_length, t.prev_match = t.match_start, t.match_length = D - 1, B !== 0 && t.prev_length < t.max_lazy_match && t.strstart - B <= t.w_size - X && (t.match_length = $(t, B), t.match_length <= 5 && (t.strategy === 1 || t.match_length === D && 4096 < t.strstart - t.match_start) && (t.match_length = D - 1)), t.prev_length >= D && t.match_length <= t.prev_length) {
            for (p = t.strstart + t.lookahead - D, y = e._tr_tally(t, t.strstart - 1 - t.prev_match, t.prev_length - D), t.lookahead -= t.prev_length - 1, t.prev_length -= 2; ++t.strstart <= p && (t.ins_h = (t.ins_h << t.hash_shift ^ t.window[t.strstart + D - 1]) & t.hash_mask, B = t.prev[t.strstart & t.w_mask] = t.head[t.ins_h], t.head[t.ins_h] = t.strstart), --t.prev_length != 0; ) ;
            if (t.match_available = 0, t.match_length = D - 1, t.strstart++, y && (j(t, !1), t.strm.avail_out === 0)) return a;
          } else if (t.match_available) {
            if ((y = e._tr_tally(t, 0, t.window[t.strstart - 1])) && j(t, !1), t.strstart++, t.lookahead--, t.strm.avail_out === 0) return a;
          } else t.match_available = 1, t.strstart++, t.lookahead--;
        }
        return t.match_available && (y = e._tr_tally(t, 0, t.window[t.strstart - 1]), t.match_available = 0), t.insert = t.strstart < D - 1 ? t.strstart : D - 1, F === b ? (j(t, !0), t.strm.avail_out === 0 ? Q : L) : t.last_lit && (j(t, !1), t.strm.avail_out === 0) ? a : U;
      }
      function st(t, F, B, y, p) {
        this.good_length = t, this.max_lazy = F, this.nice_length = B, this.max_chain = y, this.func = p;
      }
      function ut() {
        this.strm = null, this.status = 0, this.pending_buf = null, this.pending_buf_size = 0, this.pending_out = 0, this.pending = 0, this.wrap = 0, this.gzhead = null, this.gzindex = 0, this.method = v, this.last_flush = -1, this.w_size = 0, this.w_bits = 0, this.w_mask = 0, this.window = null, this.window_size = 0, this.prev = null, this.head = null, this.ins_h = 0, this.hash_size = 0, this.hash_bits = 0, this.hash_mask = 0, this.hash_shift = 0, this.block_start = 0, this.match_length = 0, this.prev_match = 0, this.match_available = 0, this.strstart = 0, this.match_start = 0, this.lookahead = 0, this.prev_length = 0, this.max_chain_length = 0, this.max_lazy_match = 0, this.level = 0, this.strategy = 0, this.good_match = 0, this.nice_match = 0, this.dyn_ltree = new i.Buf16(2 * R), this.dyn_dtree = new i.Buf16(2 * (2 * S + 1)), this.bl_tree = new i.Buf16(2 * (2 * P + 1)), M(this.dyn_ltree), M(this.dyn_dtree), M(this.bl_tree), this.l_desc = null, this.d_desc = null, this.bl_desc = null, this.bl_count = new i.Buf16(N + 1), this.heap = new i.Buf16(2 * C + 1), M(this.heap), this.heap_len = 0, this.heap_max = 0, this.depth = new i.Buf16(2 * C + 1), M(this.depth), this.l_buf = 0, this.lit_bufsize = 0, this.last_lit = 0, this.d_buf = 0, this.opt_len = 0, this.static_len = 0, this.matches = 0, this.insert = 0, this.bi_buf = 0, this.bi_valid = 0;
      }
      function ct(t) {
        var F;
        return t && t.state ? (t.total_in = t.total_out = 0, t.data_type = d, (F = t.state).pending = 0, F.pending_out = 0, F.wrap < 0 && (F.wrap = -F.wrap), F.status = F.wrap ? w : O, t.adler = F.wrap === 2 ? 0 : 1, F.last_flush = g, e._tr_init(F), u) : nt(t, m);
      }
      function kt(t) {
        var F = ct(t);
        return F === u && function(B) {
          B.window_size = 2 * B.w_size, M(B.head), B.max_lazy_match = s[B.level].max_lazy, B.good_match = s[B.level].good_length, B.nice_match = s[B.level].nice_length, B.max_chain_length = s[B.level].max_chain, B.strstart = 0, B.block_start = 0, B.lookahead = 0, B.insert = 0, B.match_length = B.prev_length = D - 1, B.match_available = 0, B.ins_h = 0;
        }(t.state), F;
      }
      function Et(t, F, B, y, p, I) {
        if (!t) return m;
        var Z = 1;
        if (F === c && (F = 6), y < 0 ? (Z = 0, y = -y) : 15 < y && (Z = 2, y -= 16), p < 1 || E < p || B !== v || y < 8 || 15 < y || F < 0 || 9 < F || I < 0 || f < I) return nt(t, m);
        y === 8 && (y = 9);
        var K = new ut();
        return (t.state = K).strm = t, K.wrap = Z, K.gzhead = null, K.w_bits = y, K.w_size = 1 << K.w_bits, K.w_mask = K.w_size - 1, K.hash_bits = p + 7, K.hash_size = 1 << K.hash_bits, K.hash_mask = K.hash_size - 1, K.hash_shift = ~~((K.hash_bits + D - 1) / D), K.window = new i.Buf8(2 * K.w_size), K.head = new i.Buf16(K.hash_size), K.prev = new i.Buf16(K.w_size), K.lit_bufsize = 1 << p + 6, K.pending_buf_size = 4 * K.lit_bufsize, K.pending_buf = new i.Buf8(K.pending_buf_size), K.d_buf = 1 * K.lit_bufsize, K.l_buf = 3 * K.lit_bufsize, K.level = F, K.strategy = I, K.method = B, kt(t);
      }
      s = [new st(0, 0, 0, 0, function(t, F) {
        var B = 65535;
        for (B > t.pending_buf_size - 5 && (B = t.pending_buf_size - 5); ; ) {
          if (t.lookahead <= 1) {
            if (lt(t), t.lookahead === 0 && F === g) return a;
            if (t.lookahead === 0) break;
          }
          t.strstart += t.lookahead, t.lookahead = 0;
          var y = t.block_start + B;
          if ((t.strstart === 0 || t.strstart >= y) && (t.lookahead = t.strstart - y, t.strstart = y, j(t, !1), t.strm.avail_out === 0) || t.strstart - t.block_start >= t.w_size - X && (j(t, !1), t.strm.avail_out === 0)) return a;
        }
        return t.insert = 0, F === b ? (j(t, !0), t.strm.avail_out === 0 ? Q : L) : (t.strstart > t.block_start && (j(t, !1), t.strm.avail_out), a);
      }), new st(4, 4, 8, 4, ht), new st(4, 5, 16, 8, ht), new st(4, 6, 32, 32, ht), new st(4, 4, 16, 16, et), new st(8, 16, 32, 32, et), new st(8, 16, 128, 128, et), new st(8, 32, 128, 256, et), new st(32, 128, 258, 1024, et), new st(32, 258, 258, 4096, et)], n.deflateInit = function(t, F) {
        return Et(t, F, v, 15, 8, 0);
      }, n.deflateInit2 = Et, n.deflateReset = kt, n.deflateResetKeep = ct, n.deflateSetHeader = function(t, F) {
        return t && t.state ? t.state.wrap !== 2 ? m : (t.state.gzhead = F, u) : m;
      }, n.deflate = function(t, F) {
        var B, y, p, I;
        if (!t || !t.state || 5 < F || F < 0) return t ? nt(t, m) : m;
        if (y = t.state, !t.output || !t.input && t.avail_in !== 0 || y.status === 666 && F !== b) return nt(t, t.avail_out === 0 ? -5 : m);
        if (y.strm = t, B = y.last_flush, y.last_flush = F, y.status === w) if (y.wrap === 2) t.adler = 0, V(y, 31), V(y, 139), V(y, 8), y.gzhead ? (V(y, (y.gzhead.text ? 1 : 0) + (y.gzhead.hcrc ? 2 : 0) + (y.gzhead.extra ? 4 : 0) + (y.gzhead.name ? 8 : 0) + (y.gzhead.comment ? 16 : 0)), V(y, 255 & y.gzhead.time), V(y, y.gzhead.time >> 8 & 255), V(y, y.gzhead.time >> 16 & 255), V(y, y.gzhead.time >> 24 & 255), V(y, y.level === 9 ? 2 : 2 <= y.strategy || y.level < 2 ? 4 : 0), V(y, 255 & y.gzhead.os), y.gzhead.extra && y.gzhead.extra.length && (V(y, 255 & y.gzhead.extra.length), V(y, y.gzhead.extra.length >> 8 & 255)), y.gzhead.hcrc && (t.adler = _(t.adler, y.pending_buf, y.pending, 0)), y.gzindex = 0, y.status = 69) : (V(y, 0), V(y, 0), V(y, 0), V(y, 0), V(y, 0), V(y, y.level === 9 ? 2 : 2 <= y.strategy || y.level < 2 ? 4 : 0), V(y, 3), y.status = O);
        else {
          var Z = v + (y.w_bits - 8 << 4) << 8;
          Z |= (2 <= y.strategy || y.level < 2 ? 0 : y.level < 6 ? 1 : y.level === 6 ? 2 : 3) << 6, y.strstart !== 0 && (Z |= 32), Z += 31 - Z % 31, y.status = O, Y(y, Z), y.strstart !== 0 && (Y(y, t.adler >>> 16), Y(y, 65535 & t.adler)), t.adler = 1;
        }
        if (y.status === 69) if (y.gzhead.extra) {
          for (p = y.pending; y.gzindex < (65535 & y.gzhead.extra.length) && (y.pending !== y.pending_buf_size || (y.gzhead.hcrc && y.pending > p && (t.adler = _(t.adler, y.pending_buf, y.pending - p, p)), A(t), p = y.pending, y.pending !== y.pending_buf_size)); ) V(y, 255 & y.gzhead.extra[y.gzindex]), y.gzindex++;
          y.gzhead.hcrc && y.pending > p && (t.adler = _(t.adler, y.pending_buf, y.pending - p, p)), y.gzindex === y.gzhead.extra.length && (y.gzindex = 0, y.status = 73);
        } else y.status = 73;
        if (y.status === 73) if (y.gzhead.name) {
          p = y.pending;
          do {
            if (y.pending === y.pending_buf_size && (y.gzhead.hcrc && y.pending > p && (t.adler = _(t.adler, y.pending_buf, y.pending - p, p)), A(t), p = y.pending, y.pending === y.pending_buf_size)) {
              I = 1;
              break;
            }
            I = y.gzindex < y.gzhead.name.length ? 255 & y.gzhead.name.charCodeAt(y.gzindex++) : 0, V(y, I);
          } while (I !== 0);
          y.gzhead.hcrc && y.pending > p && (t.adler = _(t.adler, y.pending_buf, y.pending - p, p)), I === 0 && (y.gzindex = 0, y.status = 91);
        } else y.status = 91;
        if (y.status === 91) if (y.gzhead.comment) {
          p = y.pending;
          do {
            if (y.pending === y.pending_buf_size && (y.gzhead.hcrc && y.pending > p && (t.adler = _(t.adler, y.pending_buf, y.pending - p, p)), A(t), p = y.pending, y.pending === y.pending_buf_size)) {
              I = 1;
              break;
            }
            I = y.gzindex < y.gzhead.comment.length ? 255 & y.gzhead.comment.charCodeAt(y.gzindex++) : 0, V(y, I);
          } while (I !== 0);
          y.gzhead.hcrc && y.pending > p && (t.adler = _(t.adler, y.pending_buf, y.pending - p, p)), I === 0 && (y.status = 103);
        } else y.status = 103;
        if (y.status === 103 && (y.gzhead.hcrc ? (y.pending + 2 > y.pending_buf_size && A(t), y.pending + 2 <= y.pending_buf_size && (V(y, 255 & t.adler), V(y, t.adler >> 8 & 255), t.adler = 0, y.status = O)) : y.status = O), y.pending !== 0) {
          if (A(t), t.avail_out === 0) return y.last_flush = -1, u;
        } else if (t.avail_in === 0 && G(F) <= G(B) && F !== b) return nt(t, -5);
        if (y.status === 666 && t.avail_in !== 0) return nt(t, -5);
        if (t.avail_in !== 0 || y.lookahead !== 0 || F !== g && y.status !== 666) {
          var K = y.strategy === 2 ? function(z, H) {
            for (var J; ; ) {
              if (z.lookahead === 0 && (lt(z), z.lookahead === 0)) {
                if (H === g) return a;
                break;
              }
              if (z.match_length = 0, J = e._tr_tally(z, 0, z.window[z.strstart]), z.lookahead--, z.strstart++, J && (j(z, !1), z.strm.avail_out === 0)) return a;
            }
            return z.insert = 0, H === b ? (j(z, !0), z.strm.avail_out === 0 ? Q : L) : z.last_lit && (j(z, !1), z.strm.avail_out === 0) ? a : U;
          }(y, F) : y.strategy === 3 ? function(z, H) {
            for (var J, q, tt, ot, at = z.window; ; ) {
              if (z.lookahead <= W) {
                if (lt(z), z.lookahead <= W && H === g) return a;
                if (z.lookahead === 0) break;
              }
              if (z.match_length = 0, z.lookahead >= D && 0 < z.strstart && (q = at[tt = z.strstart - 1]) === at[++tt] && q === at[++tt] && q === at[++tt]) {
                ot = z.strstart + W;
                do
                  ;
                while (q === at[++tt] && q === at[++tt] && q === at[++tt] && q === at[++tt] && q === at[++tt] && q === at[++tt] && q === at[++tt] && q === at[++tt] && tt < ot);
                z.match_length = W - (ot - tt), z.match_length > z.lookahead && (z.match_length = z.lookahead);
              }
              if (z.match_length >= D ? (J = e._tr_tally(z, 1, z.match_length - D), z.lookahead -= z.match_length, z.strstart += z.match_length, z.match_length = 0) : (J = e._tr_tally(z, 0, z.window[z.strstart]), z.lookahead--, z.strstart++), J && (j(z, !1), z.strm.avail_out === 0)) return a;
            }
            return z.insert = 0, H === b ? (j(z, !0), z.strm.avail_out === 0 ? Q : L) : z.last_lit && (j(z, !1), z.strm.avail_out === 0) ? a : U;
          }(y, F) : s[y.level].func(y, F);
          if (K !== Q && K !== L || (y.status = 666), K === a || K === Q) return t.avail_out === 0 && (y.last_flush = -1), u;
          if (K === U && (F === 1 ? e._tr_align(y) : F !== 5 && (e._tr_stored_block(y, 0, 0, !1), F === 3 && (M(y.head), y.lookahead === 0 && (y.strstart = 0, y.block_start = 0, y.insert = 0))), A(t), t.avail_out === 0)) return y.last_flush = -1, u;
        }
        return F !== b ? u : y.wrap <= 0 ? 1 : (y.wrap === 2 ? (V(y, 255 & t.adler), V(y, t.adler >> 8 & 255), V(y, t.adler >> 16 & 255), V(y, t.adler >> 24 & 255), V(y, 255 & t.total_in), V(y, t.total_in >> 8 & 255), V(y, t.total_in >> 16 & 255), V(y, t.total_in >> 24 & 255)) : (Y(y, t.adler >>> 16), Y(y, 65535 & t.adler)), A(t), 0 < y.wrap && (y.wrap = -y.wrap), y.pending !== 0 ? u : 1);
      }, n.deflateEnd = function(t) {
        var F;
        return t && t.state ? (F = t.state.status) !== w && F !== 69 && F !== 73 && F !== 91 && F !== 103 && F !== O && F !== 666 ? nt(t, m) : (t.state = null, F === O ? nt(t, -3) : u) : m;
      }, n.deflateSetDictionary = function(t, F) {
        var B, y, p, I, Z, K, z, H, J = F.length;
        if (!t || !t.state || (I = (B = t.state).wrap) === 2 || I === 1 && B.status !== w || B.lookahead) return m;
        for (I === 1 && (t.adler = l(t.adler, F, J, 0)), B.wrap = 0, J >= B.w_size && (I === 0 && (M(B.head), B.strstart = 0, B.block_start = 0, B.insert = 0), H = new i.Buf8(B.w_size), i.arraySet(H, F, J - B.w_size, B.w_size, 0), F = H, J = B.w_size), Z = t.avail_in, K = t.next_in, z = t.input, t.avail_in = J, t.next_in = 0, t.input = F, lt(B); B.lookahead >= D; ) {
          for (y = B.strstart, p = B.lookahead - (D - 1); B.ins_h = (B.ins_h << B.hash_shift ^ B.window[y + D - 1]) & B.hash_mask, B.prev[y & B.w_mask] = B.head[B.ins_h], B.head[B.ins_h] = y, y++, --p; ) ;
          B.strstart = y, B.lookahead = D - 1, lt(B);
        }
        return B.strstart += B.lookahead, B.block_start = B.strstart, B.insert = B.lookahead, B.lookahead = 0, B.match_length = B.prev_length = D - 1, B.match_available = 0, t.next_in = K, t.input = z, t.avail_in = Z, B.wrap = I, u;
      }, n.deflateInfo = "pako deflate (from Nodeca project)";
    }, { "../utils/common": 41, "./adler32": 43, "./crc32": 45, "./messages": 51, "./trees": 52 }], 47: [function(r, h, n) {
      h.exports = function() {
        this.text = 0, this.time = 0, this.xflags = 0, this.os = 0, this.extra = null, this.extra_len = 0, this.name = "", this.comment = "", this.hcrc = 0, this.done = !1;
      };
    }, {}], 48: [function(r, h, n) {
      h.exports = function(s, i) {
        var e, l, _, x, g, b, u, m, c, f, d, v, E, C, S, P, R, N, D, W, X, w, O, a, U;
        e = s.state, l = s.next_in, a = s.input, _ = l + (s.avail_in - 5), x = s.next_out, U = s.output, g = x - (i - s.avail_out), b = x + (s.avail_out - 257), u = e.dmax, m = e.wsize, c = e.whave, f = e.wnext, d = e.window, v = e.hold, E = e.bits, C = e.lencode, S = e.distcode, P = (1 << e.lenbits) - 1, R = (1 << e.distbits) - 1;
        t: do {
          E < 15 && (v += a[l++] << E, E += 8, v += a[l++] << E, E += 8), N = C[v & P];
          e: for (; ; ) {
            if (v >>>= D = N >>> 24, E -= D, (D = N >>> 16 & 255) === 0) U[x++] = 65535 & N;
            else {
              if (!(16 & D)) {
                if (!(64 & D)) {
                  N = C[(65535 & N) + (v & (1 << D) - 1)];
                  continue e;
                }
                if (32 & D) {
                  e.mode = 12;
                  break t;
                }
                s.msg = "invalid literal/length code", e.mode = 30;
                break t;
              }
              W = 65535 & N, (D &= 15) && (E < D && (v += a[l++] << E, E += 8), W += v & (1 << D) - 1, v >>>= D, E -= D), E < 15 && (v += a[l++] << E, E += 8, v += a[l++] << E, E += 8), N = S[v & R];
              r: for (; ; ) {
                if (v >>>= D = N >>> 24, E -= D, !(16 & (D = N >>> 16 & 255))) {
                  if (!(64 & D)) {
                    N = S[(65535 & N) + (v & (1 << D) - 1)];
                    continue r;
                  }
                  s.msg = "invalid distance code", e.mode = 30;
                  break t;
                }
                if (X = 65535 & N, E < (D &= 15) && (v += a[l++] << E, (E += 8) < D && (v += a[l++] << E, E += 8)), u < (X += v & (1 << D) - 1)) {
                  s.msg = "invalid distance too far back", e.mode = 30;
                  break t;
                }
                if (v >>>= D, E -= D, (D = x - g) < X) {
                  if (c < (D = X - D) && e.sane) {
                    s.msg = "invalid distance too far back", e.mode = 30;
                    break t;
                  }
                  if (O = d, (w = 0) === f) {
                    if (w += m - D, D < W) {
                      for (W -= D; U[x++] = d[w++], --D; ) ;
                      w = x - X, O = U;
                    }
                  } else if (f < D) {
                    if (w += m + f - D, (D -= f) < W) {
                      for (W -= D; U[x++] = d[w++], --D; ) ;
                      if (w = 0, f < W) {
                        for (W -= D = f; U[x++] = d[w++], --D; ) ;
                        w = x - X, O = U;
                      }
                    }
                  } else if (w += f - D, D < W) {
                    for (W -= D; U[x++] = d[w++], --D; ) ;
                    w = x - X, O = U;
                  }
                  for (; 2 < W; ) U[x++] = O[w++], U[x++] = O[w++], U[x++] = O[w++], W -= 3;
                  W && (U[x++] = O[w++], 1 < W && (U[x++] = O[w++]));
                } else {
                  for (w = x - X; U[x++] = U[w++], U[x++] = U[w++], U[x++] = U[w++], 2 < (W -= 3); ) ;
                  W && (U[x++] = U[w++], 1 < W && (U[x++] = U[w++]));
                }
                break;
              }
            }
            break;
          }
        } while (l < _ && x < b);
        l -= W = E >> 3, v &= (1 << (E -= W << 3)) - 1, s.next_in = l, s.next_out = x, s.avail_in = l < _ ? _ - l + 5 : 5 - (l - _), s.avail_out = x < b ? b - x + 257 : 257 - (x - b), e.hold = v, e.bits = E;
      };
    }, {}], 49: [function(r, h, n) {
      var s = r("../utils/common"), i = r("./adler32"), e = r("./crc32"), l = r("./inffast"), _ = r("./inftrees"), x = 1, g = 2, b = 0, u = -2, m = 1, c = 852, f = 592;
      function d(w) {
        return (w >>> 24 & 255) + (w >>> 8 & 65280) + ((65280 & w) << 8) + ((255 & w) << 24);
      }
      function v() {
        this.mode = 0, this.last = !1, this.wrap = 0, this.havedict = !1, this.flags = 0, this.dmax = 0, this.check = 0, this.total = 0, this.head = null, this.wbits = 0, this.wsize = 0, this.whave = 0, this.wnext = 0, this.window = null, this.hold = 0, this.bits = 0, this.length = 0, this.offset = 0, this.extra = 0, this.lencode = null, this.distcode = null, this.lenbits = 0, this.distbits = 0, this.ncode = 0, this.nlen = 0, this.ndist = 0, this.have = 0, this.next = null, this.lens = new s.Buf16(320), this.work = new s.Buf16(288), this.lendyn = null, this.distdyn = null, this.sane = 0, this.back = 0, this.was = 0;
      }
      function E(w) {
        var O;
        return w && w.state ? (O = w.state, w.total_in = w.total_out = O.total = 0, w.msg = "", O.wrap && (w.adler = 1 & O.wrap), O.mode = m, O.last = 0, O.havedict = 0, O.dmax = 32768, O.head = null, O.hold = 0, O.bits = 0, O.lencode = O.lendyn = new s.Buf32(c), O.distcode = O.distdyn = new s.Buf32(f), O.sane = 1, O.back = -1, b) : u;
      }
      function C(w) {
        var O;
        return w && w.state ? ((O = w.state).wsize = 0, O.whave = 0, O.wnext = 0, E(w)) : u;
      }
      function S(w, O) {
        var a, U;
        return w && w.state ? (U = w.state, O < 0 ? (a = 0, O = -O) : (a = 1 + (O >> 4), O < 48 && (O &= 15)), O && (O < 8 || 15 < O) ? u : (U.window !== null && U.wbits !== O && (U.window = null), U.wrap = a, U.wbits = O, C(w))) : u;
      }
      function P(w, O) {
        var a, U;
        return w ? (U = new v(), (w.state = U).window = null, (a = S(w, O)) !== b && (w.state = null), a) : u;
      }
      var R, N, D = !0;
      function W(w) {
        if (D) {
          var O;
          for (R = new s.Buf32(512), N = new s.Buf32(32), O = 0; O < 144; ) w.lens[O++] = 8;
          for (; O < 256; ) w.lens[O++] = 9;
          for (; O < 280; ) w.lens[O++] = 7;
          for (; O < 288; ) w.lens[O++] = 8;
          for (_(x, w.lens, 0, 288, R, 0, w.work, { bits: 9 }), O = 0; O < 32; ) w.lens[O++] = 5;
          _(g, w.lens, 0, 32, N, 0, w.work, { bits: 5 }), D = !1;
        }
        w.lencode = R, w.lenbits = 9, w.distcode = N, w.distbits = 5;
      }
      function X(w, O, a, U) {
        var Q, L = w.state;
        return L.window === null && (L.wsize = 1 << L.wbits, L.wnext = 0, L.whave = 0, L.window = new s.Buf8(L.wsize)), U >= L.wsize ? (s.arraySet(L.window, O, a - L.wsize, L.wsize, 0), L.wnext = 0, L.whave = L.wsize) : (U < (Q = L.wsize - L.wnext) && (Q = U), s.arraySet(L.window, O, a - U, Q, L.wnext), (U -= Q) ? (s.arraySet(L.window, O, a - U, U, 0), L.wnext = U, L.whave = L.wsize) : (L.wnext += Q, L.wnext === L.wsize && (L.wnext = 0), L.whave < L.wsize && (L.whave += Q))), 0;
      }
      n.inflateReset = C, n.inflateReset2 = S, n.inflateResetKeep = E, n.inflateInit = function(w) {
        return P(w, 15);
      }, n.inflateInit2 = P, n.inflate = function(w, O) {
        var a, U, Q, L, nt, G, M, A, j, V, Y, $, lt, ht, et, st, ut, ct, kt, Et, t, F, B, y, p = 0, I = new s.Buf8(4), Z = [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15];
        if (!w || !w.state || !w.output || !w.input && w.avail_in !== 0) return u;
        (a = w.state).mode === 12 && (a.mode = 13), nt = w.next_out, Q = w.output, M = w.avail_out, L = w.next_in, U = w.input, G = w.avail_in, A = a.hold, j = a.bits, V = G, Y = M, F = b;
        t: for (; ; ) switch (a.mode) {
          case m:
            if (a.wrap === 0) {
              a.mode = 13;
              break;
            }
            for (; j < 16; ) {
              if (G === 0) break t;
              G--, A += U[L++] << j, j += 8;
            }
            if (2 & a.wrap && A === 35615) {
              I[a.check = 0] = 255 & A, I[1] = A >>> 8 & 255, a.check = e(a.check, I, 2, 0), j = A = 0, a.mode = 2;
              break;
            }
            if (a.flags = 0, a.head && (a.head.done = !1), !(1 & a.wrap) || (((255 & A) << 8) + (A >> 8)) % 31) {
              w.msg = "incorrect header check", a.mode = 30;
              break;
            }
            if ((15 & A) != 8) {
              w.msg = "unknown compression method", a.mode = 30;
              break;
            }
            if (j -= 4, t = 8 + (15 & (A >>>= 4)), a.wbits === 0) a.wbits = t;
            else if (t > a.wbits) {
              w.msg = "invalid window size", a.mode = 30;
              break;
            }
            a.dmax = 1 << t, w.adler = a.check = 1, a.mode = 512 & A ? 10 : 12, j = A = 0;
            break;
          case 2:
            for (; j < 16; ) {
              if (G === 0) break t;
              G--, A += U[L++] << j, j += 8;
            }
            if (a.flags = A, (255 & a.flags) != 8) {
              w.msg = "unknown compression method", a.mode = 30;
              break;
            }
            if (57344 & a.flags) {
              w.msg = "unknown header flags set", a.mode = 30;
              break;
            }
            a.head && (a.head.text = A >> 8 & 1), 512 & a.flags && (I[0] = 255 & A, I[1] = A >>> 8 & 255, a.check = e(a.check, I, 2, 0)), j = A = 0, a.mode = 3;
          case 3:
            for (; j < 32; ) {
              if (G === 0) break t;
              G--, A += U[L++] << j, j += 8;
            }
            a.head && (a.head.time = A), 512 & a.flags && (I[0] = 255 & A, I[1] = A >>> 8 & 255, I[2] = A >>> 16 & 255, I[3] = A >>> 24 & 255, a.check = e(a.check, I, 4, 0)), j = A = 0, a.mode = 4;
          case 4:
            for (; j < 16; ) {
              if (G === 0) break t;
              G--, A += U[L++] << j, j += 8;
            }
            a.head && (a.head.xflags = 255 & A, a.head.os = A >> 8), 512 & a.flags && (I[0] = 255 & A, I[1] = A >>> 8 & 255, a.check = e(a.check, I, 2, 0)), j = A = 0, a.mode = 5;
          case 5:
            if (1024 & a.flags) {
              for (; j < 16; ) {
                if (G === 0) break t;
                G--, A += U[L++] << j, j += 8;
              }
              a.length = A, a.head && (a.head.extra_len = A), 512 & a.flags && (I[0] = 255 & A, I[1] = A >>> 8 & 255, a.check = e(a.check, I, 2, 0)), j = A = 0;
            } else a.head && (a.head.extra = null);
            a.mode = 6;
          case 6:
            if (1024 & a.flags && (G < ($ = a.length) && ($ = G), $ && (a.head && (t = a.head.extra_len - a.length, a.head.extra || (a.head.extra = new Array(a.head.extra_len)), s.arraySet(a.head.extra, U, L, $, t)), 512 & a.flags && (a.check = e(a.check, U, $, L)), G -= $, L += $, a.length -= $), a.length)) break t;
            a.length = 0, a.mode = 7;
          case 7:
            if (2048 & a.flags) {
              if (G === 0) break t;
              for ($ = 0; t = U[L + $++], a.head && t && a.length < 65536 && (a.head.name += String.fromCharCode(t)), t && $ < G; ) ;
              if (512 & a.flags && (a.check = e(a.check, U, $, L)), G -= $, L += $, t) break t;
            } else a.head && (a.head.name = null);
            a.length = 0, a.mode = 8;
          case 8:
            if (4096 & a.flags) {
              if (G === 0) break t;
              for ($ = 0; t = U[L + $++], a.head && t && a.length < 65536 && (a.head.comment += String.fromCharCode(t)), t && $ < G; ) ;
              if (512 & a.flags && (a.check = e(a.check, U, $, L)), G -= $, L += $, t) break t;
            } else a.head && (a.head.comment = null);
            a.mode = 9;
          case 9:
            if (512 & a.flags) {
              for (; j < 16; ) {
                if (G === 0) break t;
                G--, A += U[L++] << j, j += 8;
              }
              if (A !== (65535 & a.check)) {
                w.msg = "header crc mismatch", a.mode = 30;
                break;
              }
              j = A = 0;
            }
            a.head && (a.head.hcrc = a.flags >> 9 & 1, a.head.done = !0), w.adler = a.check = 0, a.mode = 12;
            break;
          case 10:
            for (; j < 32; ) {
              if (G === 0) break t;
              G--, A += U[L++] << j, j += 8;
            }
            w.adler = a.check = d(A), j = A = 0, a.mode = 11;
          case 11:
            if (a.havedict === 0) return w.next_out = nt, w.avail_out = M, w.next_in = L, w.avail_in = G, a.hold = A, a.bits = j, 2;
            w.adler = a.check = 1, a.mode = 12;
          case 12:
            if (O === 5 || O === 6) break t;
          case 13:
            if (a.last) {
              A >>>= 7 & j, j -= 7 & j, a.mode = 27;
              break;
            }
            for (; j < 3; ) {
              if (G === 0) break t;
              G--, A += U[L++] << j, j += 8;
            }
            switch (a.last = 1 & A, j -= 1, 3 & (A >>>= 1)) {
              case 0:
                a.mode = 14;
                break;
              case 1:
                if (W(a), a.mode = 20, O !== 6) break;
                A >>>= 2, j -= 2;
                break t;
              case 2:
                a.mode = 17;
                break;
              case 3:
                w.msg = "invalid block type", a.mode = 30;
            }
            A >>>= 2, j -= 2;
            break;
          case 14:
            for (A >>>= 7 & j, j -= 7 & j; j < 32; ) {
              if (G === 0) break t;
              G--, A += U[L++] << j, j += 8;
            }
            if ((65535 & A) != (A >>> 16 ^ 65535)) {
              w.msg = "invalid stored block lengths", a.mode = 30;
              break;
            }
            if (a.length = 65535 & A, j = A = 0, a.mode = 15, O === 6) break t;
          case 15:
            a.mode = 16;
          case 16:
            if ($ = a.length) {
              if (G < $ && ($ = G), M < $ && ($ = M), $ === 0) break t;
              s.arraySet(Q, U, L, $, nt), G -= $, L += $, M -= $, nt += $, a.length -= $;
              break;
            }
            a.mode = 12;
            break;
          case 17:
            for (; j < 14; ) {
              if (G === 0) break t;
              G--, A += U[L++] << j, j += 8;
            }
            if (a.nlen = 257 + (31 & A), A >>>= 5, j -= 5, a.ndist = 1 + (31 & A), A >>>= 5, j -= 5, a.ncode = 4 + (15 & A), A >>>= 4, j -= 4, 286 < a.nlen || 30 < a.ndist) {
              w.msg = "too many length or distance symbols", a.mode = 30;
              break;
            }
            a.have = 0, a.mode = 18;
          case 18:
            for (; a.have < a.ncode; ) {
              for (; j < 3; ) {
                if (G === 0) break t;
                G--, A += U[L++] << j, j += 8;
              }
              a.lens[Z[a.have++]] = 7 & A, A >>>= 3, j -= 3;
            }
            for (; a.have < 19; ) a.lens[Z[a.have++]] = 0;
            if (a.lencode = a.lendyn, a.lenbits = 7, B = { bits: a.lenbits }, F = _(0, a.lens, 0, 19, a.lencode, 0, a.work, B), a.lenbits = B.bits, F) {
              w.msg = "invalid code lengths set", a.mode = 30;
              break;
            }
            a.have = 0, a.mode = 19;
          case 19:
            for (; a.have < a.nlen + a.ndist; ) {
              for (; st = (p = a.lencode[A & (1 << a.lenbits) - 1]) >>> 16 & 255, ut = 65535 & p, !((et = p >>> 24) <= j); ) {
                if (G === 0) break t;
                G--, A += U[L++] << j, j += 8;
              }
              if (ut < 16) A >>>= et, j -= et, a.lens[a.have++] = ut;
              else {
                if (ut === 16) {
                  for (y = et + 2; j < y; ) {
                    if (G === 0) break t;
                    G--, A += U[L++] << j, j += 8;
                  }
                  if (A >>>= et, j -= et, a.have === 0) {
                    w.msg = "invalid bit length repeat", a.mode = 30;
                    break;
                  }
                  t = a.lens[a.have - 1], $ = 3 + (3 & A), A >>>= 2, j -= 2;
                } else if (ut === 17) {
                  for (y = et + 3; j < y; ) {
                    if (G === 0) break t;
                    G--, A += U[L++] << j, j += 8;
                  }
                  j -= et, t = 0, $ = 3 + (7 & (A >>>= et)), A >>>= 3, j -= 3;
                } else {
                  for (y = et + 7; j < y; ) {
                    if (G === 0) break t;
                    G--, A += U[L++] << j, j += 8;
                  }
                  j -= et, t = 0, $ = 11 + (127 & (A >>>= et)), A >>>= 7, j -= 7;
                }
                if (a.have + $ > a.nlen + a.ndist) {
                  w.msg = "invalid bit length repeat", a.mode = 30;
                  break;
                }
                for (; $--; ) a.lens[a.have++] = t;
              }
            }
            if (a.mode === 30) break;
            if (a.lens[256] === 0) {
              w.msg = "invalid code -- missing end-of-block", a.mode = 30;
              break;
            }
            if (a.lenbits = 9, B = { bits: a.lenbits }, F = _(x, a.lens, 0, a.nlen, a.lencode, 0, a.work, B), a.lenbits = B.bits, F) {
              w.msg = "invalid literal/lengths set", a.mode = 30;
              break;
            }
            if (a.distbits = 6, a.distcode = a.distdyn, B = { bits: a.distbits }, F = _(g, a.lens, a.nlen, a.ndist, a.distcode, 0, a.work, B), a.distbits = B.bits, F) {
              w.msg = "invalid distances set", a.mode = 30;
              break;
            }
            if (a.mode = 20, O === 6) break t;
          case 20:
            a.mode = 21;
          case 21:
            if (6 <= G && 258 <= M) {
              w.next_out = nt, w.avail_out = M, w.next_in = L, w.avail_in = G, a.hold = A, a.bits = j, l(w, Y), nt = w.next_out, Q = w.output, M = w.avail_out, L = w.next_in, U = w.input, G = w.avail_in, A = a.hold, j = a.bits, a.mode === 12 && (a.back = -1);
              break;
            }
            for (a.back = 0; st = (p = a.lencode[A & (1 << a.lenbits) - 1]) >>> 16 & 255, ut = 65535 & p, !((et = p >>> 24) <= j); ) {
              if (G === 0) break t;
              G--, A += U[L++] << j, j += 8;
            }
            if (st && !(240 & st)) {
              for (ct = et, kt = st, Et = ut; st = (p = a.lencode[Et + ((A & (1 << ct + kt) - 1) >> ct)]) >>> 16 & 255, ut = 65535 & p, !(ct + (et = p >>> 24) <= j); ) {
                if (G === 0) break t;
                G--, A += U[L++] << j, j += 8;
              }
              A >>>= ct, j -= ct, a.back += ct;
            }
            if (A >>>= et, j -= et, a.back += et, a.length = ut, st === 0) {
              a.mode = 26;
              break;
            }
            if (32 & st) {
              a.back = -1, a.mode = 12;
              break;
            }
            if (64 & st) {
              w.msg = "invalid literal/length code", a.mode = 30;
              break;
            }
            a.extra = 15 & st, a.mode = 22;
          case 22:
            if (a.extra) {
              for (y = a.extra; j < y; ) {
                if (G === 0) break t;
                G--, A += U[L++] << j, j += 8;
              }
              a.length += A & (1 << a.extra) - 1, A >>>= a.extra, j -= a.extra, a.back += a.extra;
            }
            a.was = a.length, a.mode = 23;
          case 23:
            for (; st = (p = a.distcode[A & (1 << a.distbits) - 1]) >>> 16 & 255, ut = 65535 & p, !((et = p >>> 24) <= j); ) {
              if (G === 0) break t;
              G--, A += U[L++] << j, j += 8;
            }
            if (!(240 & st)) {
              for (ct = et, kt = st, Et = ut; st = (p = a.distcode[Et + ((A & (1 << ct + kt) - 1) >> ct)]) >>> 16 & 255, ut = 65535 & p, !(ct + (et = p >>> 24) <= j); ) {
                if (G === 0) break t;
                G--, A += U[L++] << j, j += 8;
              }
              A >>>= ct, j -= ct, a.back += ct;
            }
            if (A >>>= et, j -= et, a.back += et, 64 & st) {
              w.msg = "invalid distance code", a.mode = 30;
              break;
            }
            a.offset = ut, a.extra = 15 & st, a.mode = 24;
          case 24:
            if (a.extra) {
              for (y = a.extra; j < y; ) {
                if (G === 0) break t;
                G--, A += U[L++] << j, j += 8;
              }
              a.offset += A & (1 << a.extra) - 1, A >>>= a.extra, j -= a.extra, a.back += a.extra;
            }
            if (a.offset > a.dmax) {
              w.msg = "invalid distance too far back", a.mode = 30;
              break;
            }
            a.mode = 25;
          case 25:
            if (M === 0) break t;
            if ($ = Y - M, a.offset > $) {
              if (($ = a.offset - $) > a.whave && a.sane) {
                w.msg = "invalid distance too far back", a.mode = 30;
                break;
              }
              lt = $ > a.wnext ? ($ -= a.wnext, a.wsize - $) : a.wnext - $, $ > a.length && ($ = a.length), ht = a.window;
            } else ht = Q, lt = nt - a.offset, $ = a.length;
            for (M < $ && ($ = M), M -= $, a.length -= $; Q[nt++] = ht[lt++], --$; ) ;
            a.length === 0 && (a.mode = 21);
            break;
          case 26:
            if (M === 0) break t;
            Q[nt++] = a.length, M--, a.mode = 21;
            break;
          case 27:
            if (a.wrap) {
              for (; j < 32; ) {
                if (G === 0) break t;
                G--, A |= U[L++] << j, j += 8;
              }
              if (Y -= M, w.total_out += Y, a.total += Y, Y && (w.adler = a.check = a.flags ? e(a.check, Q, Y, nt - Y) : i(a.check, Q, Y, nt - Y)), Y = M, (a.flags ? A : d(A)) !== a.check) {
                w.msg = "incorrect data check", a.mode = 30;
                break;
              }
              j = A = 0;
            }
            a.mode = 28;
          case 28:
            if (a.wrap && a.flags) {
              for (; j < 32; ) {
                if (G === 0) break t;
                G--, A += U[L++] << j, j += 8;
              }
              if (A !== (4294967295 & a.total)) {
                w.msg = "incorrect length check", a.mode = 30;
                break;
              }
              j = A = 0;
            }
            a.mode = 29;
          case 29:
            F = 1;
            break t;
          case 30:
            F = -3;
            break t;
          case 31:
            return -4;
          case 32:
          default:
            return u;
        }
        return w.next_out = nt, w.avail_out = M, w.next_in = L, w.avail_in = G, a.hold = A, a.bits = j, (a.wsize || Y !== w.avail_out && a.mode < 30 && (a.mode < 27 || O !== 4)) && X(w, w.output, w.next_out, Y - w.avail_out) ? (a.mode = 31, -4) : (V -= w.avail_in, Y -= w.avail_out, w.total_in += V, w.total_out += Y, a.total += Y, a.wrap && Y && (w.adler = a.check = a.flags ? e(a.check, Q, Y, w.next_out - Y) : i(a.check, Q, Y, w.next_out - Y)), w.data_type = a.bits + (a.last ? 64 : 0) + (a.mode === 12 ? 128 : 0) + (a.mode === 20 || a.mode === 15 ? 256 : 0), (V == 0 && Y === 0 || O === 4) && F === b && (F = -5), F);
      }, n.inflateEnd = function(w) {
        if (!w || !w.state) return u;
        var O = w.state;
        return O.window && (O.window = null), w.state = null, b;
      }, n.inflateGetHeader = function(w, O) {
        var a;
        return w && w.state && 2 & (a = w.state).wrap ? ((a.head = O).done = !1, b) : u;
      }, n.inflateSetDictionary = function(w, O) {
        var a, U = O.length;
        return w && w.state ? (a = w.state).wrap !== 0 && a.mode !== 11 ? u : a.mode === 11 && i(1, O, U, 0) !== a.check ? -3 : X(w, O, U, U) ? (a.mode = 31, -4) : (a.havedict = 1, b) : u;
      }, n.inflateInfo = "pako inflate (from Nodeca project)";
    }, { "../utils/common": 41, "./adler32": 43, "./crc32": 45, "./inffast": 48, "./inftrees": 50 }], 50: [function(r, h, n) {
      var s = r("../utils/common"), i = [3, 4, 5, 6, 7, 8, 9, 10, 11, 13, 15, 17, 19, 23, 27, 31, 35, 43, 51, 59, 67, 83, 99, 115, 131, 163, 195, 227, 258, 0, 0], e = [16, 16, 16, 16, 16, 16, 16, 16, 17, 17, 17, 17, 18, 18, 18, 18, 19, 19, 19, 19, 20, 20, 20, 20, 21, 21, 21, 21, 16, 72, 78], l = [1, 2, 3, 4, 5, 7, 9, 13, 17, 25, 33, 49, 65, 97, 129, 193, 257, 385, 513, 769, 1025, 1537, 2049, 3073, 4097, 6145, 8193, 12289, 16385, 24577, 0, 0], _ = [16, 16, 16, 16, 17, 17, 18, 18, 19, 19, 20, 20, 21, 21, 22, 22, 23, 23, 24, 24, 25, 25, 26, 26, 27, 27, 28, 28, 29, 29, 64, 64];
      h.exports = function(x, g, b, u, m, c, f, d) {
        var v, E, C, S, P, R, N, D, W, X = d.bits, w = 0, O = 0, a = 0, U = 0, Q = 0, L = 0, nt = 0, G = 0, M = 0, A = 0, j = null, V = 0, Y = new s.Buf16(16), $ = new s.Buf16(16), lt = null, ht = 0;
        for (w = 0; w <= 15; w++) Y[w] = 0;
        for (O = 0; O < u; O++) Y[g[b + O]]++;
        for (Q = X, U = 15; 1 <= U && Y[U] === 0; U--) ;
        if (U < Q && (Q = U), U === 0) return m[c++] = 20971520, m[c++] = 20971520, d.bits = 1, 0;
        for (a = 1; a < U && Y[a] === 0; a++) ;
        for (Q < a && (Q = a), w = G = 1; w <= 15; w++) if (G <<= 1, (G -= Y[w]) < 0) return -1;
        if (0 < G && (x === 0 || U !== 1)) return -1;
        for ($[1] = 0, w = 1; w < 15; w++) $[w + 1] = $[w] + Y[w];
        for (O = 0; O < u; O++) g[b + O] !== 0 && (f[$[g[b + O]]++] = O);
        if (R = x === 0 ? (j = lt = f, 19) : x === 1 ? (j = i, V -= 257, lt = e, ht -= 257, 256) : (j = l, lt = _, -1), w = a, P = c, nt = O = A = 0, C = -1, S = (M = 1 << (L = Q)) - 1, x === 1 && 852 < M || x === 2 && 592 < M) return 1;
        for (; ; ) {
          for (N = w - nt, W = f[O] < R ? (D = 0, f[O]) : f[O] > R ? (D = lt[ht + f[O]], j[V + f[O]]) : (D = 96, 0), v = 1 << w - nt, a = E = 1 << L; m[P + (A >> nt) + (E -= v)] = N << 24 | D << 16 | W | 0, E !== 0; ) ;
          for (v = 1 << w - 1; A & v; ) v >>= 1;
          if (v !== 0 ? (A &= v - 1, A += v) : A = 0, O++, --Y[w] == 0) {
            if (w === U) break;
            w = g[b + f[O]];
          }
          if (Q < w && (A & S) !== C) {
            for (nt === 0 && (nt = Q), P += a, G = 1 << (L = w - nt); L + nt < U && !((G -= Y[L + nt]) <= 0); ) L++, G <<= 1;
            if (M += 1 << L, x === 1 && 852 < M || x === 2 && 592 < M) return 1;
            m[C = A & S] = Q << 24 | L << 16 | P - c | 0;
          }
        }
        return A !== 0 && (m[P + A] = w - nt << 24 | 64 << 16 | 0), d.bits = Q, 0;
      };
    }, { "../utils/common": 41 }], 51: [function(r, h, n) {
      h.exports = { 2: "need dictionary", 1: "stream end", 0: "", "-1": "file error", "-2": "stream error", "-3": "data error", "-4": "insufficient memory", "-5": "buffer error", "-6": "incompatible version" };
    }, {}], 52: [function(r, h, n) {
      var s = r("../utils/common"), i = 0, e = 1;
      function l(p) {
        for (var I = p.length; 0 <= --I; ) p[I] = 0;
      }
      var _ = 0, x = 29, g = 256, b = g + 1 + x, u = 30, m = 19, c = 2 * b + 1, f = 15, d = 16, v = 7, E = 256, C = 16, S = 17, P = 18, R = [0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0], N = [0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13], D = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 3, 7], W = [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15], X = new Array(2 * (b + 2));
      l(X);
      var w = new Array(2 * u);
      l(w);
      var O = new Array(512);
      l(O);
      var a = new Array(256);
      l(a);
      var U = new Array(x);
      l(U);
      var Q, L, nt, G = new Array(u);
      function M(p, I, Z, K, z) {
        this.static_tree = p, this.extra_bits = I, this.extra_base = Z, this.elems = K, this.max_length = z, this.has_stree = p && p.length;
      }
      function A(p, I) {
        this.dyn_tree = p, this.max_code = 0, this.stat_desc = I;
      }
      function j(p) {
        return p < 256 ? O[p] : O[256 + (p >>> 7)];
      }
      function V(p, I) {
        p.pending_buf[p.pending++] = 255 & I, p.pending_buf[p.pending++] = I >>> 8 & 255;
      }
      function Y(p, I, Z) {
        p.bi_valid > d - Z ? (p.bi_buf |= I << p.bi_valid & 65535, V(p, p.bi_buf), p.bi_buf = I >> d - p.bi_valid, p.bi_valid += Z - d) : (p.bi_buf |= I << p.bi_valid & 65535, p.bi_valid += Z);
      }
      function $(p, I, Z) {
        Y(p, Z[2 * I], Z[2 * I + 1]);
      }
      function lt(p, I) {
        for (var Z = 0; Z |= 1 & p, p >>>= 1, Z <<= 1, 0 < --I; ) ;
        return Z >>> 1;
      }
      function ht(p, I, Z) {
        var K, z, H = new Array(f + 1), J = 0;
        for (K = 1; K <= f; K++) H[K] = J = J + Z[K - 1] << 1;
        for (z = 0; z <= I; z++) {
          var q = p[2 * z + 1];
          q !== 0 && (p[2 * z] = lt(H[q]++, q));
        }
      }
      function et(p) {
        var I;
        for (I = 0; I < b; I++) p.dyn_ltree[2 * I] = 0;
        for (I = 0; I < u; I++) p.dyn_dtree[2 * I] = 0;
        for (I = 0; I < m; I++) p.bl_tree[2 * I] = 0;
        p.dyn_ltree[2 * E] = 1, p.opt_len = p.static_len = 0, p.last_lit = p.matches = 0;
      }
      function st(p) {
        8 < p.bi_valid ? V(p, p.bi_buf) : 0 < p.bi_valid && (p.pending_buf[p.pending++] = p.bi_buf), p.bi_buf = 0, p.bi_valid = 0;
      }
      function ut(p, I, Z, K) {
        var z = 2 * I, H = 2 * Z;
        return p[z] < p[H] || p[z] === p[H] && K[I] <= K[Z];
      }
      function ct(p, I, Z) {
        for (var K = p.heap[Z], z = Z << 1; z <= p.heap_len && (z < p.heap_len && ut(I, p.heap[z + 1], p.heap[z], p.depth) && z++, !ut(I, K, p.heap[z], p.depth)); ) p.heap[Z] = p.heap[z], Z = z, z <<= 1;
        p.heap[Z] = K;
      }
      function kt(p, I, Z) {
        var K, z, H, J, q = 0;
        if (p.last_lit !== 0) for (; K = p.pending_buf[p.d_buf + 2 * q] << 8 | p.pending_buf[p.d_buf + 2 * q + 1], z = p.pending_buf[p.l_buf + q], q++, K === 0 ? $(p, z, I) : ($(p, (H = a[z]) + g + 1, I), (J = R[H]) !== 0 && Y(p, z -= U[H], J), $(p, H = j(--K), Z), (J = N[H]) !== 0 && Y(p, K -= G[H], J)), q < p.last_lit; ) ;
        $(p, E, I);
      }
      function Et(p, I) {
        var Z, K, z, H = I.dyn_tree, J = I.stat_desc.static_tree, q = I.stat_desc.has_stree, tt = I.stat_desc.elems, ot = -1;
        for (p.heap_len = 0, p.heap_max = c, Z = 0; Z < tt; Z++) H[2 * Z] !== 0 ? (p.heap[++p.heap_len] = ot = Z, p.depth[Z] = 0) : H[2 * Z + 1] = 0;
        for (; p.heap_len < 2; ) H[2 * (z = p.heap[++p.heap_len] = ot < 2 ? ++ot : 0)] = 1, p.depth[z] = 0, p.opt_len--, q && (p.static_len -= J[2 * z + 1]);
        for (I.max_code = ot, Z = p.heap_len >> 1; 1 <= Z; Z--) ct(p, H, Z);
        for (z = tt; Z = p.heap[1], p.heap[1] = p.heap[p.heap_len--], ct(p, H, 1), K = p.heap[1], p.heap[--p.heap_max] = Z, p.heap[--p.heap_max] = K, H[2 * z] = H[2 * Z] + H[2 * K], p.depth[z] = (p.depth[Z] >= p.depth[K] ? p.depth[Z] : p.depth[K]) + 1, H[2 * Z + 1] = H[2 * K + 1] = z, p.heap[1] = z++, ct(p, H, 1), 2 <= p.heap_len; ) ;
        p.heap[--p.heap_max] = p.heap[1], function(at, yt) {
          var Dt, St, zt, dt, $t, le, At = yt.dyn_tree, we = yt.max_code, cr = yt.stat_desc.static_tree, ur = yt.stat_desc.has_stree, dr = yt.stat_desc.extra_bits, xe = yt.stat_desc.extra_base, Mt = yt.stat_desc.max_length, Ht = 0;
          for (dt = 0; dt <= f; dt++) at.bl_count[dt] = 0;
          for (At[2 * at.heap[at.heap_max] + 1] = 0, Dt = at.heap_max + 1; Dt < c; Dt++) Mt < (dt = At[2 * At[2 * (St = at.heap[Dt]) + 1] + 1] + 1) && (dt = Mt, Ht++), At[2 * St + 1] = dt, we < St || (at.bl_count[dt]++, $t = 0, xe <= St && ($t = dr[St - xe]), le = At[2 * St], at.opt_len += le * (dt + $t), ur && (at.static_len += le * (cr[2 * St + 1] + $t)));
          if (Ht !== 0) {
            do {
              for (dt = Mt - 1; at.bl_count[dt] === 0; ) dt--;
              at.bl_count[dt]--, at.bl_count[dt + 1] += 2, at.bl_count[Mt]--, Ht -= 2;
            } while (0 < Ht);
            for (dt = Mt; dt !== 0; dt--) for (St = at.bl_count[dt]; St !== 0; ) we < (zt = at.heap[--Dt]) || (At[2 * zt + 1] !== dt && (at.opt_len += (dt - At[2 * zt + 1]) * At[2 * zt], At[2 * zt + 1] = dt), St--);
          }
        }(p, I), ht(H, ot, p.bl_count);
      }
      function t(p, I, Z) {
        var K, z, H = -1, J = I[1], q = 0, tt = 7, ot = 4;
        for (J === 0 && (tt = 138, ot = 3), I[2 * (Z + 1) + 1] = 65535, K = 0; K <= Z; K++) z = J, J = I[2 * (K + 1) + 1], ++q < tt && z === J || (q < ot ? p.bl_tree[2 * z] += q : z !== 0 ? (z !== H && p.bl_tree[2 * z]++, p.bl_tree[2 * C]++) : q <= 10 ? p.bl_tree[2 * S]++ : p.bl_tree[2 * P]++, H = z, ot = (q = 0) === J ? (tt = 138, 3) : z === J ? (tt = 6, 3) : (tt = 7, 4));
      }
      function F(p, I, Z) {
        var K, z, H = -1, J = I[1], q = 0, tt = 7, ot = 4;
        for (J === 0 && (tt = 138, ot = 3), K = 0; K <= Z; K++) if (z = J, J = I[2 * (K + 1) + 1], !(++q < tt && z === J)) {
          if (q < ot) for (; $(p, z, p.bl_tree), --q != 0; ) ;
          else z !== 0 ? (z !== H && ($(p, z, p.bl_tree), q--), $(p, C, p.bl_tree), Y(p, q - 3, 2)) : q <= 10 ? ($(p, S, p.bl_tree), Y(p, q - 3, 3)) : ($(p, P, p.bl_tree), Y(p, q - 11, 7));
          H = z, ot = (q = 0) === J ? (tt = 138, 3) : z === J ? (tt = 6, 3) : (tt = 7, 4);
        }
      }
      l(G);
      var B = !1;
      function y(p, I, Z, K) {
        Y(p, (_ << 1) + (K ? 1 : 0), 3), function(z, H, J, q) {
          st(z), V(z, J), V(z, ~J), s.arraySet(z.pending_buf, z.window, H, J, z.pending), z.pending += J;
        }(p, I, Z);
      }
      n._tr_init = function(p) {
        B || (function() {
          var I, Z, K, z, H, J = new Array(f + 1);
          for (z = K = 0; z < x - 1; z++) for (U[z] = K, I = 0; I < 1 << R[z]; I++) a[K++] = z;
          for (a[K - 1] = z, z = H = 0; z < 16; z++) for (G[z] = H, I = 0; I < 1 << N[z]; I++) O[H++] = z;
          for (H >>= 7; z < u; z++) for (G[z] = H << 7, I = 0; I < 1 << N[z] - 7; I++) O[256 + H++] = z;
          for (Z = 0; Z <= f; Z++) J[Z] = 0;
          for (I = 0; I <= 143; ) X[2 * I + 1] = 8, I++, J[8]++;
          for (; I <= 255; ) X[2 * I + 1] = 9, I++, J[9]++;
          for (; I <= 279; ) X[2 * I + 1] = 7, I++, J[7]++;
          for (; I <= 287; ) X[2 * I + 1] = 8, I++, J[8]++;
          for (ht(X, b + 1, J), I = 0; I < u; I++) w[2 * I + 1] = 5, w[2 * I] = lt(I, 5);
          Q = new M(X, R, g + 1, b, f), L = new M(w, N, 0, u, f), nt = new M(new Array(0), D, 0, m, v);
        }(), B = !0), p.l_desc = new A(p.dyn_ltree, Q), p.d_desc = new A(p.dyn_dtree, L), p.bl_desc = new A(p.bl_tree, nt), p.bi_buf = 0, p.bi_valid = 0, et(p);
      }, n._tr_stored_block = y, n._tr_flush_block = function(p, I, Z, K) {
        var z, H, J = 0;
        0 < p.level ? (p.strm.data_type === 2 && (p.strm.data_type = function(q) {
          var tt, ot = 4093624447;
          for (tt = 0; tt <= 31; tt++, ot >>>= 1) if (1 & ot && q.dyn_ltree[2 * tt] !== 0) return i;
          if (q.dyn_ltree[18] !== 0 || q.dyn_ltree[20] !== 0 || q.dyn_ltree[26] !== 0) return e;
          for (tt = 32; tt < g; tt++) if (q.dyn_ltree[2 * tt] !== 0) return e;
          return i;
        }(p)), Et(p, p.l_desc), Et(p, p.d_desc), J = function(q) {
          var tt;
          for (t(q, q.dyn_ltree, q.l_desc.max_code), t(q, q.dyn_dtree, q.d_desc.max_code), Et(q, q.bl_desc), tt = m - 1; 3 <= tt && q.bl_tree[2 * W[tt] + 1] === 0; tt--) ;
          return q.opt_len += 3 * (tt + 1) + 5 + 5 + 4, tt;
        }(p), z = p.opt_len + 3 + 7 >>> 3, (H = p.static_len + 3 + 7 >>> 3) <= z && (z = H)) : z = H = Z + 5, Z + 4 <= z && I !== -1 ? y(p, I, Z, K) : p.strategy === 4 || H === z ? (Y(p, 2 + (K ? 1 : 0), 3), kt(p, X, w)) : (Y(p, 4 + (K ? 1 : 0), 3), function(q, tt, ot, at) {
          var yt;
          for (Y(q, tt - 257, 5), Y(q, ot - 1, 5), Y(q, at - 4, 4), yt = 0; yt < at; yt++) Y(q, q.bl_tree[2 * W[yt] + 1], 3);
          F(q, q.dyn_ltree, tt - 1), F(q, q.dyn_dtree, ot - 1);
        }(p, p.l_desc.max_code + 1, p.d_desc.max_code + 1, J + 1), kt(p, p.dyn_ltree, p.dyn_dtree)), et(p), K && st(p);
      }, n._tr_tally = function(p, I, Z) {
        return p.pending_buf[p.d_buf + 2 * p.last_lit] = I >>> 8 & 255, p.pending_buf[p.d_buf + 2 * p.last_lit + 1] = 255 & I, p.pending_buf[p.l_buf + p.last_lit] = 255 & Z, p.last_lit++, I === 0 ? p.dyn_ltree[2 * Z]++ : (p.matches++, I--, p.dyn_ltree[2 * (a[Z] + g + 1)]++, p.dyn_dtree[2 * j(I)]++), p.last_lit === p.lit_bufsize - 1;
      }, n._tr_align = function(p) {
        Y(p, 2, 3), $(p, E, X), function(I) {
          I.bi_valid === 16 ? (V(I, I.bi_buf), I.bi_buf = 0, I.bi_valid = 0) : 8 <= I.bi_valid && (I.pending_buf[I.pending++] = 255 & I.bi_buf, I.bi_buf >>= 8, I.bi_valid -= 8);
        }(p);
      };
    }, { "../utils/common": 41 }], 53: [function(r, h, n) {
      h.exports = function() {
        this.input = null, this.next_in = 0, this.avail_in = 0, this.total_in = 0, this.output = null, this.next_out = 0, this.avail_out = 0, this.total_out = 0, this.msg = "", this.state = null, this.data_type = 2, this.adler = 0;
      };
    }, {}], 54: [function(r, h, n) {
      (function(s) {
        (function(i, e) {
          if (!i.setImmediate) {
            var l, _, x, g, b = 1, u = {}, m = !1, c = i.document, f = Object.getPrototypeOf && Object.getPrototypeOf(i);
            f = f && f.setTimeout ? f : i, l = {}.toString.call(i.process) === "[object process]" ? function(C) {
              process.nextTick(function() {
                v(C);
              });
            } : function() {
              if (i.postMessage && !i.importScripts) {
                var C = !0, S = i.onmessage;
                return i.onmessage = function() {
                  C = !1;
                }, i.postMessage("", "*"), i.onmessage = S, C;
              }
            }() ? (g = "setImmediate$" + Math.random() + "$", i.addEventListener ? i.addEventListener("message", E, !1) : i.attachEvent("onmessage", E), function(C) {
              i.postMessage(g + C, "*");
            }) : i.MessageChannel ? ((x = new MessageChannel()).port1.onmessage = function(C) {
              v(C.data);
            }, function(C) {
              x.port2.postMessage(C);
            }) : c && "onreadystatechange" in c.createElement("script") ? (_ = c.documentElement, function(C) {
              var S = c.createElement("script");
              S.onreadystatechange = function() {
                v(C), S.onreadystatechange = null, _.removeChild(S), S = null;
              }, _.appendChild(S);
            }) : function(C) {
              setTimeout(v, 0, C);
            }, f.setImmediate = function(C) {
              typeof C != "function" && (C = new Function("" + C));
              for (var S = new Array(arguments.length - 1), P = 0; P < S.length; P++) S[P] = arguments[P + 1];
              var R = { callback: C, args: S };
              return u[b] = R, l(b), b++;
            }, f.clearImmediate = d;
          }
          function d(C) {
            delete u[C];
          }
          function v(C) {
            if (m) setTimeout(v, 0, C);
            else {
              var S = u[C];
              if (S) {
                m = !0;
                try {
                  (function(P) {
                    var R = P.callback, N = P.args;
                    switch (N.length) {
                      case 0:
                        R();
                        break;
                      case 1:
                        R(N[0]);
                        break;
                      case 2:
                        R(N[0], N[1]);
                        break;
                      case 3:
                        R(N[0], N[1], N[2]);
                        break;
                      default:
                        R.apply(e, N);
                    }
                  })(S);
                } finally {
                  d(C), m = !1;
                }
              }
            }
          }
          function E(C) {
            C.source === i && typeof C.data == "string" && C.data.indexOf(g) === 0 && v(+C.data.slice(g.length));
          }
        })(typeof self > "u" ? s === void 0 ? this : s : self);
      }).call(this, typeof pt < "u" ? pt : typeof self < "u" ? self : typeof window < "u" ? window : {});
    }, {}] }, {}, [10])(10);
  });
})($e);
var Lr = $e.exports;
const He = /* @__PURE__ */ Ur(Lr), Wr = _t.div`
  display: flex;
  flex-direction: column;
  border: 1px solid
    ${({ theme: T }) => T.palette.borderColor.main};
  border-radius: 4px;
`, Zr = _t.div`
  display: flex;
  background-color: #fff;
  justify-content: flex-end;
  & > button {
    margin-left: 10px;
  }
  padding-right: 16px;
`;
_t.div`
  position: absolute;
  width: 100%;
  height: 50%;
  background: #2323234d;
`;
const Kr = (T) => T.length === 1 && T.some((o) => o.name.endsWith(".zip")) || !T.some((o) => o.name.endsWith(".sql") || o.name.endsWith(".r")) ? T.find((o) => o.name.endsWith(".zip")) : null, qe = (T) => {
  const {
    type: o,
    noDropzone: r,
    onCancel: h,
    afterCreate: n,
    createMethod: s,
    acceptExt: i,
    freeUpload: e,
    textAvailableExt: l,
    localDownload: _
  } = T, { enqueueSnackbar: x } = Wt(), [g, b] = vt(!1), u = he(!1), m = Kt({
    primaryKey: "id",
    values: []
  }), c = ft(
    (v, E) => {
      v.preventDefault(), E.file.name.endsWith(".zip") && (u.current = !1), m.removeEntity(E);
    },
    []
  ), f = ft(async (v) => {
    if (u.current) return;
    const E = Kr(v);
    if (v.forEach((C) => {
      const S = Le();
      m.createEntity({
        id: S,
        file: C
      });
    }), _)
      if (!E)
        n == null || n(v, null);
      else {
        const C = new He();
        u.current = !0, C.loadAsync(E).then((S) => {
          n == null || n(E, S);
        });
      }
  }, []), d = ft(async () => {
    b(!0);
    const v = [];
    m.data.ids.forEach((E) => {
      const C = m.data.byId[E].file, S = new FormData();
      S.append("file", C), v.push(s(S));
    });
    try {
      await Promise.all(v), b(!1), x({
        message: "Loaded successfully",
        variant: "success"
      }), n == null || n({});
    } catch {
      x({
        message: "Fail to load",
        variant: "error"
      }), n == null || n({});
    }
  }, [m]);
  return /* @__PURE__ */ k.jsx(Wr, { children: /* @__PURE__ */ k.jsxs(
    Oe,
    {
      items: Object.values(m.data.byId),
      primaryKey: "id",
      title: "Files to upload",
      headerText: "Upload your attachments",
      onRemove: c,
      itemComponent: (v) => /* @__PURE__ */ k.jsx(Ne, { file: v.file, disableIcon: !0 }),
      children: [
        /* @__PURE__ */ k.jsx(
          me,
          {
            onDrop: f,
            acceptExt: i,
            textAvailableExt: l,
            freeUpload: e,
            maxSize: 1e9
          }
        ),
        /* @__PURE__ */ k.jsx(Zr, { children: !_ && /* @__PURE__ */ k.jsx(
          bt,
          {
            variant: "contained",
            onClick: d,
            disabled: !m.data.ids.length || g,
            color: "success",
            name: "upload-files",
            startIcon: g ? /* @__PURE__ */ k.jsx(Zt, { size: 16 }) : /* @__PURE__ */ k.jsx(gt, { iconName: "submit" }),
            children: "Upload Files"
          }
        ) })
      ]
    }
  ) });
};
var Ct = {}, Xe = {}, Rt = {}, Gt = {}, Tt = {}, ne = {};
Object.defineProperty(ne, "__esModule", { value: !0 });
ne.lexoHelper = void 0;
ne.lexoHelper = {
  arrayCopy: Gr
};
function Gr(T, o, r, h, n) {
  let s = h;
  const i = o + n;
  for (let e = o; e < i; e++)
    r[s] = T[e], ++s;
}
var Yt = {};
Object.defineProperty(Yt, "__esModule", { value: !0 });
class Yr {
  constructor(o = "") {
    this.str = o;
  }
  get length() {
    return this.str.length;
  }
  set length(o) {
    this.str = this.str.substring(0, o);
  }
  append(o) {
    return this.str = this.str + o, this;
  }
  remove(o, r) {
    return this.str = this.str.substr(0, o) + this.str.substr(o + r), this;
  }
  insert(o, r) {
    return this.str = this.str.substr(0, o) + r + this.str.substr(o), this;
  }
  toString() {
    return this.str;
  }
}
Yt.default = Yr;
Object.defineProperty(Tt, "__esModule", { value: !0 });
Tt.LexoInteger = void 0;
const Xt = ne, $r = Yt;
class it {
  constructor(o, r, h) {
    this.sys = o, this.sign = r, this.mag = h;
  }
  static parse(o, r) {
    let h = o, n = 1;
    o.indexOf(r.getPositiveChar()) === 0 ? h = o.substring(1) : o.indexOf(r.getNegativeChar()) === 0 && (h = o.substring(1), n = -1);
    const s = new Array(h.length);
    let i = s.length - 1;
    for (let e = 0; i >= 0; ++e)
      s[e] = r.toDigit(h.charAt(i)), --i;
    return it.make(r, n, s);
  }
  static zero(o) {
    return new it(o, 0, it.ZERO_MAG);
  }
  static one(o) {
    return it.make(o, 1, it.ONE_MAG);
  }
  static make(o, r, h) {
    let n;
    for (n = h.length; n > 0 && h[n - 1] === 0; --n)
      ;
    if (n === 0)
      return it.zero(o);
    if (n === h.length)
      return new it(o, r, h);
    const s = new Array(n).fill(0);
    return Xt.lexoHelper.arrayCopy(h, 0, s, 0, n), new it(o, r, s);
  }
  static add(o, r, h) {
    const n = Math.max(r.length, h.length), s = new Array(n).fill(0);
    let i = 0;
    for (let e = 0; e < n; ++e) {
      const l = e < r.length ? r[e] : 0, _ = e < h.length ? h[e] : 0;
      let x = l + _ + i;
      for (i = 0; x >= o.getBase(); x -= o.getBase())
        ++i;
      s[e] = x;
    }
    return it.extendWithCarry(s, i);
  }
  static extendWithCarry(o, r) {
    if (r > 0) {
      const h = new Array(o.length + 1).fill(0);
      return Xt.lexoHelper.arrayCopy(o, 0, h, 0, o.length), h[h.length - 1] = r, h;
    }
    return o;
  }
  static subtract(o, r, h) {
    const n = it.complement(o, h, r.length), s = it.add(o, r, n);
    return s[s.length - 1] = 0, it.add(o, s, it.ONE_MAG);
  }
  static multiply(o, r, h) {
    const n = new Array(r.length + h.length).fill(0);
    for (let s = 0; s < r.length; ++s)
      for (let i = 0; i < h.length; ++i) {
        const e = s + i;
        for (n[e] += r[s] * h[i]; n[e] >= o.getBase(); n[e] -= o.getBase())
          ++n[e + 1];
      }
    return n;
  }
  static complement(o, r, h) {
    if (h <= 0)
      throw new Error("Expected at least 1 digit");
    const n = new Array(h).fill(o.getBase() - 1);
    for (let s = 0; s < r.length; ++s)
      n[s] = o.getBase() - 1 - r[s];
    return n;
  }
  static compare(o, r) {
    if (o.length < r.length)
      return -1;
    if (o.length > r.length)
      return 1;
    for (let h = o.length - 1; h >= 0; --h) {
      if (o[h] < r[h])
        return -1;
      if (o[h] > r[h])
        return 1;
    }
    return 0;
  }
  add(o) {
    if (this.checkSystem(o), this.isZero())
      return o;
    if (o.isZero())
      return this;
    if (this.sign !== o.sign) {
      let h;
      return this.sign === -1 ? (h = this.negate(), h.subtract(o).negate()) : (h = o.negate(), this.subtract(h));
    }
    const r = it.add(this.sys, this.mag, o.mag);
    return it.make(this.sys, this.sign, r);
  }
  subtract(o) {
    if (this.checkSystem(o), this.isZero())
      return o.negate();
    if (o.isZero())
      return this;
    if (this.sign !== o.sign) {
      let h;
      return this.sign === -1 ? (h = this.negate(), h.add(o).negate()) : (h = o.negate(), this.add(h));
    }
    const r = it.compare(this.mag, o.mag);
    return r === 0 ? it.zero(this.sys) : r < 0 ? it.make(this.sys, this.sign === -1 ? 1 : -1, it.subtract(this.sys, o.mag, this.mag)) : it.make(this.sys, this.sign === -1 ? -1 : 1, it.subtract(this.sys, this.mag, o.mag));
  }
  multiply(o) {
    if (this.checkSystem(o), this.isZero())
      return this;
    if (o.isZero())
      return o;
    if (this.isOneish())
      return this.sign === o.sign ? it.make(this.sys, 1, o.mag) : it.make(this.sys, -1, o.mag);
    if (o.isOneish())
      return this.sign === o.sign ? it.make(this.sys, 1, this.mag) : it.make(this.sys, -1, this.mag);
    const r = it.multiply(this.sys, this.mag, o.mag);
    return this.sign === o.sign ? it.make(this.sys, 1, r) : it.make(this.sys, -1, r);
  }
  negate() {
    return this.isZero() ? this : it.make(this.sys, this.sign === 1 ? -1 : 1, this.mag);
  }
  shiftLeft(o = 1) {
    if (o === 0)
      return this;
    if (o < 0)
      return this.shiftRight(Math.abs(o));
    const r = new Array(this.mag.length + o).fill(0);
    return Xt.lexoHelper.arrayCopy(this.mag, 0, r, o, this.mag.length), it.make(this.sys, this.sign, r);
  }
  shiftRight(o = 1) {
    if (this.mag.length - o <= 0)
      return it.zero(this.sys);
    const r = new Array(this.mag.length - o).fill(0);
    return Xt.lexoHelper.arrayCopy(this.mag, o, r, 0, r.length), it.make(this.sys, this.sign, r);
  }
  complement() {
    return this.complementDigits(this.mag.length);
  }
  complementDigits(o) {
    return it.make(this.sys, this.sign, it.complement(this.sys, this.mag, o));
  }
  isZero() {
    return this.sign === 0 && this.mag.length === 1 && this.mag[0] === 0;
  }
  isOne() {
    return this.sign === 1 && this.mag.length === 1 && this.mag[0] === 1;
  }
  getMag(o) {
    return this.mag[o];
  }
  compareTo(o) {
    if (this === o)
      return 0;
    if (!o)
      return 1;
    if (this.sign === -1) {
      if (o.sign === -1) {
        const r = it.compare(this.mag, o.mag);
        return r === -1 ? 1 : r === 1 ? -1 : 0;
      }
      return -1;
    }
    return this.sign === 1 ? o.sign === 1 ? it.compare(this.mag, o.mag) : 1 : o.sign === -1 ? 1 : o.sign === 1 ? -1 : 0;
  }
  getSystem() {
    return this.sys;
  }
  format() {
    if (this.isZero())
      return "" + this.sys.toChar(0);
    const o = new $r.default(), r = this.mag, h = r.length;
    for (let n = 0; n < h; ++n) {
      const s = r[n];
      o.insert(0, this.sys.toChar(s));
    }
    return this.sign === -1 && o.insert(0, this.sys.getNegativeChar()), o.toString();
  }
  equals(o) {
    return this === o ? !0 : o ? this.sys.getBase() === o.sys.getBase() && this.compareTo(o) === 0 : !1;
  }
  toString() {
    return this.format();
  }
  isOneish() {
    return this.mag.length === 1 && this.mag[0] === 1;
  }
  checkSystem(o) {
    if (this.sys.getBase() !== o.sys.getBase())
      throw new Error("Expected numbers of same numeral sys");
  }
}
Tt.LexoInteger = it;
it.ZERO_MAG = [0];
it.ONE_MAG = [1];
it.NEGATIVE_SIGN = -1;
it.ZERO_SIGN = 0;
it.POSITIVE_SIGN = 1;
Object.defineProperty(Gt, "__esModule", { value: !0 });
Gt.LexoDecimal = void 0;
const Ut = Tt, Hr = Yt;
class wt {
  constructor(o, r) {
    this.mag = o, this.sig = r;
  }
  static half(o) {
    const r = o.getBase() / 2 | 0;
    return wt.make(Ut.LexoInteger.make(o, 1, [r]), 1);
  }
  static parse(o, r) {
    const h = o.indexOf(r.getRadixPointChar());
    if (o.lastIndexOf(r.getRadixPointChar()) !== h)
      throw new Error("More than one " + r.getRadixPointChar());
    if (h < 0)
      return wt.make(Ut.LexoInteger.parse(o, r), 0);
    const n = o.substring(0, h) + o.substring(h + 1);
    return wt.make(Ut.LexoInteger.parse(n, r), o.length - 1 - h);
  }
  static from(o) {
    return wt.make(o, 0);
  }
  static make(o, r) {
    if (o.isZero())
      return new wt(o, 0);
    let h = 0;
    for (let i = 0; i < r && o.getMag(i) === 0; ++i)
      ++h;
    const n = o.shiftRight(h), s = r - h;
    return new wt(n, s);
  }
  getSystem() {
    return this.mag.getSystem();
  }
  add(o) {
    let r = this.mag, h = this.sig, n = o.mag, s;
    for (s = o.sig; h < s; ++h)
      r = r.shiftLeft();
    for (; h > s; )
      n = n.shiftLeft(), ++s;
    return wt.make(r.add(n), h);
  }
  subtract(o) {
    let r = this.mag, h = this.sig, n = o.mag, s;
    for (s = o.sig; h < s; ++h)
      r = r.shiftLeft();
    for (; h > s; )
      n = n.shiftLeft(), ++s;
    return wt.make(r.subtract(n), h);
  }
  multiply(o) {
    return wt.make(this.mag.multiply(o.mag), this.sig + o.sig);
  }
  floor() {
    return this.mag.shiftRight(this.sig);
  }
  ceil() {
    if (this.isExact())
      return this.mag;
    const o = this.floor();
    return o.add(Ut.LexoInteger.one(o.getSystem()));
  }
  isExact() {
    if (this.sig === 0)
      return !0;
    for (let o = 0; o < this.sig; ++o)
      if (this.mag.getMag(o) !== 0)
        return !1;
    return !0;
  }
  getScale() {
    return this.sig;
  }
  setScale(o, r = !1) {
    if (o >= this.sig)
      return this;
    o < 0 && (o = 0);
    const h = this.sig - o;
    let n = this.mag.shiftRight(h);
    return r && (n = n.add(Ut.LexoInteger.one(n.getSystem()))), wt.make(n, o);
  }
  compareTo(o) {
    if (this === o)
      return 0;
    if (!o)
      return 1;
    let r = this.mag, h = o.mag;
    return this.sig > o.sig ? h = h.shiftLeft(this.sig - o.sig) : this.sig < o.sig && (r = r.shiftLeft(o.sig - this.sig)), r.compareTo(h);
  }
  format() {
    const o = this.mag.format();
    if (this.sig === 0)
      return o;
    const r = new Hr.default(o), h = r[0], n = h === this.mag.getSystem().getPositiveChar() || h === this.mag.getSystem().getNegativeChar();
    for (n && r.remove(0, 1); r.length < this.sig + 1; )
      r.insert(0, this.mag.getSystem().toChar(0));
    return r.insert(r.length - this.sig, this.mag.getSystem().getRadixPointChar()), r.length - this.sig === 0 && r.insert(0, this.mag.getSystem().toChar(0)), n && r.insert(0, h), r.toString();
  }
  equals(o) {
    return this === o ? !0 : o ? this.mag.equals(o.mag) && this.sig === o.sig : !1;
  }
  toString() {
    return this.format();
  }
}
Gt.LexoDecimal = wt;
var Vt = {}, Te;
function Ve() {
  if (Te) return Vt;
  Te = 1, Object.defineProperty(Vt, "__esModule", { value: !0 });
  const T = Tt, o = Qe();
  class r {
    constructor(n) {
      this.value = T.LexoInteger.parse(n, o.LexoRank.NUMERAL_SYSTEM);
    }
    static get BUCKET_0() {
      return this._BUCKET_0 || (this._BUCKET_0 = new r("0")), this._BUCKET_0;
    }
    static get BUCKET_1() {
      return this._BUCKET_1 || (this._BUCKET_1 = new r("1")), this._BUCKET_1;
    }
    static get BUCKET_2() {
      return this._BUCKET_2 || (this._BUCKET_2 = new r("2")), this._BUCKET_2;
    }
    static get VALUES() {
      return this._VALUES || (this._VALUES = [r.BUCKET_0, r.BUCKET_1, r.BUCKET_2]), this._VALUES;
    }
    static max() {
      return r.VALUES[r.VALUES.length - 1];
    }
    static from(n) {
      const s = T.LexoInteger.parse(n, o.LexoRank.NUMERAL_SYSTEM), i = r.VALUES, e = i.length;
      for (let l = 0; l < e; ++l) {
        const _ = i[l];
        if (_.value.equals(s))
          return _;
      }
      throw new Error("Unknown bucket: " + n);
    }
    static resolve(n) {
      const s = r.VALUES, i = s.length;
      for (let e = 0; e < i; ++e) {
        const l = s[e];
        if (l.equals(r.from(n.toString())))
          return l;
      }
      throw new Error("No bucket found with id " + n);
    }
    format() {
      return this.value.format();
    }
    next() {
      return this.equals(r.BUCKET_0) ? r.BUCKET_1 : this.equals(r.BUCKET_1) ? r.BUCKET_2 : this.equals(r.BUCKET_2) ? r.BUCKET_0 : r.BUCKET_2;
    }
    prev() {
      return this.equals(r.BUCKET_0) ? r.BUCKET_2 : this.equals(r.BUCKET_1) ? r.BUCKET_0 : this.equals(r.BUCKET_2) ? r.BUCKET_1 : r.BUCKET_0;
    }
    equals(n) {
      return this === n ? !0 : n ? this.value.equals(n.value) : !1;
    }
  }
  return Vt.default = r, Vt;
}
var ye = {}, Je = {};
Object.defineProperty(Je, "__esModule", { value: !0 });
var ie = {};
Object.defineProperty(ie, "__esModule", { value: !0 });
ie.LexoNumeralSystem10 = void 0;
class qr {
  getBase() {
    return 10;
  }
  getPositiveChar() {
    return "+";
  }
  getNegativeChar() {
    return "-";
  }
  getRadixPointChar() {
    return ".";
  }
  toDigit(o) {
    if (o >= "0" && o <= "9")
      return o.charCodeAt(0) - 48;
    throw new Error("Not valid digit: " + o);
  }
  toChar(o) {
    return String.fromCharCode(o + 48);
  }
}
ie.LexoNumeralSystem10 = qr;
var se = {};
Object.defineProperty(se, "__esModule", { value: !0 });
se.LexoNumeralSystem36 = void 0;
class Xr {
  constructor() {
    this.DIGITS = "0123456789abcdefghijklmnopqrstuvwxyz".split("");
  }
  getBase() {
    return 36;
  }
  getPositiveChar() {
    return "+";
  }
  getNegativeChar() {
    return "-";
  }
  getRadixPointChar() {
    return ":";
  }
  toDigit(o) {
    if (o >= "0" && o <= "9")
      return o.charCodeAt(0) - 48;
    if (o >= "a" && o <= "z")
      return o.charCodeAt(0) - 97 + 10;
    throw new Error("Not valid digit: " + o);
  }
  toChar(o) {
    return this.DIGITS[o];
  }
}
se.LexoNumeralSystem36 = Xr;
var ae = {};
Object.defineProperty(ae, "__esModule", { value: !0 });
ae.LexoNumeralSystem64 = void 0;
class Vr {
  constructor() {
    this.DIGITS = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ^_abcdefghijklmnopqrstuvwxyz".split("");
  }
  getBase() {
    return 64;
  }
  getPositiveChar() {
    return "+";
  }
  getNegativeChar() {
    return "-";
  }
  getRadixPointChar() {
    return ":";
  }
  toDigit(o) {
    if (o >= "0" && o <= "9")
      return o.charCodeAt(0) - 48;
    if (o >= "A" && o <= "Z")
      return o.charCodeAt(0) - 65 + 10;
    if (o === "^")
      return 36;
    if (o === "_")
      return 37;
    if (o >= "a" && o <= "z")
      return o.charCodeAt(0) - 97 + 38;
    throw new Error("Not valid digit: " + o);
  }
  toChar(o) {
    return this.DIGITS[o];
  }
}
ae.LexoNumeralSystem64 = Vr;
(function(T) {
  var o = pt && pt.__createBinding || (Object.create ? function(h, n, s, i) {
    i === void 0 && (i = s);
    var e = Object.getOwnPropertyDescriptor(n, s);
    (!e || ("get" in e ? !n.__esModule : e.writable || e.configurable)) && (e = { enumerable: !0, get: function() {
      return n[s];
    } }), Object.defineProperty(h, i, e);
  } : function(h, n, s, i) {
    i === void 0 && (i = s), h[i] = n[s];
  }), r = pt && pt.__exportStar || function(h, n) {
    for (var s in h) s !== "default" && !Object.prototype.hasOwnProperty.call(n, s) && o(n, h, s);
  };
  Object.defineProperty(T, "__esModule", { value: !0 }), r(Je, T), r(ie, T), r(se, T), r(ae, T);
})(ye);
var De;
function Qe() {
  if (De) return Rt;
  De = 1, Object.defineProperty(Rt, "__esModule", { value: !0 }), Rt.LexoRank = void 0;
  const T = Gt, o = Ve(), r = Yt, h = ye;
  class n {
    constructor(i, e) {
      this.value = i.format() + "|" + n.formatDecimal(e), this.bucket = i, this.decimal = e;
    }
    static get NUMERAL_SYSTEM() {
      return this._NUMERAL_SYSTEM || (this._NUMERAL_SYSTEM = new h.LexoNumeralSystem36()), this._NUMERAL_SYSTEM;
    }
    static get ZERO_DECIMAL() {
      return this._ZERO_DECIMAL || (this._ZERO_DECIMAL = T.LexoDecimal.parse("0", n.NUMERAL_SYSTEM)), this._ZERO_DECIMAL;
    }
    static get ONE_DECIMAL() {
      return this._ONE_DECIMAL || (this._ONE_DECIMAL = T.LexoDecimal.parse("1", n.NUMERAL_SYSTEM)), this._ONE_DECIMAL;
    }
    static get EIGHT_DECIMAL() {
      return this._EIGHT_DECIMAL || (this._EIGHT_DECIMAL = T.LexoDecimal.parse("8", n.NUMERAL_SYSTEM)), this._EIGHT_DECIMAL;
    }
    static get MIN_DECIMAL() {
      return this._MIN_DECIMAL || (this._MIN_DECIMAL = n.ZERO_DECIMAL), this._MIN_DECIMAL;
    }
    static get MAX_DECIMAL() {
      return this._MAX_DECIMAL || (this._MAX_DECIMAL = T.LexoDecimal.parse("1000000", n.NUMERAL_SYSTEM).subtract(n.ONE_DECIMAL)), this._MAX_DECIMAL;
    }
    static get MID_DECIMAL() {
      return this._MID_DECIMAL || (this._MID_DECIMAL = n.between(n.MIN_DECIMAL, n.MAX_DECIMAL)), this._MID_DECIMAL;
    }
    static get INITIAL_MIN_DECIMAL() {
      return this._INITIAL_MIN_DECIMAL || (this._INITIAL_MIN_DECIMAL = T.LexoDecimal.parse("100000", n.NUMERAL_SYSTEM)), this._INITIAL_MIN_DECIMAL;
    }
    static get INITIAL_MAX_DECIMAL() {
      return this._INITIAL_MAX_DECIMAL || (this._INITIAL_MAX_DECIMAL = T.LexoDecimal.parse(n.NUMERAL_SYSTEM.toChar(n.NUMERAL_SYSTEM.getBase() - 2) + "00000", n.NUMERAL_SYSTEM)), this._INITIAL_MAX_DECIMAL;
    }
    static min() {
      return n.from(o.default.BUCKET_0, n.MIN_DECIMAL);
    }
    static middle() {
      const i = n.min();
      return i.between(n.max(i.bucket));
    }
    static max(i = o.default.BUCKET_0) {
      return n.from(i, n.MAX_DECIMAL);
    }
    static initial(i) {
      return i === o.default.BUCKET_0 ? n.from(i, n.INITIAL_MIN_DECIMAL) : n.from(i, n.INITIAL_MAX_DECIMAL);
    }
    static between(i, e) {
      if (i.getSystem().getBase() !== e.getSystem().getBase())
        throw new Error("Expected same system");
      let l = i, _ = e, x;
      if (i.getScale() < e.getScale()) {
        if (x = e.setScale(i.getScale(), !1), i.compareTo(x) >= 0)
          return n.mid(i, e);
        _ = x;
      }
      if (i.getScale() > _.getScale()) {
        if (x = i.setScale(_.getScale(), !0), x.compareTo(_) >= 0)
          return n.mid(i, e);
        l = x;
      }
      let g;
      for (let m = l.getScale(); m > 0; _ = g) {
        const c = m - 1, f = l.setScale(c, !0);
        if (g = _.setScale(c, !1), f.compareTo(g) === 0)
          return n.checkMid(i, e, f);
        if (f.compareTo(g) > 0)
          break;
        m = c, l = f;
      }
      let b = n.middleInternal(i, e, l, _), u;
      for (let m = b.getScale(); m > 0; m = u) {
        u = m - 1;
        const c = b.setScale(u);
        if (i.compareTo(c) >= 0 || c.compareTo(e) >= 0)
          break;
        b = c;
      }
      return b;
    }
    static parse(i) {
      const e = i.split("|"), l = o.default.from(e[0]), _ = T.LexoDecimal.parse(e[1], n.NUMERAL_SYSTEM);
      return new n(l, _);
    }
    static from(i, e) {
      if (e.getSystem().getBase() !== n.NUMERAL_SYSTEM.getBase())
        throw new Error("Expected different system");
      return new n(i, e);
    }
    static middleInternal(i, e, l, _) {
      const x = n.mid(l, _);
      return n.checkMid(i, e, x);
    }
    static checkMid(i, e, l) {
      return i.compareTo(l) >= 0 || l.compareTo(e) >= 0 ? n.mid(i, e) : l;
    }
    static mid(i, e) {
      const _ = i.add(e).multiply(T.LexoDecimal.half(i.getSystem())), x = i.getScale() > e.getScale() ? i.getScale() : e.getScale();
      if (_.getScale() > x) {
        const g = _.setScale(x, !1);
        if (g.compareTo(i) > 0)
          return g;
        const b = _.setScale(x, !0);
        if (b.compareTo(e) < 0)
          return b;
      }
      return _;
    }
    static formatDecimal(i) {
      const e = i.format(), l = new r.default(e);
      let _ = e.indexOf(n.NUMERAL_SYSTEM.getRadixPointChar());
      const x = n.NUMERAL_SYSTEM.toChar(0);
      for (_ < 0 && (_ = e.length, l.append(n.NUMERAL_SYSTEM.getRadixPointChar())); _ < 6; )
        l.insert(0, x), ++_;
      for (; l[l.length - 1] === x; )
        l.length = l.length - 1;
      return l.toString();
    }
    genPrev() {
      if (this.isMax())
        return new n(this.bucket, n.INITIAL_MAX_DECIMAL);
      const i = this.decimal.floor();
      let l = T.LexoDecimal.from(i).subtract(n.EIGHT_DECIMAL);
      return l.compareTo(n.MIN_DECIMAL) <= 0 && (l = n.between(n.MIN_DECIMAL, this.decimal)), new n(this.bucket, l);
    }
    genNext() {
      if (this.isMin())
        return new n(this.bucket, n.INITIAL_MIN_DECIMAL);
      const i = this.decimal.ceil();
      let l = T.LexoDecimal.from(i).add(n.EIGHT_DECIMAL);
      return l.compareTo(n.MAX_DECIMAL) >= 0 && (l = n.between(this.decimal, n.MAX_DECIMAL)), new n(this.bucket, l);
    }
    between(i) {
      if (!this.bucket.equals(i.bucket))
        throw new Error("Between works only within the same bucket");
      const e = this.decimal.compareTo(i.decimal);
      if (e > 0)
        return new n(this.bucket, n.between(i.decimal, this.decimal));
      if (e === 0)
        throw new Error("Try to rank between issues with same rank this=" + this + " other=" + i + " this.decimal=" + this.decimal + " other.decimal=" + i.decimal);
      return new n(this.bucket, n.between(this.decimal, i.decimal));
    }
    getBucket() {
      return this.bucket;
    }
    getDecimal() {
      return this.decimal;
    }
    inNextBucket() {
      return n.from(this.bucket.next(), this.decimal);
    }
    inPrevBucket() {
      return n.from(this.bucket.prev(), this.decimal);
    }
    isMin() {
      return this.decimal.equals(n.MIN_DECIMAL);
    }
    isMax() {
      return this.decimal.equals(n.MAX_DECIMAL);
    }
    format() {
      return this.value;
    }
    equals(i) {
      return this === i ? !0 : i ? this.value === i.value : !1;
    }
    toString() {
      return this.value;
    }
    compareTo(i) {
      return this === i ? 0 : i ? this.value.localeCompare(i.value) : 1;
    }
  }
  return Rt.LexoRank = n, Rt;
}
(function(T) {
  var o = pt && pt.__createBinding || (Object.create ? function(h, n, s, i) {
    i === void 0 && (i = s);
    var e = Object.getOwnPropertyDescriptor(n, s);
    (!e || ("get" in e ? !n.__esModule : e.writable || e.configurable)) && (e = { enumerable: !0, get: function() {
      return n[s];
    } }), Object.defineProperty(h, i, e);
  } : function(h, n, s, i) {
    i === void 0 && (i = s), h[i] = n[s];
  }), r = pt && pt.__exportStar || function(h, n) {
    for (var s in h) s !== "default" && !Object.prototype.hasOwnProperty.call(n, s) && o(n, h, s);
  };
  Object.defineProperty(T, "__esModule", { value: !0 }), r(Qe(), T), r(Ve(), T), r(Gt, T), r(Tt, T);
})(Xe);
(function(T) {
  var o = pt && pt.__createBinding || (Object.create ? function(h, n, s, i) {
    i === void 0 && (i = s);
    var e = Object.getOwnPropertyDescriptor(n, s);
    (!e || ("get" in e ? !n.__esModule : e.writable || e.configurable)) && (e = { enumerable: !0, get: function() {
      return n[s];
    } }), Object.defineProperty(h, i, e);
  } : function(h, n, s, i) {
    i === void 0 && (i = s), h[i] = n[s];
  }), r = pt && pt.__exportStar || function(h, n) {
    for (var s in h) s !== "default" && !Object.prototype.hasOwnProperty.call(n, s) && o(n, h, s);
  };
  Object.defineProperty(T, "__esModule", { value: !0 }), r(Xe, T), r(ye, T);
})(Ct);
const Jr = _t.div`
  display: flex;
  flex-direction: column;
  border: 1px solid
    ${({ theme: T }) => T.palette.borderColor.main};
  border-radius: 4px;
`;
_t.div`
  display: flex;
  background-color: #fff;
  justify-content: flex-end;
  & > button {
    margin-left: 10px;
  }
  padding-right: 16px;
`;
const tr = (T) => {
  const { pageNumber: o = 0, pageSize: r = 20, sortBy: h, query: n } = T || {}, s = ee(h), i = `/documents/list?size=${r}&page=${o}&sort=${s}&${n || ""}`;
  return mt.get(i);
}, ze = () => mt.get("/documents/list/library"), er = (T) => {
  const { pageNumber: o = 0, pageSize: r = 20, sortBy: h, query: n } = T || {}, s = ee(h), i = `/workspace/documents/list?size=${r}&page=${o}&sort=${s}&${n || ""}`;
  return mt.get(i);
}, rr = (T, o) => {
  const { pageNumber: r = 0, pageSize: h = 20, sortBy: n, query: s } = o || {}, i = ee(n), e = `/studies/${T}/documents/list?size=${h}&page=${r}&sort=${i}&${s || ""}`;
  return mt.get(e);
}, Qr = (T) => {
  const o = `/documents/filter?${T}`;
  return mt.get(o);
}, tn = (T) => {
  const o = `/workspace/documents/filter?${T}`;
  return mt.get(o);
}, en = (T, o) => {
  const r = `/studies/${o}/documents/filter?${T}`;
  return mt.get(r);
}, nr = (T) => mt.get(`/documents/${T}/download`), oe = (T) => mt.delete(`/documents/${T}`), ir = (T) => mt.post("/analyses", T), sr = (T) => mt.post("/workspace/documents/upload", T), ar = (T, o) => mt.post(`/studies/${T}/documents/upload`, o), rn = (T) => mt.post("/documents/upload/library", T), nn = (T) => mt.post("/documents", T), sn = () => mt.get("/documents/sorts"), an = () => mt.get("/workspace/documents/sorts"), on = (T, o) => {
  const { pageNumber: r, pageSize: h, sortBy: n, query: s } = o, i = ee(n), e = `data-source/${T}/documents/list?size=${h || ""}&page=${r || ""}&sort=${i}&${s || ""}`;
  return mt.get(e);
}, ln = (T, o) => mt.post(`/data-source/${T}/documents/upload`, o), cn = fe(
  (T) => {
    const { onClose: o, documents: r, successCallback: h } = T, { enqueueSnackbar: n } = Wt(), [s, i] = vt(!1), [e, l] = vt(0), _ = Kt({
      primaryKey: "id",
      values: []
    }), [x, g] = vt([]);
    Lt(() => {
      let N = null;
      const D = r.map((W, X) => {
        const w = {
          ...W
        };
        return w.rank ? N = w.rank : (X == 0 ? N = Ct.LexoRank.min().between(Ct.LexoRank.middle()).toString() : N = Ct.LexoRank.parse(N).between(Ct.LexoRank.max()).toString(), w.rank = N), w;
      });
      g(D);
    }, r);
    const [b, u] = vt(!1), m = pe(), c = ft(async (N) => {
      u(!0), i(!0);
      const D = [];
      N.forEach((W) => {
        const X = new FormData();
        X.append("file", W), l((w) => w + 1), D.push(
          v(It.DETACHED, null).create(X).then((w) => {
            g((O) => {
              const a = O.sort(
                (U, Q) => U.rank.localeCompare(Q.rank, void 0, { numeric: !0 })
              )[O.length - 1];
              return w.rank = a ? C(a).between(Ct.LexoRank.max()).toString() : Ct.LexoRank.middle().toString(), [...O, w];
            }), n({
              message: "File " + w.fileMetadata.realName + " uploaded",
              variant: "success"
            });
          }).finally(() => l((w) => w - 1))
        );
      });
      try {
        await Promise.all(D), i(!1);
      } catch (W) {
        i(!1), console.error("Failed to upload files", W), n({
          message: "Failed to upload files",
          variant: "error"
        });
      }
    }, []), f = (N, D) => {
      u(!0);
      const W = x.map((X, w) => w === N ? {
        ...X,
        fileMetadata: {
          ...X.fileMetadata,
          realName: D
        },
        mediaFileMetadata: X.mediaFileMetadata
      } : X);
      g(W);
    }, d = (N, D) => {
      u(!0);
      const W = x.map((X, w) => w === N ? {
        ...X,
        fileMetadata: X.fileMetadata,
        mediaFileMetadata: {
          ...X.mediaFileMetadata,
          duration: D
        }
      } : X);
      g(W);
    }, v = (N, D) => We(
      N,
      D,
      void 0,
      void 0,
      void 0,
      void 0,
      rn
    ), E = (N, D) => {
      u(!0), g((W) => {
        let X = [...W];
        const w = N === "up" ? D - 1 : D + 1, O = X[D], a = X[w];
        let U = null;
        return N === "up" ? w === 0 ? U = C(a).between(Ct.LexoRank.min()).toString() : U = S(a, X[w - 1]).toString() : w === X.length - 1 ? U = C(a).between(Ct.LexoRank.max()).toString() : U = S(a, X[w + 1]).toString(), O.rank = U, X.sort(
          (Q, L) => Q.rank.localeCompare(L.rank, void 0, { numeric: !0 })
        );
      });
    }, C = (N) => Ct.LexoRank.parse(N.rank ?? ""), S = (N, D) => C(N).between(C(D)), P = (N) => {
      oe(N).then((D) => {
        n({
          message: "Document deleted",
          variant: "success"
        }), g(x.filter((W) => W.id !== N));
      }).catch((D) => {
        console.error("ERROR", D), n({
          message: "Failed to delete document",
          variant: "error"
        });
      });
    }, R = ft(async () => {
      i(!0);
      try {
        const N = await nn(x);
        i(!1), n({
          message: "Documents updated",
          variant: "success"
        }), h == null || h(N), o(b);
      } catch {
        n({
          message: "Fail to load",
          variant: "error"
        });
      }
    }, [_]);
    return /* @__PURE__ */ k.jsx(rt, { container: !0, p: 2, children: /* @__PURE__ */ k.jsx(ge, { children: /* @__PURE__ */ k.jsxs(rt, { container: !0, spacing: 2, p: 2, children: [
      /* @__PURE__ */ k.jsx(rt, { item: !0, xs: 12, children: /* @__PURE__ */ k.jsxs(Jr, { children: [
        /* @__PURE__ */ k.jsx(
          me,
          {
            onDrop: c,
            textAvailableExt: "All formats allowed",
            freeUpload: !0,
            maxSize: 1e9
          }
        ),
        e > 0 && /* @__PURE__ */ k.jsxs(k.Fragment, { children: [
          /* @__PURE__ */ k.jsxs(
            xt,
            {
              variant: "subtitle1",
              component: "span",
              sx: { marginLeft: "15px" },
              children: [
                "Uploading ",
                e,
                " file(s)..."
              ]
            }
          ),
          /* @__PURE__ */ k.jsx(
            "progress",
            {
              style: { width: "95%", margin: "5px 15px" }
            }
          )
        ] })
      ] }) }),
      /* @__PURE__ */ k.jsxs(rt, { container: !0, p: 2, children: [
        /* @__PURE__ */ k.jsx(rt, { item: !0, xs: 2, children: /* @__PURE__ */ k.jsx(xt, { variant: "subtitle1", component: "span", children: "Rearrange" }) }),
        /* @__PURE__ */ k.jsx(rt, { item: !0, xs: 4, children: /* @__PURE__ */ k.jsx(xt, { variant: "subtitle1", component: "span", children: "Name" }) }),
        /* @__PURE__ */ k.jsx(rt, { item: !0, xs: 1, children: /* @__PURE__ */ k.jsx(xt, { variant: "subtitle1", component: "span", children: "Icon" }) }),
        /* @__PURE__ */ k.jsx(rt, { item: !0, xs: 2, children: /* @__PURE__ */ k.jsx(xt, { variant: "subtitle1", component: "span", children: "Size" }) }),
        /* @__PURE__ */ k.jsx(rt, { item: !0, xs: 3, children: /* @__PURE__ */ k.jsx(xt, { variant: "subtitle1", component: "span", children: "Duration" }) })
      ] }),
      /* @__PURE__ */ k.jsx(rt, { container: !0, p: 2, children: x.map(
        (N, D) => {
          var w;
          const W = Ze(N.fileMetadata.realName), X = re(W);
          return /* @__PURE__ */ k.jsxs(
            rt,
            {
              container: !0,
              alignItems: "left",
              spacing: 1,
              mb: 1,
              children: [
                /* @__PURE__ */ k.jsxs(rt, { item: !0, xs: 2, children: [
                  /* @__PURE__ */ k.jsxs(xt, { variant: "subtitle2", component: "span", mr: 1, children: [
                    D + 1,
                    "."
                  ] }),
                  /* @__PURE__ */ k.jsx(
                    bt,
                    {
                      onClick: () => {
                        E("up", D);
                      },
                      variant: "outlined",
                      sx: {
                        minWidth: 30,
                        height: 30,
                        borderColor: "borderColor.main",
                        p: 0,
                        mr: 0.5
                      },
                      disabled: D === 0,
                      children: /* @__PURE__ */ k.jsx(
                        gt,
                        {
                          iconName: "chevron",
                          sx: { fontSize: 14, transform: "rotate(180deg)" }
                        }
                      )
                    }
                  ),
                  /* @__PURE__ */ k.jsx(
                    bt,
                    {
                      onClick: () => {
                        E("down", D);
                      },
                      variant: "outlined",
                      sx: {
                        minWidth: 30,
                        height: 30,
                        p: 0,
                        borderColor: "borderColor.main"
                      },
                      disabled: D === (x == null ? void 0 : x.length) - 1,
                      children: /* @__PURE__ */ k.jsx(gt, { iconName: "chevron", sx: { fontSize: 14 } })
                    }
                  )
                ] }),
                /* @__PURE__ */ k.jsx(rt, { item: !0, xs: 4, children: /* @__PURE__ */ k.jsx(
                  ce,
                  {
                    value: N.fileMetadata.realName,
                    onChange: (O) => f(D, O.target.value)
                  }
                ) }),
                /* @__PURE__ */ k.jsx(rt, { item: !0, xs: 1, children: /* @__PURE__ */ k.jsx(
                  gt,
                  {
                    iconName: X,
                    sx: { color: (w = m.palette) == null ? void 0 : w.primary.main }
                  }
                ) }),
                /* @__PURE__ */ k.jsx(rt, { item: !0, xs: 2, children: /* @__PURE__ */ k.jsx(
                  ce,
                  {
                    value: _e(N.fileMetadata.length),
                    disabled: !0
                  }
                ) }),
                /* @__PURE__ */ k.jsx(rt, { item: !0, xs: 2, children: /* @__PURE__ */ k.jsx(
                  ce,
                  {
                    value: N.mediaFileMetadata.duration ? N.mediaFileMetadata.duration : "",
                    onChange: (O) => d(D, O.target.value)
                  }
                ) }),
                /* @__PURE__ */ k.jsx(rt, { item: !0, xs: 1, children: /* @__PURE__ */ k.jsx(
                  Be,
                  {
                    size: "medium",
                    iconSize: 14,
                    onRemove: () => P(N.id),
                    withConfirmation: !0,
                    confirmationMessage: 'Are you sure you want to delete document "' + N.fileMetadata.realName + '"?'
                  }
                ) })
              ]
            },
            D + "-document"
          );
        }
      ) }),
      /* @__PURE__ */ k.jsx(rt, { item: !0, xs: 12, children: /* @__PURE__ */ k.jsxs(fr, { children: [
        /* @__PURE__ */ k.jsx(
          bt,
          {
            variant: "outlined",
            disabled: s,
            onClick: () => o(b),
            startIcon: /* @__PURE__ */ k.jsx(gt, { iconName: "deactivate" }),
            name: "delete",
            children: "Cancel"
          }
        ),
        /* @__PURE__ */ k.jsx(
          bt,
          {
            onClick: R,
            disabled: !b || s,
            variant: "contained",
            color: "success",
            startIcon: /* @__PURE__ */ k.jsx(gt, { iconName: "submit" }),
            name: "save",
            children: "Save"
          }
        )
      ] }) })
    ] }) }) });
  }
), un = {
  name: "documents",
  title: "Documents",
  modal: {
    header: {
      new: "New document"
    }
  },
  addButtonText: "Add document",
  getApiMethods: (T, o) => ({
    primaryKey: "uuid",
    methods: {
      create: {
        method: (r) => {
          switch (T) {
            case It.WORKSPACE:
              return sr(r);
            case It.STUDY:
              return ar(o, r);
            default:
              return ir(r);
          }
        }
      },
      read: {
        method: (r = {}) => {
          switch (T) {
            case It.WORKSPACE:
              return er(r);
            case It.STUDY:
              return rr(o, r);
            default:
              return tr(r);
          }
        },
        formatter: (r) => r.map((h) => {
          var n;
          return {
            ...h,
            uuid: h == null ? void 0 : h.id,
            label: (n = h == null ? void 0 : h.fileMetadata) == null ? void 0 : n.realName
          };
        })
      },
      delete: {
        method: (r) => oe(r.id)
      }
    }
  })
}, dn = _t.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-grow: 1;
  width: 100%;
  padding: 8px 0px;
  cursor: pointer;
  ${({ isDisabled: T = !1 }) => T && `
    opacity: 0.5;
    pointer-events: none;
  `}
  &:not(:last-of-type) {
    border-bottom: 1px solid ${({ theme: T }) => T.palette.borderColor.light};
  }
  &:hover {
    background-color: ${({ theme: T }) => T.palette.backgroundColor.main};
  }
`, hn = _t.div`
  display: flex;
  align-items: center;
  flex-grow: 1;
  min-width: calc(100% - 80px);
`, fn = _t.div`
  margin-left: 16px;
  display: flex;
  flex-direction: column;
  max-width: calc(100% - 50px);
`, mn = _t.div`
  color: ${({ theme: T }) => T.palette.textColor.secondary};
  font-size: 14px;
  text-overflow: ellipsis;
  overflow-x: hidden;
  white-space: nowrap;
`, pn = _t.div`
  font-size: 10px;
  color: ${({ theme: T }) => T.palette.textColor.label};
`, gn = _t.div`
  display: flex;
  align-items: center;
`, _n = _t.div`
  div:not(:last-child) {
    margin-right: 8px;
  }
`;
_t.div``;
const vn = fe((T) => {
  var g;
  const { isProcessing: o, document: r, onSelect: h, onRemove: n, typeContainer: s } = T, i = pe(), e = Pt(
    () => ve(r),
    [r]
  ), l = ft((b) => {
    b.preventDefault(), h == null || h(e);
  }, []), _ = ft((b) => {
    b.preventDefault(), n == null || n(r);
  }, []), x = Qt.useMemo(
    () => !!(!(s === It.STUDY && r.actions) || be(r.actions)[Ge.UPDATE]),
    [r.actions]
  );
  return /* @__PURE__ */ k.jsxs(dn, { isDisabled: o, children: [
    /* @__PURE__ */ k.jsxs(hn, { onClick: l, children: [
      /* @__PURE__ */ k.jsx(
        gt,
        {
          iconName: re(e.extension),
          iconStatus: Ke(e.antivirusFileStatusDto),
          sx: { color: (g = i.palette) == null ? void 0 : g.textColor.primary, opacity: 0.75 }
        }
      ),
      /* @__PURE__ */ k.jsxs(fn, { children: [
        /* @__PURE__ */ k.jsx(Jt, { text: e.name, color: "primary", children: /* @__PURE__ */ k.jsx(mn, { children: e.name }) }),
        /* @__PURE__ */ k.jsx(pn, { children: Ir(e.createdAt, jr.DATE_TIME, !0) })
      ] })
    ] }),
    /* @__PURE__ */ k.jsx(_n, { children: o ? /* @__PURE__ */ k.jsx(Zt, { size: 20 }) : /* @__PURE__ */ k.jsxs(gn, { children: [
      /* @__PURE__ */ k.jsx(Jt, { text: "Download document", color: "primary", width: "auto", children: /* @__PURE__ */ k.jsx("div", { children: /* @__PURE__ */ k.jsx(
        "a",
        {
          href: `/api/documents/${e.id}/download`,
          target: "_blank",
          children: /* @__PURE__ */ k.jsx(
            Pe,
            {
              size: "small",
              iconName: "download",
              onClick: () => {
              },
              color: "primary",
              noExpand: !0
            }
          )
        }
      ) }) }),
      x && /* @__PURE__ */ k.jsx(Jt, { text: "Remove document", color: "primary", width: "auto", children: /* @__PURE__ */ k.jsx("div", { children: /* @__PURE__ */ k.jsx(
        Be,
        {
          onRemove: _,
          withConfirmation: !0,
          confirmationMessage: `Are you sure you want to delete document ${e.name}?`
        }
      ) }) })
    ] }) })
  ] });
}), bn = (T) => {
  const { data: o, onSelect: r, onRemove: h, processingIds: n, typeContainer: s } = T;
  return /* @__PURE__ */ k.jsx(rt, { container: !0, children: o.ids.map((i) => {
    const e = o.byId[i];
    return /* @__PURE__ */ k.jsx(Qt.Fragment, { children: /* @__PURE__ */ k.jsx(
      vn,
      {
        document: e,
        onSelect: r,
        onRemove: h,
        typeContainer: s,
        isProcessing: n.includes(i)
      }
    ) }, i);
  }) });
}, yn = _t.div`
  display: flex;
  flex-direction: column;
  /* margin: 0 24px; */
`, wn = _t.div`
  display: flex;
  background-color: #fff;
  justify-content: flex-end;
  & > button {
    margin-left: 10px;
  }
  padding-right: 16px;
`, or = (T) => {
  const { onCancel: o, afterCreate: r, createMethod: h } = T, [n, s] = vt(!1), [i, e] = vt([]), { enqueueSnackbar: l } = Wt(), _ = he(!0), x = [
    "txt",
    "pdf",
    "json",
    "csv",
    "xls",
    "xlsx",
    "doc",
    "docx",
    "ppt",
    "pptx"
  ], g = [
    "text/plain",
    "text/csv",
    "application/json",
    "application/pdf",
    "application/msword",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    "application/vnd.ms-powerpoint",
    "application/vnd.openxmlformats-officedocument.presentationml.presentation",
    "application/vnd.ms-excel",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
  ], b = Kt({
    primaryKey: "id",
    values: []
  }), u = ft(
    (d, v) => {
      d.preventDefault(), b.removeEntity(v);
    },
    []
  ), m = ft((d) => {
    d.forEach((v) => {
      const E = Le();
      b.createEntity({
        id: E,
        file: v
      });
    }), _.current ? e([]) : _.current = !0;
  }, []), c = ft((d) => {
    e(d), _.current = !1;
  }, []), f = ft(async () => {
    s(!0);
    try {
      const d = [];
      b.data.ids.forEach((v) => {
        const E = b.data.byId[v].file, C = new FormData();
        C.append("file", E), d.push(h(C));
      }), await Promise.all(d), l({
        message: "Documents uploaded successfully",
        variant: "success"
      });
    } catch {
      l({
        message: "Documents uploaded Failed",
        variant: "error"
      });
    }
    s(!1), r == null || r({});
  }, [b]);
  return /* @__PURE__ */ k.jsx(rt, { container: !0, p: 2, children: /* @__PURE__ */ k.jsx(ge, { elevated: !0, outlined: !0, children: /* @__PURE__ */ k.jsx(yn, { children: /* @__PURE__ */ k.jsxs(
    Oe,
    {
      items: Object.values(b.data.byId),
      primaryKey: "id",
      title: "Files to upload",
      headerText: "Upload your attachments",
      onRemove: u,
      itemComponent: (d) => /* @__PURE__ */ k.jsx(Ne, { file: d.file, disableIcon: !0 }),
      children: [
        /* @__PURE__ */ k.jsx(me, { onDrop: m, onDropReject: c }),
        /* @__PURE__ */ k.jsx(wn, { children: /* @__PURE__ */ k.jsx(
          bt,
          {
            name: "new-document-form-add-btn",
            variant: "contained",
            onClick: f,
            disabled: !b.data.ids.length || n,
            color: "success",
            startIcon: n ? /* @__PURE__ */ k.jsx(Zt, { size: 16 }) : /* @__PURE__ */ k.jsx(gt, { iconName: "submit" }),
            children: "Upload Files"
          }
        ) }),
        i && i.length > 0 && i.map(
          (d, v) => (() => {
            var Q, L, nt, G, M, A, j, V;
            const E = (d == null ? void 0 : d.errors) || [], C = E.some(
              (Y) => (Y == null ? void 0 : Y.code) === "file-invalid-type"
            ), S = E.some(
              (Y) => (Y == null ? void 0 : Y.code) === "file-too-large"
            ), P = ((Q = d == null ? void 0 : d.file) == null ? void 0 : Q.path) || "", R = ((L = d == null ? void 0 : d.file) == null ? void 0 : L.name) || P || "", D = ((nt = P.split(".").pop()) == null ? void 0 : nt.toLowerCase()) || "" || ((G = R.split(".").pop()) == null ? void 0 : G.toLowerCase()) || "", W = !D || !x.includes(D), X = ((M = d == null ? void 0 : d.file) == null ? void 0 : M.type) || "", w = !X || !g.includes(X), O = W || w;
            (A = E.find(
              (Y) => (Y == null ? void 0 : Y.code) === "file-invalid-type"
            )) == null || A.message;
            const a = (j = E.find(
              (Y) => (Y == null ? void 0 : Y.code) === "file-too-large"
            )) == null ? void 0 : j.message;
            let U = "";
            return C || O ? U = "has invalid file format" : S ? U = a || `exceed the maximum file size (${50 * 1024} KB) that this server supports` : (V = E[0]) != null && V.message ? U = E[0].message : U = "is not accepted", /* @__PURE__ */ k.jsxs(
              Er,
              {
                severity: "error",
                sx: {
                  marginY: "12px",
                  marginBottom: v === d.length - 1 ? "12px" : 0
                },
                children: [
                  d.file.path,
                  " ",
                  U
                ]
              },
              v
            );
          })()
        )
      ]
    }
  ) }) }) });
}, xn = {
  title: "Documents",
  modal: {
    header: {
      new: "New document",
      edit: "Document"
    }
  },
  addButtonText: "Add document",
  listConfigGetter: (T) => ({
    primaryKey: "uuid",
    methods: {
      read: {
        // method: () => getStudyDocuments(studyId),
        formatter: (o) => o.map((r) => {
          var h;
          return {
            ...r,
            uuid: r == null ? void 0 : r.id,
            label: (h = r == null ? void 0 : r.fileMetadata) == null ? void 0 : h.realName
          };
        })
      },
      delete: {
        method: (o) => {
        }
        // removeStudyDocument(studyId)(documentId),
      }
    }
  }),
  getApiMethods: () => ({
    primaryKey: "uuid",
    methods: {
      // create: {
      //   method: (document: any) => {
      //     return {};
      //   },
      // },
      read: {
        method: (T) => nr(T)
      }
      // delete: {
      //   method: (document: any) => {
      //     return {};
      //   },
      // },
    }
  })
}, En = (T) => {
  var C;
  const {
    path: o,
    addButtonText: r,
    modal: h,
    apiMethods: n,
    parentId: s,
    typeContainer: i,
    viewMode: e
  } = T, l = Mr();
  Ye();
  const [_, x] = vt(null), g = Ft(te), b = xn.getApiMethods(), u = 20, m = Kt({
    methods: n.methods,
    primaryKey: n.primaryKey
  });
  Lt(() => {
    m.getEntityList({ pageNumber: 0, pageSize: u });
  }, []);
  const c = ft(() => {
    g == null || g.openModal(
      () => /* @__PURE__ */ k.jsx(
        or,
        {
          afterCreate: d,
          onCancel: f,
          createMethod: n.methods.create.method
        }
      ),
      h.header.new,
      {
        onClose: f,
        width: "700px",
        closeOnClickOutside: !0
      }
    );
  }, []), f = ft(() => {
    x(null), g == null || g.closeModal();
  }, []), d = ft(async (S) => {
    m.getEntityList({ pageNumber: 0, pageSize: u }), f(), l(Ae(i, s));
  }, []), v = ft(async (S) => {
    await m.removeEntity(S, !0), m.getEntityList({ pageNumber: 0, pageSize: u }), l(Ae(i, s));
  }, []), E = ft(
    (S) => {
      g == null || g.openModal(
        () => /* @__PURE__ */ k.jsx(rt, { item: !0, xs: 12, p: 2, children: /* @__PURE__ */ k.jsx(
          Re,
          {
            data: S,
            downloadMethod: b.methods.read.method
          }
        ) }),
        "Document Viewer",
        {
          onClose: f,
          width: "calc(100% - 128px)",
          closeOnClickOutside: !0
        }
      );
    },
    [n.primaryKey]
  );
  return /* @__PURE__ */ k.jsxs(
    mr,
    {
      addButtonText: r,
      onAddClick: c,
      status: m.status,
      isEmpty: ((C = m.data.ids) == null ? void 0 : C.length) === 0,
      actions: m.actions,
      listName: "documents",
      emptyTableText: "0 documents",
      viewMode: e,
      loadingSkeleton: /* @__PURE__ */ k.jsx(rt, { container: !0, children: Array.from({ length: 9 }).map((S, P) => /* @__PURE__ */ k.jsxs(
        rt,
        {
          item: !0,
          xs: 12,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          py: 1,
          sx: { borderBottom: "1px solid #EEEEEE" },
          children: [
            /* @__PURE__ */ k.jsx(rt, { item: !0, width: "calc(100% - 80px)", children: /* @__PURE__ */ k.jsxs(rt, { container: !0, alignItems: "center", flexWrap: "nowrap", children: [
              /* @__PURE__ */ k.jsx(rt, { item: !0, pr: 1.5, children: /* @__PURE__ */ k.jsx(
                Ot,
                {
                  variant: "rounded",
                  sx: { width: 20, height: 20 }
                }
              ) }),
              /* @__PURE__ */ k.jsxs(rt, { item: !0, flexGrow: 1, minWidth: 0, children: [
                /* @__PURE__ */ k.jsx(
                  Ot,
                  {
                    variant: "rounded",
                    sx: {
                      height: 16,
                      width: P % 2 === 0 ? "88%" : "74%"
                    }
                  }
                ),
                /* @__PURE__ */ k.jsx(
                  Ot,
                  {
                    variant: "rounded",
                    sx: { height: 12, width: "36%", mt: 0.75 }
                  }
                )
              ] })
            ] }) }),
            /* @__PURE__ */ k.jsxs(
              rt,
              {
                item: !0,
                width: 56,
                display: "flex",
                justifyContent: "space-between",
                children: [
                  /* @__PURE__ */ k.jsx(Ot, { variant: "rounded", sx: { width: 14, height: 14 } }),
                  /* @__PURE__ */ k.jsx(Ot, { variant: "rounded", sx: { width: 14, height: 14 } })
                ]
              }
            )
          ]
        },
        `documents-loading-${P}`
      )) }),
      children: [
        /* @__PURE__ */ k.jsx(rt, { item: !0, xs: 12, children: /* @__PURE__ */ k.jsx(
          bn,
          {
            data: m.data,
            onSelect: E,
            onRemove: v,
            isLoading: m.isLoading,
            typeContainer: i,
            processingIds: m.processingIds
          }
        ) }),
        m.pageCount > 1 && /* @__PURE__ */ k.jsx(rt, { item: !0, xs: 12, display: "flex", justifyContent: "flex-end", mt: 1, children: /* @__PURE__ */ k.jsx(
          kr,
          {
            total: m.pageCount,
            page: (m.pageNumber ?? 0) + 1,
            onChange: (S, P) => {
              m.getEntityList({
                pageNumber: P - 1,
                pageSize: u
              });
            }
          }
        ) })
      ]
    }
  );
}, kn = (T) => {
  const { path: o, config: r, viewMode: h } = T, { typeContainer: n, parentId: s } = r, {
    name: i,
    addButtonText: e,
    title: l,
    redirectButtonText: _,
    modal: x,
    getApiMethods: g
  } = un, b = Pt(() => g(n, s), [s, n]);
  return /* @__PURE__ */ k.jsx(
    En,
    {
      addButtonText: e,
      title: l,
      redirectButtonText: _,
      name: i,
      apiMethods: b,
      path: o,
      modal: x,
      typeContainer: n,
      parentId: s,
      viewMode: h
    }
  );
}, Sn = (T) => {
  const {
    onChange: o,
    titleButton: r = "Upload file",
    initialTextFile: h,
    required: n = !1
  } = T, s = he(null), i = () => {
    s && s.current && (s.current.value = "");
  }, { enqueueSnackbar: e } = Wt(), [l, _] = vt(
    h ? {
      name: h
    } : null
  ), x = (g) => {
    const b = new FileReader();
    b.readAsText(g), b.onload = function() {
      try {
        const u = JSON.parse(b.result);
        o(u, g), _(g);
      } catch {
        e({
          message: "invalid JSON",
          variant: "error"
        });
      }
    }, b.onerror = function() {
      e({
        message: b.error,
        variant: "error"
      });
    };
  };
  return /* @__PURE__ */ k.jsx(rt, { container: !0, children: /* @__PURE__ */ k.jsxs(
    rt,
    {
      item: !0,
      xs: 12,
      p: 1.5,
      borderRadius: 1,
      bgcolor: "backgroundColor.main",
      container: !0,
      alignItems: "center",
      flexWrap: "nowrap",
      children: [
        /* @__PURE__ */ k.jsxs(rt, { item: !0, children: [
          /* @__PURE__ */ k.jsxs(
            bt,
            {
              variant: "contained",
              component: "label",
              color: "info",
              startIcon: /* @__PURE__ */ k.jsx(gt, { iconName: "upload" }),
              sx: { minWidth: 150 },
              children: [
                r,
                /* @__PURE__ */ k.jsx(
                  "input",
                  {
                    type: "file",
                    accept: "application/json",
                    ref: s,
                    onChange: (g) => {
                      const b = g.target.files[0];
                      x(b);
                    },
                    hidden: !0
                  }
                )
              ]
            }
          ),
          " "
        ] }),
        /* @__PURE__ */ k.jsx(rt, { item: !0, flexGrow: 1, ml: 2, display: "flex", alignItems: "center", children: l ? /* @__PURE__ */ k.jsxs(k.Fragment, { children: [
          /* @__PURE__ */ k.jsx(
            xt,
            {
              sx: { maxWidth: "calc(100% - 30px)", wordBreak: "break-all" },
              children: l == null ? void 0 : l.name
            }
          ),
          /* @__PURE__ */ k.jsx(
            Fe,
            {
              size: "small",
              color: "error",
              sx: { p: 0.5, ml: 1 },
              onClick: () => {
                _(null), o(null), i();
              },
              children: /* @__PURE__ */ k.jsx(gt, { iconName: "delete", sx: { fontSize: 14 } })
            }
          )
        ] }) : /* @__PURE__ */ k.jsxs(
          xt,
          {
            variant: "subtitle2",
            sx: { sup: { color: "error.main", fontSize: 12 } },
            children: [
              "Choose file to upload",
              n && /* @__PURE__ */ k.jsx("sup", { children: "*" })
            ]
          }
        ) })
      ]
    }
  ) });
}, Cn = (T) => {
  const { onChange: o, titleButton: r = "Upload file" } = T, { enqueueSnackbar: h } = Wt(), [n, s] = vt(null);
  return Rr(), /* @__PURE__ */ k.jsx(rt, { container: !0, children: /* @__PURE__ */ k.jsxs(
    rt,
    {
      item: !0,
      xs: 12,
      p: 1.5,
      border: "2px dashed",
      borderColor: "borderColor.main",
      container: !0,
      alignItems: "center",
      flexWrap: "nowrap",
      children: [
        /* @__PURE__ */ k.jsxs(rt, { item: !0, children: [
          /* @__PURE__ */ k.jsxs(
            bt,
            {
              variant: "contained",
              component: "label",
              color: "info",
              startIcon: /* @__PURE__ */ k.jsx(gt, { iconName: "upload" }),
              sx: { minWidth: 150 },
              children: [
                r,
                /* @__PURE__ */ k.jsx(
                  "input",
                  {
                    type: "file",
                    accept: "zip,application/octet-stream,application/zip,application/x-zip,application/x-zip-compressed",
                    onChange: (i) => {
                      const e = i.target.files[0];
                      new He().loadAsync(e).then((_) => {
                        s(e), o(_, e);
                      });
                    },
                    hidden: !0
                  }
                )
              ]
            }
          ),
          " "
        ] }),
        /* @__PURE__ */ k.jsx(rt, { item: !0, flexGrow: 1, ml: 2, display: "flex", alignItems: "center", children: n ? /* @__PURE__ */ k.jsxs(k.Fragment, { children: [
          /* @__PURE__ */ k.jsx(
            xt,
            {
              sx: { maxWidth: "calc(100% - 30px)", wordBreak: "break-all" },
              children: n == null ? void 0 : n.name
            }
          ),
          /* @__PURE__ */ k.jsx(
            Fe,
            {
              size: "small",
              color: "error",
              sx: { p: 0.5, ml: 1 },
              onClick: () => {
                s(void 0), o(void 0);
              },
              children: /* @__PURE__ */ k.jsx(gt, { iconName: "delete", sx: { fontSize: 14 } })
            }
          )
        ] }) : /* @__PURE__ */ k.jsx(
          xt,
          {
            variant: "subtitle2",
            sx: (i) => ({ color: i.palette.borderColor.main }),
            children: "Choose file to upload"
          }
        ) })
      ]
    }
  ) });
}, An = ({
  row: T
}) => {
  const o = ve(T.original);
  return /* @__PURE__ */ k.jsxs(ke, { display: "flex", alignItems: "center", children: [
    /* @__PURE__ */ k.jsx(
      gt,
      {
        iconName: re(o.extension),
        iconStatus: Ke(o.antivirusFileStatusDto),
        color: "info"
      }
    ),
    /* @__PURE__ */ k.jsx(
      ke,
      {
        ml: 1,
        fontWeight: "bold",
        sx: {
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap"
        },
        title: o.name,
        children: o.name
      }
    )
  ] });
}, ue = {
  primaryKey: "id",
  methods: (T) => ({
    create: {
      method: (o) => ln(T, o)
    },
    read: {
      method: () => on(T, {}),
      formatter: (o) => o.map((r) => {
        var h;
        return {
          ...r,
          label: (h = r == null ? void 0 : r.fileMetadata) == null ? void 0 : h.realName
        };
      })
    },
    delete: {
      method: (o) => oe(o.id)
    }
  })
}, In = (T) => /* @__PURE__ */ k.jsx("div", { onClick: (o) => o == null ? void 0 : o.stopPropagation(), children: /* @__PURE__ */ k.jsx("a", { href: `/api/documents/${T}/download`, target: "_blank", children: /* @__PURE__ */ k.jsx(
  vr,
  {
    iconName: "download",
    color: "default",
    noExpand: !0,
    size: "small",
    onClick: () => {
    }
  }
) }) }), jn = (T, o = !1) => [
  { header: "File", accessorKey: "label", cell: An },
  {
    header: "Author",
    accessorKey: "created",
    cell: pr
  },
  {
    header: "Email",
    accessorKey: "created.user.email"
  },
  {
    header: "Updated",
    accessorKey: "modified.timestamp",
    cell: gr
  },
  {
    header: "Size",
    accessorFn: (r) => {
      var h;
      return (h = r == null ? void 0 : r.fileMetadata) != null && h.length ? _e(r.fileMetadata.length) : "-";
    }
  },
  {
    header: "",
    id: "actions",
    accessorKey: "label",
    meta: { columnType: "action" },
    cell: (r) => {
      const h = r.row.original.actions, n = o || (h ? be(h)[Nr.DELETE] : !1);
      return /* @__PURE__ */ k.jsx(
        _r,
        {
          onRemove: n ? () => T(r.row.original) : void 0,
          withConfirmation: !0,
          children: In(r.row.original.id)
        }
      );
    }
  }
], Tn = ({
  parentId: T,
  onChange: o,
  canManageDocuments: r = !1
}) => {
  const h = Ft(te), n = Kt({
    methods: ue.methods(T),
    primaryKey: ue.primaryKey
  });
  Lt(() => {
    n.getEntityList();
  }, []);
  const s = ft(async (g) => {
    await n.removeEntity(g, !0), n.getEntityList(), o == null || o();
  }, []), i = () => {
    n.getEntityList(), h == null || h.closeModal(), o == null || o();
  }, e = ft(() => {
    h == null || h.openModal(
      () => /* @__PURE__ */ k.jsx(
        or,
        {
          afterCreate: i,
          onCancel: h == null ? void 0 : h.closeModal,
          createMethod: ue.methods(T).create.method
        }
      ),
      "Upload document",
      {
        onClose: h == null ? void 0 : h.closeModal,
        width: "700px",
        closeOnClickOutside: !0
      }
    );
  }, []), l = (g) => {
    h == null || h.openModal(
      () => /* @__PURE__ */ k.jsx(rt, { item: !0, xs: 12, p: 2, children: /* @__PURE__ */ k.jsx(Re, { data: g, downloadMethod: nr }) }),
      /* @__PURE__ */ k.jsx(xt, { fontSize: 20, children: g.name || "View document" }),
      {
        onClose: h == null ? void 0 : h.closeModal,
        width: "calc(100% - 128px)",
        closeOnClickOutside: !0
      }
    );
  }, _ = Pt(
    () => jn(s, r),
    [s, r]
  ), x = r || be(n == null ? void 0 : n.actions)[Ge.CREATE];
  return /* @__PURE__ */ k.jsx(
    rt,
    {
      container: !0,
      flexDirection: "column",
      flexGrow: 1,
      bgcolor: "backgroundColor.dark",
      px: 6,
      py: 2,
      children: /* @__PURE__ */ k.jsx(rt, { item: !0, xs: 12, children: /* @__PURE__ */ k.jsxs(ge, { elevated: !0, outlined: !0, children: [
        /* @__PURE__ */ k.jsx(rt, { item: !0, xs: 12, px: 2, children: /* @__PURE__ */ k.jsx(
          br,
          {
            title: "",
            dense: !0,
            customButtons: x && /* @__PURE__ */ k.jsx(
              bt,
              {
                color: "info",
                variant: "contained",
                startIcon: /* @__PURE__ */ k.jsx(gt, { iconName: "fileUpload" }),
                onClick: e,
                children: "Upload Files"
              }
            )
          }
        ) }),
        /* @__PURE__ */ k.jsx(rt, { item: !0, xs: 12, px: 2, pb: 1.5, children: /* @__PURE__ */ k.jsx(
          Sr,
          {
            loading: n.status === jt.IN_PROGRESS || n.status === jt.IN_PROGRESS_RELOAD,
            onRowClick: (g) => l(ve(g.original)),
            columns: _,
            data: Object.values(n.data.byId) || [],
            hideSettings: !0
          }
        ) })
      ] }) })
    }
  );
}, Dn = {
  title: "Documentation",
  description: "Guides, tutorials, and other documentation that helps understanding and using Prometheus platform."
}, zn = (T) => {
  const { documentationItems: o, status: r } = T, h = pe(), [n, s] = vt(5), i = () => {
    s(n + 5);
  }, e = () => {
    s(5);
  };
  return r === jt.INITIAL || r === jt.IN_PROGRESS ? /* @__PURE__ */ k.jsx(Ue, { children: /* @__PURE__ */ k.jsx(Zt, { size: 32 }) }) : /* @__PURE__ */ k.jsxs(rt, { container: !0, children: [
    /* @__PURE__ */ k.jsxs(yr, { children: [
      r === jt.SUCCESS && (o != null && o.length) ? o.slice(0, Math.min(o.length, n)).map((l) => {
        var x, g, b, u;
        const _ = Ze(l.fileMetadata.realName);
        return /* @__PURE__ */ k.jsxs(
          Ee,
          {
            className: "documentation-list-item",
            children: [
              /* @__PURE__ */ k.jsxs("div", { className: "list-item-section nowrap", children: [
                /* @__PURE__ */ k.jsx(
                  gt,
                  {
                    iconName: re(_),
                    sx: { color: (x = h.palette) == null ? void 0 : x.primary.main }
                  }
                ),
                /* @__PURE__ */ k.jsx(
                  "div",
                  {
                    className: "list-item-title",
                    title: l.fileMetadata.realName,
                    children: l.fileMetadata.realName
                  }
                )
              ] }),
              /* @__PURE__ */ k.jsxs("div", { className: "list-item-section", children: [
                ((g = l.mediaFileMetadata) == null ? void 0 : g.duration) && /* @__PURE__ */ k.jsx(
                  Se,
                  {
                    color: (b = h.palette) == null ? void 0 : b.black.light,
                    text: l.mediaFileMetadata.duration,
                    light: !0,
                    align: "center",
                    minWidth: 60
                  }
                ),
                /* @__PURE__ */ k.jsx(
                  Se,
                  {
                    color: (u = h.palette) == null ? void 0 : u.black.light,
                    text: _e(l.fileMetadata.length),
                    light: !0,
                    align: "center",
                    minWidth: 60
                  }
                ),
                /* @__PURE__ */ k.jsx(
                  Jt,
                  {
                    text: "Download document",
                    color: "primary",
                    width: "auto",
                    children: /* @__PURE__ */ k.jsx("div", { children: /* @__PURE__ */ k.jsx(
                      "a",
                      {
                        href: `/api/documents/${l.id}/download`,
                        target: "_blank",
                        children: /* @__PURE__ */ k.jsx(
                          Pe,
                          {
                            size: "small",
                            iconName: "download",
                            onClick: () => {
                            },
                            color: "primary",
                            noExpand: !0
                          }
                        )
                      }
                    ) })
                  }
                )
              ] })
            ]
          },
          l.id + "-document"
        );
      }) : /* @__PURE__ */ k.jsx(k.Fragment, {}),
      r === jt.ERROR && /* @__PURE__ */ k.jsx(Ee, { light: !0, children: /* @__PURE__ */ k.jsx(
        Cr,
        {
          noDataText: "Failed to load documents",
          addButtonText: ""
        }
      ) })
    ] }),
    (o == null ? void 0 : o.length) > 5 && o.length > n && /* @__PURE__ */ k.jsx(rt, { container: !0, justifyContent: "flex-end", mt: 2, children: /* @__PURE__ */ k.jsx(bt, { onClick: i, size: "small", variant: "text", color: "info", children: "Show more..." }) }),
    (o == null ? void 0 : o.length) > 5 && o.length <= n && /* @__PURE__ */ k.jsx(rt, { container: !0, justifyContent: "flex-end", mt: 2, children: /* @__PURE__ */ k.jsx(bt, { onClick: e, size: "small", variant: "text", color: "info", children: "Show less" }) })
  ] });
}, Mn = fe((T) => {
  var Q;
  const { name: o, path: r, config: h, viewMode: n } = T, { title: s, description: i } = Dn, {
    onClose: e,
    onChange: l,
    createMethod: _,
    freeUpload: x,
    acceptExt: g,
    textAvailableExt: b,
    localDownload: u,
    type: m,
    noDropzone: c,
    titleButton: f,
    initialTextFile: d,
    required: v,
    parentId: E,
    canManageDocuments: C
  } = h, P = (Q = Or((L) => L.user.data).moduleIds) == null ? void 0 : Q.includes("admin"), [R, N] = vt([]), { state: D, status: W } = o === "home-widget" ? Ar(ze) : { state: [], status: "" };
  Lt(() => {
    o === "home-widget" && N(D);
  }, [D]);
  const { openModal: X, closeModal: w } = Ft(te), O = (L) => {
    N(L);
  }, a = (L) => {
    w(), L !== !1 && ze().then((nt) => O(nt));
  }, U = () => {
    X(
      () => /* @__PURE__ */ k.jsx(
        cn,
        {
          documents: R || [],
          onClose: a,
          successCallback: O
        }
      ),
      "Manage Documentation",
      {
        closeOnClickOutside: !0,
        width: "700px",
        onClose: a
      }
    );
  };
  return /* @__PURE__ */ k.jsxs(Qt.Fragment, { children: [
    o === "widget-info" && /* @__PURE__ */ k.jsx(kn, { path: r, config: h, viewMode: n }),
    o === "upload-new-document" && /* @__PURE__ */ k.jsx(
      qe,
      {
        type: m,
        noDropzone: c,
        onCancel: e,
        afterCreate: l,
        freeUpload: x,
        createMethod: _,
        textAvailableExt: b,
        acceptExt: g,
        localDownload: u
      }
    ),
    o === "import-json-file" && /* @__PURE__ */ k.jsx(
      Sn,
      {
        titleButton: f,
        onChange: l,
        initialTextFile: d,
        required: v
      }
    ),
    o === "import-zip-file" && /* @__PURE__ */ k.jsx(Cn, { titleButton: f, onChange: l }),
    o === "documents-list" && /* @__PURE__ */ k.jsx(
      Tn,
      {
        parentId: E,
        onChange: l,
        canManageDocuments: C
      }
    ),
    o === "home-widget" && /* @__PURE__ */ k.jsx(
      wr,
      {
        title: s,
        description: i,
        iconName: "documentation",
        actions: /* @__PURE__ */ k.jsxs(k.Fragment, { children: [
          /* @__PURE__ */ k.jsx(
            bt,
            {
              onClick: () => {
                window.location.href = "/api/documents/download/library";
              },
              disabled: !(R != null && R.length),
              variant: "outlined",
              name: "download-all",
              children: "Download all"
            }
          ),
          P && /* @__PURE__ */ k.jsx(
            bt,
            {
              onClick: () => U(),
              variant: "outlined",
              name: "manage",
              sx: { ml: 1 },
              children: "Manage"
            }
          )
        ] }),
        children: /* @__PURE__ */ k.jsx(rt, { item: !0, xs: 12, container: !0, pt: 2, children: /* @__PURE__ */ k.jsx(
          zn,
          {
            documentationItems: R,
            status: W
          }
        ) })
      }
    )
  ] });
}), Me = {
  rowId: "id",
  loadingMessage: "Loading cohorts...",
  addButtonTitle: "Upload new document",
  tableTitle: "Documents",
  listInitialSort: null,
  createEntityModal: {
    name: "upload-document",
    title: "Upload new document",
    createMethodApi: (T, o) => We(
      T,
      o,
      ir,
      ar,
      sr
    )
  },
  createCrudMethod: (T, o) => zr(
    T,
    o,
    tr,
    oe,
    rr,
    er
  ),
  createFiltersPanel: (T, o) => Dr(
    T,
    o,
    Qr,
    en,
    tn
  ),
  createSortingMethod(T) {
    return Tr(T, {
      getSorting: sn,
      getSortingWorkspace: an
    });
  }
}, On = () => {
  Ye();
  const { openModal: T, closeModal: o } = Ft(te), r = Ft(
    lr
  ), h = Pt(() => r == null ? void 0 : r.config, []), { createEntityModal: n } = Me, s = Pt(() => n.createMethodApi(
    h.typeContainer,
    h.parentId
  ), [h.typeContainer, h.parentId]), i = () => {
    T(
      () => /* @__PURE__ */ k.jsx(
        qe,
        {
          createMethod: s == null ? void 0 : s.create,
          onCancel: o,
          afterCreate: (e) => {
            o();
          }
        }
      ),
      n.title,
      {
        closeOnClickOutside: !0,
        width: "700px",
        onClose: o
      }
    );
  };
  return /* @__PURE__ */ k.jsx(
    xr,
    {
      isImport: !1,
      onCreate: i,
      moduleConfig: r,
      listConfig: Me,
      allowDelete: !0
    }
  );
}, Nn = () => /* @__PURE__ */ k.jsx(k.Fragment, { children: "Entity" }), lr = hr(null), Bn = (T) => {
  const { path: o, title: r, name: h, storage: n, rootSettings: s, initStorage: i } = T, [e, l] = vt(s), [_, x] = vt(!0);
  return Lt(() => {
    s || l({
      rootPath: o,
      rootTitle: r
    }), x(!1);
  }, []), _ ? /* @__PURE__ */ k.jsx(Ue, { children: /* @__PURE__ */ k.jsx(Zt, { size: 32 }) }) : /* @__PURE__ */ k.jsx(lr.Provider, { value: { ...T, rootSettings: e }, children: /* @__PURE__ */ k.jsxs(Br, { children: [
    /* @__PURE__ */ k.jsx(Ce, { path: ":id/*", element: /* @__PURE__ */ k.jsx(Nn, {}) }),
    /* @__PURE__ */ k.jsx(Ce, { index: !0, element: /* @__PURE__ */ k.jsx(On, {}) })
  ] }) });
}, qn = (T) => {
  const { type: o } = T;
  return /* @__PURE__ */ k.jsxs(k.Fragment, { children: [
    !o && /* @__PURE__ */ k.jsx(Bn, { ...T }),
    o === "component" && /* @__PURE__ */ k.jsx(Mn, { ...T })
  ] });
};
export {
  qn as Documents
};
